//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class CaseloadClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadsForClinicianURL(){
        let url_ = this.baseUrl + "/api/Caseload/clinician";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of caseloads based of current staff id where staff is clinician.
     * @return A List of Caseloads.
     */
    getCaseloadsForClinician(): Promise<CaseloadViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/clinician";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloadsForClinician(_response);
        });
    }

    protected processGetCaseloadsForClinician(response: Response): Promise<CaseloadViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseloadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseloadViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadsForPatientURL(id: number, caseloadType: CaseloadType | undefined){
        let url_ = this.baseUrl + "/api/Caseload/patient/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (caseloadType === null)
            throw new Error("The parameter 'caseloadType' cannot be null.");
        else if (caseloadType !== undefined)
            url_ += "caseloadType=" + encodeURIComponent("" + caseloadType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of caseloads based of current patient id (can be just shared or personal if specified).
     * @param id The id of the patient.
     * @param caseloadType (optional) Type of caseload to return will be both if all caseloads need to return.
     * @return A List of Caseloads.
     */
    getCaseloadsForPatient(id: number, caseloadType: CaseloadType | undefined): Promise<CaseloadViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/patient/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (caseloadType === null)
            throw new Error("The parameter 'caseloadType' cannot be null.");
        else if (caseloadType !== undefined)
            url_ += "caseloadType=" + encodeURIComponent("" + caseloadType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloadsForPatient(_response);
        });
    }

    protected processGetCaseloadsForPatient(response: Response): Promise<CaseloadViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseloadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseloadViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadsForCurrentPatientURL(type: CaseloadType | undefined){
        let url_ = this.baseUrl + "/currentPatient?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of caseloads based on the current patient.
     * @param type (optional) The type of the caseload.
     * @return A List of Caseloads.
     */
    getCaseloadsForCurrentPatient(type: CaseloadType | undefined): Promise<CaseloadViewModel[]> {
        let url_ = this.baseUrl + "/currentPatient?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloadsForCurrentPatient(_response);
        });
    }

    protected processGetCaseloadsForCurrentPatient(response: Response): Promise<CaseloadViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseloadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseloadViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadsForAdministratorURL(includeArchived: boolean | undefined){
        let url_ = this.baseUrl + "/api/Caseload/administrator?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of caseloads based of current user's id where user is admin.
     * @param includeArchived (optional) If to return archivedw caseloads in get as well.
     * @return A List of Caseloads.
     */
    getCaseloadsForAdministrator(includeArchived: boolean | undefined): Promise<CaseloadViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/administrator?";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloadsForAdministrator(_response);
        });
    }

    protected processGetCaseloadsForAdministrator(response: Response): Promise<CaseloadViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseloadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseloadViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadsURL(){
        let url_ = this.baseUrl + "/api/Caseload/allCaseloads";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of top 10 caseloads alphabetically.
     * @return A List of Caseloads.
     */
    getCaseloads(): Promise<CaseloadViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/allCaseloads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloads(_response);
        });
    }

    protected processGetCaseloads(response: Response): Promise<CaseloadViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseloadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseloadViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadPatientsURL(id: number){
        let url_ = this.baseUrl + "/api/Caseload/{id}/patients";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of patients based on a caseload id.
     * @param id The id of the caseload.
     * @return A List of Patients.
     */
    getCaseloadPatients(id: number): Promise<PatientViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/{id}/patients";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloadPatients(_response);
        });
    }

    protected processGetCaseloadPatients(response: Response): Promise<PatientViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadCliniciansURL(id: number){
        let url_ = this.baseUrl + "/api/Caseload/{id}/clinicians";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of clinicians based on a caseload id.
     * @param id The id of the caseload.
     * @return A List of Clinicians.
     */
    getCaseloadClinicians(id: number): Promise<StaffViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/{id}/clinicians";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloadClinicians(_response);
        });
    }

    protected processGetCaseloadClinicians(response: Response): Promise<StaffViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StaffViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaffViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnairesForCaseloadURL(caseloadId: number | undefined){
        let url_ = this.baseUrl + "/api/Caseload/getQuestionnairesForCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of the requested questionnaire via caseloadId.
     * @param caseloadId (optional) Caseload id to search on.
     * @return The expected questionnaires.
     */
    getQuestionnairesForCaseload(caseloadId: number | undefined): Promise<QuestionnaireViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/getQuestionnairesForCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnairesForCaseload(_response);
        });
    }

    protected processGetQuestionnairesForCaseload(response: Response): Promise<QuestionnaireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetAllQuestionnairesLinkedToSharedCaseloadURL(caseloadId: number | undefined){
        let url_ = this.baseUrl + "/api/Caseload/getAllQuestionnairesLinkedToSharedCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of the requested caseloadId.
     * @param caseloadId (optional) Caseload id to search on.
     * @return List of questionnaires linked to caseload.
     */
    getAllQuestionnairesLinkedToSharedCaseload(caseloadId: number | undefined): Promise<QuestionnaireViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/getAllQuestionnairesLinkedToSharedCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllQuestionnairesLinkedToSharedCaseload(_response);
        });
    }

    protected processGetAllQuestionnairesLinkedToSharedCaseload(response: Response): Promise<QuestionnaireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getAssignQuestionnairesToCaseloadURL(caseloadId: number | undefined, questionnaireIds: number[] | null | undefined){
        let url_ = this.baseUrl + "/api/Caseload/assignQuestionnairesToCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (questionnaireIds !== undefined && questionnaireIds !== null)
            questionnaireIds && questionnaireIds.forEach(item => { url_ += "questionnaireIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Sets the links between questionnaires and a caseload.
     * @param caseloadId (optional) The caseload id to establish the link to.
     * @param questionnaireIds (optional) The questionnaires to assign.
     * @return Ok, if the updates were saved successfully.
     */
    assignQuestionnairesToCaseload(caseloadId: number | undefined, questionnaireIds: number[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Caseload/assignQuestionnairesToCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (questionnaireIds !== undefined && questionnaireIds !== null)
            questionnaireIds && questionnaireIds.forEach(item => { url_ += "questionnaireIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignQuestionnairesToCaseload(_response);
        });
    }

    protected processAssignQuestionnairesToCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getAssignCliniciansToCaseloadURL(caseloadId: number | undefined, staffIds: number[] | null | undefined){
        let url_ = this.baseUrl + "/api/Caseload/assignCliniciansToCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (staffIds !== undefined && staffIds !== null)
            staffIds && staffIds.forEach(item => { url_ += "staffIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Assigns clinicians to a caseload.
     * @param caseloadId (optional) Id of the caseload.
     * @param staffIds (optional) The ids of the clinician staff being assigned to caseload.
     * @return True if assigned, false otherwise.
     */
    assignCliniciansToCaseload(caseloadId: number | undefined, staffIds: number[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Caseload/assignCliniciansToCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (staffIds !== undefined && staffIds !== null)
            staffIds && staffIds.forEach(item => { url_ += "staffIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignCliniciansToCaseload(_response);
        });
    }

    protected processAssignCliniciansToCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateTeamCaseloadURL(caseload: CaseloadViewModel){
        let url_ = this.baseUrl + "/api/Caseload/createTeamCaseload";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Creates a new team caseload.
     * @param caseload Caseload to create.
     * @return Ok, if the creating was successful.
     */
    createTeamCaseload(caseload: CaseloadViewModel): Promise<QuestionnaireViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/createTeamCaseload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(caseload);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTeamCaseload(_response);
        });
    }

    protected processCreateTeamCaseload(response: Response): Promise<QuestionnaireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getEditTeamCaseloadURL(caseload: CaseloadViewModel){
        let url_ = this.baseUrl + "/api/Caseload/editTeamCaseload";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Edits an existing team caseload.
     * @param caseload Values of caseload to update to.
     * @return Ok, if the editing was successful.
     */
    editTeamCaseload(caseload: CaseloadViewModel): Promise<QuestionnaireViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/editTeamCaseload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(caseload);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditTeamCaseload(_response);
        });
    }

    protected processEditTeamCaseload(response: Response): Promise<QuestionnaireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getRemovePatientFromCaseloadURL(caseloadId: number | undefined, patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Caseload/removePatientFromCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Removes patient from caseload.
     * @param caseloadId (optional) Id of the caseload.
     * @param patientId (optional) The id of the patient being removed from the caseload.
     * @return True if removed, false otherwise.
     */
    removePatientFromCaseload(caseloadId: number | undefined, patientId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Caseload/removePatientFromCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemovePatientFromCaseload(_response);
        });
    }

    protected processRemovePatientFromCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getRemoveClinicianFromCaseloadURL(caseloadId: number | undefined, clinicianId: number | undefined){
        let url_ = this.baseUrl + "/api/Caseload/removeClinicianFromCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (clinicianId === null)
            throw new Error("The parameter 'clinicianId' cannot be null.");
        else if (clinicianId !== undefined)
            url_ += "clinicianId=" + encodeURIComponent("" + clinicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Removes clinician from caseload.
     * @param caseloadId (optional) Id of the caseload.
     * @param clinicianId (optional) The id of the clinician being removed from the caseload.
     * @return True if removed, false otherwise.
     */
    removeClinicianFromCaseload(caseloadId: number | undefined, clinicianId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Caseload/removeClinicianFromCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (clinicianId === null)
            throw new Error("The parameter 'clinicianId' cannot be null.");
        else if (clinicianId !== undefined)
            url_ += "clinicianId=" + encodeURIComponent("" + clinicianId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveClinicianFromCaseload(_response);
        });
    }

    protected processRemoveClinicianFromCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getAssignPatientsToCaseloadURL(caseloadId: number | undefined, patientIds: number[] | null | undefined){
        let url_ = this.baseUrl + "/api/Caseload/assignPatientsToCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (patientIds !== undefined && patientIds !== null)
            patientIds && patientIds.forEach(item => { url_ += "patientIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Assigns patients to a caseload.
     * @param caseloadId (optional) Id of the caseload.
     * @param patientIds (optional) The ids of the patients being assigned to caseload.
     * @return True if assigned, false otherwise.
     */
    assignPatientsToCaseload(caseloadId: number | undefined, patientIds: number[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Caseload/assignPatientsToCaseload?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (patientIds !== undefined && patientIds !== null)
            patientIds && patientIds.forEach(item => { url_ += "patientIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignPatientsToCaseload(_response);
        });
    }

    protected processAssignPatientsToCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCaseloadsByNameURL(nameQuery: string | null | undefined){
        let url_ = this.baseUrl + "/api/Caseload/getCaseloadsByName?";
        if (nameQuery !== undefined && nameQuery !== null)
            url_ += "nameQuery=" + encodeURIComponent("" + nameQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of all caseloads.
     * @param nameQuery (optional) Caseload name to search with.
     * @return A List of Caseloads with names matching searching criteria.
     */
    getCaseloadsByName(nameQuery: string | null | undefined): Promise<CaseloadViewModel[]> {
        let url_ = this.baseUrl + "/api/Caseload/getCaseloadsByName?";
        if (nameQuery !== undefined && nameQuery !== null)
            url_ += "nameQuery=" + encodeURIComponent("" + nameQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaseloadsByName(_response);
        });
    }

    protected processGetCaseloadsByName(response: Response): Promise<CaseloadViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseloadViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseloadViewModel[]>(null as any);
    }
}

export class DashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetLatestPatientTotalScoreURL(){
        let url_ = this.baseUrl + "/api/Dashboard/getLatestPatientTotalScore";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the latest patient total score for their assigned dashboard questionnaire.
     * @return The assigned questionnaire view model and the total score the patient got on that questionnaire.
     */
    getLatestPatientTotalScore(): Promise<ValueTupleOfQuestionnaireViewModelAndNullableDouble> {
        let url_ = this.baseUrl + "/api/Dashboard/getLatestPatientTotalScore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestPatientTotalScore(_response);
        });
    }

    protected processGetLatestPatientTotalScore(response: Response): Promise<ValueTupleOfQuestionnaireViewModelAndNullableDouble> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValueTupleOfQuestionnaireViewModelAndNullableDouble.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValueTupleOfQuestionnaireViewModelAndNullableDouble>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSetPatientDashboardQuestionnaireURL(patientId: number | undefined, questionnaireId: number | undefined){
        let url_ = this.baseUrl + "/api/Dashboard/setPatientDashboardQuestionnaire?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Sets the given patients dashboard questionnaire.
     * @param patientId (optional) The id of the patient.
     * @param questionnaireId (optional) The id of the questionnaire the patient will be assigned to.
     * @return True if successful else false.
     */
    setPatientDashboardQuestionnaire(patientId: number | undefined, questionnaireId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Dashboard/setPatientDashboardQuestionnaire?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetPatientDashboardQuestionnaire(_response);
        });
    }

    protected processSetPatientDashboardQuestionnaire(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DatasetClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateDatasetURL(dataset: DatasetViewModel){
        let url_ = this.baseUrl + "/api/Dataset/createDataset";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Create new Dataset.
     * @param dataset The Dataset to create.
     * @return Status result 400 if error, 200 if successful.
     */
    createDataset(dataset: DatasetViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Dataset/createDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataset);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDataset(_response);
        });
    }

    protected processCreateDataset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetTenantDatasetsURL(){
        let url_ = this.baseUrl + "/api/Dataset/getTenantDatasets";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets tenant specific Datasets.
     * @return Tenant specific DatasetViewModels.
     */
    getTenantDatasets(): Promise<DatasetViewModel[]> {
        let url_ = this.baseUrl + "/api/Dataset/getTenantDatasets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantDatasets(_response);
        });
    }

    protected processGetTenantDatasets(response: Response): Promise<DatasetViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatasetViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatasetViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateDatasetURL(dataset: DatasetViewModel){
        let url_ = this.baseUrl + "/api/Dataset/updateDataset";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates Dataset.
     * @param dataset The Dataset to update.
     * @return Status result 400 if error, 200 if successful.
     */
    updateDataset(dataset: DatasetViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Dataset/updateDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataset);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDataset(_response);
        });
    }

    protected processUpdateDataset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteDatasetURL(dataset: DatasetViewModel){
        let url_ = this.baseUrl + "/api/Dataset/deleteDataset";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes Dataset.
     * @param dataset The Dataset to delete.
     * @return Status result 400 if error, 200 if successful.
     */
    deleteDataset(dataset: DatasetViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Dataset/deleteDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataset);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDataset(_response);
        });
    }

    protected processDeleteDataset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateMeasurementURL(measurement: MeasurementViewModel){
        let url_ = this.baseUrl + "/api/Dataset/createMeasurement";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Create new Measurement.
     * @param measurement The Measurement to create.
     * @return Status result 400 if error, 200 if successful.
     */
    createMeasurement(measurement: MeasurementViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Dataset/createMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(measurement);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMeasurement(_response);
        });
    }

    protected processCreateMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetMeasurementsLinkedToDatasetURL(datasetId: number | undefined){
        let url_ = this.baseUrl + "/api/Dataset/getMeasurementsLinkedToDataset?";
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets Measurements linked to specified dataset.
     * @param datasetId (optional) Dataset id to get linked measurements.
     * @return MeasurementViewModels linked to dataset.
     */
    getMeasurementsLinkedToDataset(datasetId: number | undefined): Promise<MeasurementViewModel[]> {
        let url_ = this.baseUrl + "/api/Dataset/getMeasurementsLinkedToDataset?";
        if (datasetId === null)
            throw new Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeasurementsLinkedToDataset(_response);
        });
    }

    protected processGetMeasurementsLinkedToDataset(response: Response): Promise<MeasurementViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateMeasurementURL(measurement: MeasurementViewModel){
        let url_ = this.baseUrl + "/api/Dataset/updateMeasurement";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates Measurement.
     * @param measurement The Measurement to update.
     * @return Status result 400 if error, 200 if successful.
     */
    updateMeasurement(measurement: MeasurementViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Dataset/updateMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(measurement);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMeasurement(_response);
        });
    }

    protected processUpdateMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteMeasurementURL(measurement: MeasurementViewModel){
        let url_ = this.baseUrl + "/api/Dataset/deleteMeasurement";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes Measurement.
     * @param measurement The Measurement to delete.
     * @return Status result 400 if error, 200 if successful.
     */
    deleteMeasurement(measurement: MeasurementViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Dataset/deleteMeasurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(measurement);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMeasurement(_response);
        });
    }

    protected processDeleteMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EnumClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetMonitoringStatusDescriptionsURL(){
        let url_ = this.baseUrl + "/api/Enum/getMonitoringStatusDescriptions";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets monitoring status descriptions.
     * @return Returns monitoring status descriptions as dictionary of key being enum name and value being the enum description.
     */
    getMonitoringStatusDescriptions(): Promise<{ [key in keyof typeof MonitoringStatus]?: string; }> {
        let url_ = this.baseUrl + "/api/Enum/getMonitoringStatusDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMonitoringStatusDescriptions(_response);
        });
    }

    protected processGetMonitoringStatusDescriptions(response: Response): Promise<{ [key in keyof typeof MonitoringStatus]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof MonitoringStatus]?: string; }>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetGoalOwnerDescriptionsURL(){
        let url_ = this.baseUrl + "/api/Enum/getGoalOwnerDescriptions";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets goal owner descriptions.
     * @return Returns goal owner descriptions as dictionary of key being enum name and value being the enum description.
     */
    getGoalOwnerDescriptions(): Promise<{ [key in keyof typeof MonitoringStatus]?: string; }> {
        let url_ = this.baseUrl + "/api/Enum/getGoalOwnerDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGoalOwnerDescriptions(_response);
        });
    }

    protected processGetGoalOwnerDescriptions(response: Response): Promise<{ [key in keyof typeof MonitoringStatus]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof MonitoringStatus]?: string; }>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetRoleDescriptionsURL(){
        let url_ = this.baseUrl + "/api/Enum/getRoleDescriptions";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets role descriptions.
     * @return Returns role descriptions as dictionary of key being enum name and value being the enum description.
     */
    getRoleDescriptions(): Promise<{ [key in keyof typeof Role]?: string; }> {
        let url_ = this.baseUrl + "/api/Enum/getRoleDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoleDescriptions(_response);
        });
    }

    protected processGetRoleDescriptions(response: Response): Promise<{ [key in keyof typeof Role]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof Role]?: string; }>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetStaleDurationDescriptionsURL(){
        let url_ = this.baseUrl + "/api/Enum/getStaleDurationDescriptions";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets stale duration descriptions.
     * @return Returns stale duration descriptions as dictionary of key being enum name and value being the enum description.
     */
    getStaleDurationDescriptions(): Promise<{ [key in keyof typeof StaleDuration]?: string; }> {
        let url_ = this.baseUrl + "/api/Enum/getStaleDurationDescriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStaleDurationDescriptions(_response);
        });
    }

    protected processGetStaleDurationDescriptions(response: Response): Promise<{ [key in keyof typeof StaleDuration]?: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key in keyof typeof StaleDuration]?: string; }>(null as any);
    }
}

export class GoalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetGoalsForPatientURL(patientId: number){
        let url_ = this.baseUrl + "/api/Goal/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets goals for a patient.
     * @param patientId The id of the patient to get the goals for.
     * @return The goals that belong to a patient.
     */
    getGoalsForPatient(patientId: number): Promise<GoalViewModel[]> {
        let url_ = this.baseUrl + "/api/Goal/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGoalsForPatient(_response);
        });
    }

    protected processGetGoalsForPatient(response: Response): Promise<GoalViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetGoalsForCurrentPatientURL(){
        let url_ = this.baseUrl + "/api/Goal/currentPatientGoals";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets goals for this patient user.
     * @return The goals that belong to the patient.
     */
    getGoalsForCurrentPatient(): Promise<GoalViewModel[]> {
        let url_ = this.baseUrl + "/api/Goal/currentPatientGoals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGoalsForCurrentPatient(_response);
        });
    }

    protected processGetGoalsForCurrentPatient(response: Response): Promise<GoalViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnaireForTokensURL(tokens: string[] | null | undefined){
        let url_ = this.baseUrl + "/api/Goal/goalQuestionnaires?";
        if (tokens !== undefined && tokens !== null)
            tokens && tokens.forEach(item => { url_ += "tokens=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the questionnaire for the given tokens.
     * @param tokens (optional) The tokens to get the questionnaire for.
     * @return The goals questionnaire for the tokens.
     */
    getQuestionnaireForTokens(tokens: string[] | null | undefined): Promise<QuestionnaireViewModel> {
        let url_ = this.baseUrl + "/api/Goal/goalQuestionnaires?";
        if (tokens !== undefined && tokens !== null)
            tokens && tokens.forEach(item => { url_ += "tokens=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireForTokens(_response);
        });
    }

    protected processGetQuestionnaireForTokens(response: Response): Promise<QuestionnaireViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getRespondToGoalsQuestionnaireURL(response: GoalResponseViewModel, goalResponseId: number | null | undefined, tenantId: number | null | undefined, token: string | null | undefined){
        let url_ = this.baseUrl + "/api/Goal/respondToGoalsQuestionnaire?";
        if (goalResponseId !== undefined && goalResponseId !== null)
            url_ += "goalResponseId=" + encodeURIComponent("" + goalResponseId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Stores the goals questionnaire response.
     * @param response The response for the goals.
     * @param goalResponseId (optional) Id of the response to update. Will be null if not editing.
     * @param tenantId (optional) Tenant id in cases where this.User is not avaliable i.e. in prompt responses.
     * @param token (optional) The token for the response.
     * @return True if successful, false otherwise.
     */
    respondToGoalsQuestionnaire(response: GoalResponseViewModel, goalResponseId: number | null | undefined, tenantId: number | null | undefined, token: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Goal/respondToGoalsQuestionnaire?";
        if (goalResponseId !== undefined && goalResponseId !== null)
            url_ += "goalResponseId=" + encodeURIComponent("" + goalResponseId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRespondToGoalsQuestionnaire(_response);
        });
    }

    protected processRespondToGoalsQuestionnaire(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateGoalURL(goal: GoalViewModel){
        let url_ = this.baseUrl + "/api/Goal/create";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Creates a goal.
     * @param goal The GoalViewModel to create.
     * @return The created GoalViewModel.
     */
    createGoal(goal: GoalViewModel): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(goal);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateGoal(_response);
        });
    }

    protected processCreateGoal(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getPutGoalURL(goal: GoalViewModel){
        let url_ = this.baseUrl + "/api/Goal";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates a goal.
     * @param goal The GoalViewModel to update.
     * @return The updated GoalViewModel.
     */
    putGoal(goal: GoalViewModel): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(goal);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutGoal(_response);
        });
    }

    protected processPutGoal(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteGoalResponseURL(id: number | undefined, patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes a goal response.
     * @param id (optional) The id of the GoalResponse to delete.
     * @param patientId (optional) Patient id for checking if staff has link to patient.
     * @return True if successful, false otherwise.
     */
    deleteGoalResponse(id: number | undefined, patientId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Goal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteGoalResponse(_response);
        });
    }

    protected processDeleteGoalResponse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getArchiveGoalURL(goalId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/archive?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Archives a goal.
     * @param goalId (optional) The id of the GoalViewModel to archive.
     * @return True if successful, false otherwise.
     */
    archiveGoal(goalId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/archive?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveGoal(_response);
        });
    }

    protected processArchiveGoal(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getArchiveAllGoalsForUserURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/archiveall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Archive all goals for a user.
     * @param patientId (optional) The id of the patient to archive all GoalViewModels for.
     * @return True if successful, false otherwise.
     */
    archiveAllGoalsForUser(patientId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/archiveall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveAllGoalsForUser(_response);
        });
    }

    protected processArchiveAllGoalsForUser(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSuspendGoalURL(goalId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/suspend?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Suspends a goal.
     * @param goalId (optional) The id of the GoalViewModel to suspend.
     * @return True if successful, false otherwise.
     */
    suspendGoal(goalId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/suspend?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuspendGoal(_response);
        });
    }

    protected processSuspendGoal(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSuspendAllGoalsForUserURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/suspendall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Suspends all goals for a user.
     * @param patientId (optional) The id of the patient to suspend all GoalViewModels for.
     * @return True if successful, false otherwise.
     */
    suspendAllGoalsForUser(patientId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/suspendall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuspendAllGoalsForUser(_response);
        });
    }

    protected processSuspendAllGoalsForUser(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getResumeGoalURL(goalId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/resume?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Resumes a goal.
     * @param goalId (optional) The id of the GoalViewModel to resume.
     * @return True if successful, false otherwise.
     */
    resumeGoal(goalId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/resume?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResumeGoal(_response);
        });
    }

    protected processResumeGoal(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getResumeAllGoalsForUserURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/resumeall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Resumes all goals for a user.
     * @param patientId (optional) The id of the patient to resumes all GoalViewModels for.
     * @return True if successful, false otherwise.
     */
    resumeAllGoalsForUser(patientId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/resumeall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResumeAllGoalsForUser(_response);
        });
    }

    protected processResumeAllGoalsForUser(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCompleteGoalURL(goalId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/complete?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Completes a goal.
     * @param goalId (optional) The id of the GoalViewModel to complete.
     * @return True if successful, false otherwise.
     */
    completeGoal(goalId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/complete?";
        if (goalId === null)
            throw new Error("The parameter 'goalId' cannot be null.");
        else if (goalId !== undefined)
            url_ += "goalId=" + encodeURIComponent("" + goalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleteGoal(_response);
        });
    }

    protected processCompleteGoal(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCompleteAllGoalsForUserURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/completeall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Completes all goals for a user.
     * @param patientId (optional) The id of the patient to complete all GoalViewModels for.
     * @return True if successful, false otherwise.
     */
    completeAllGoalsForUser(patientId: number | undefined): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/completeall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleteAllGoalsForUser(_response);
        });
    }

    protected processCompleteAllGoalsForUser(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCompleteAllGoalsForCurrentUserURL(){
        let url_ = this.baseUrl + "/api/Goal/patientcompleteall";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Completes all goals for this patient user.
     * @return True if successful, false otherwise.
     */
    completeAllGoalsForCurrentUser(): Promise<GoalViewModel> {
        let url_ = this.baseUrl + "/api/Goal/patientcompleteall";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleteAllGoalsForCurrentUser(_response);
        });
    }

    protected processCompleteAllGoalsForCurrentUser(response: Response): Promise<GoalViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoalViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getEditResponseDateURL(dateToChange: Date | undefined, goalResponseId: number | undefined, patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/editResponseDate?";
        if (dateToChange === null)
            throw new Error("The parameter 'dateToChange' cannot be null.");
        else if (dateToChange !== undefined)
            url_ += "dateToChange=" + encodeURIComponent(dateToChange ? "" + dateToChange.toISOString() : "") + "&";
        if (goalResponseId === null)
            throw new Error("The parameter 'goalResponseId' cannot be null.");
        else if (goalResponseId !== undefined)
            url_ += "goalResponseId=" + encodeURIComponent("" + goalResponseId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates response date of goal response.
     * @param dateToChange (optional) Date to update to.
     * @param goalResponseId (optional) Goal reponse Id for changing date.
     * @param patientId (optional) Id of the patient that the goal response is against.
     * @return True if success, bad request otherwise.
     */
    editResponseDate(dateToChange: Date | undefined, goalResponseId: number | undefined, patientId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Goal/editResponseDate?";
        if (dateToChange === null)
            throw new Error("The parameter 'dateToChange' cannot be null.");
        else if (dateToChange !== undefined)
            url_ += "dateToChange=" + encodeURIComponent(dateToChange ? "" + dateToChange.toISOString() : "") + "&";
        if (goalResponseId === null)
            throw new Error("The parameter 'goalResponseId' cannot be null.");
        else if (goalResponseId !== undefined)
            url_ += "goalResponseId=" + encodeURIComponent("" + goalResponseId) + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditResponseDate(_response);
        });
    }

    protected processEditResponseDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUnarchiveGoalURL(id: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/unarchive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Unarchives a goal.
     * @param id (optional) The Goal to unarchive.
     * @return True if successful, false otherwise.
     */
    unarchiveGoal(id: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Goal/unarchive?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnarchiveGoal(_response);
        });
    }

    protected processUnarchiveGoal(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnaireGoalsURL(patientId: number | undefined, questionnaireId: number | undefined){
        let url_ = this.baseUrl + "/api/Goal/questionnaireGoals?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets questionnaire goals for a patient and questionnaire.
     * @param patientId (optional) Patient id goals are against.
     * @param questionnaireId (optional) Questionnaire id goals are against.
     * @return List of questionnaire goals against specified patient and questionnaire.
     */
    getQuestionnaireGoals(patientId: number | undefined, questionnaireId: number | undefined): Promise<GoalViewModel[]> {
        let url_ = this.baseUrl + "/api/Goal/questionnaireGoals?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireGoals(_response);
        });
    }

    protected processGetQuestionnaireGoals(response: Response): Promise<GoalViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GoalViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalViewModel[]>(null as any);
    }
}

export class GraphClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetSummaryGraphURL(fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Graph/getSummaryGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a summary graph for a patient.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @param patientId (optional) The id of the patient to get the data for.
     * @return The summary graph for the patient.
     */
    getSummaryGraph(fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined): Promise<LineGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getSummaryGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaryGraph(_response);
        });
    }

    protected processGetSummaryGraph(response: Response): Promise<LineGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LineGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineGraphDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentSummaryGraphURL(fromDate: Date | null | undefined, toDate: Date | null | undefined){
        let url_ = this.baseUrl + "/api/Graph/getCurrentSummaryGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a summary graph for this patient user.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @return The summary graph for this patient.
     */
    getCurrentSummaryGraph(fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<LineGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getCurrentSummaryGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentSummaryGraph(_response);
        });
    }

    protected processGetCurrentSummaryGraph(response: Response): Promise<LineGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LineGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineGraphDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetSymptomsGraphURL(fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Graph/getSymptomsGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a symptoms graph for a patient.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @param patientId (optional) The id of the patient to get the data for.
     * @return The symptoms graph for the patient.
     */
    getSymptomsGraph(fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined): Promise<SymptomsGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getSymptomsGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSymptomsGraph(_response);
        });
    }

    protected processGetSymptomsGraph(response: Response): Promise<SymptomsGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SymptomsGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SymptomsGraphDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentSymptomsGraphURL(fromDate: Date | null | undefined, toDate: Date | null | undefined){
        let url_ = this.baseUrl + "/api/Graph/getCurrentSymptomsGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a symptoms graph for this patient user.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @return The symptoms graph for the patient.
     */
    getCurrentSymptomsGraph(fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<SymptomsGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getCurrentSymptomsGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentSymptomsGraph(_response);
        });
    }

    protected processGetCurrentSymptomsGraph(response: Response): Promise<SymptomsGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SymptomsGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SymptomsGraphDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetGoalResponsesGraphURL(showCompletedGoals: boolean | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Graph/getGoalResponsesGraph?";
        if (showCompletedGoals === null)
            throw new Error("The parameter 'showCompletedGoals' cannot be null.");
        else if (showCompletedGoals !== undefined)
            url_ += "ShowCompletedGoals=" + encodeURIComponent("" + showCompletedGoals) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a goal responses graph for a patient.
     * @param showCompletedGoals (optional) Gets or sets a value indicating whether completed goals should be shown on the graph.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @param patientId (optional) The id of the patient to get the data for.
     * @return The goal responses graph for the patient.
     */
    getGoalResponsesGraph(showCompletedGoals: boolean | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined): Promise<LineGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getGoalResponsesGraph?";
        if (showCompletedGoals === null)
            throw new Error("The parameter 'showCompletedGoals' cannot be null.");
        else if (showCompletedGoals !== undefined)
            url_ += "ShowCompletedGoals=" + encodeURIComponent("" + showCompletedGoals) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGoalResponsesGraph(_response);
        });
    }

    protected processGetGoalResponsesGraph(response: Response): Promise<LineGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LineGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineGraphDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetMedicationGraphURL(fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Graph/getMedicationGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the medication graph for a patient.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @param patientId (optional) The id of the patient to get the data for.
     * @return The summary graph for the patient.
     */
    getMedicationGraph(fromDate: Date | null | undefined, toDate: Date | null | undefined, patientId: number | undefined): Promise<MedicationLineGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getMedicationGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedicationGraph(_response);
        });
    }

    protected processGetMedicationGraph(response: Response): Promise<MedicationLineGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationLineGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationLineGraphDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentPatientMedicationGraphURL(fromDate: Date | null | undefined, toDate: Date | null | undefined){
        let url_ = this.baseUrl + "/api/Graph/getCurrentPatientMedicationGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the current patients medication graph.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @return The summary graph for the current patient.
     */
    getCurrentPatientMedicationGraph(fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<MedicationLineGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getCurrentPatientMedicationGraph?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentPatientMedicationGraph(_response);
        });
    }

    protected processGetCurrentPatientMedicationGraph(response: Response): Promise<MedicationLineGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationLineGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationLineGraphDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentGoalResponsesGraphURL(showCompletedGoals: boolean | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined){
        let url_ = this.baseUrl + "/api/Graph/getCurrentGoalResponsesGraph?";
        if (showCompletedGoals === null)
            throw new Error("The parameter 'showCompletedGoals' cannot be null.");
        else if (showCompletedGoals !== undefined)
            url_ += "ShowCompletedGoals=" + encodeURIComponent("" + showCompletedGoals) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a goal responses graph for this patient user.
     * @param showCompletedGoals (optional) Gets or sets a value indicating whether completed goals should be shown on the graph.
     * @param fromDate (optional) Gets or sets the date to get data from.
     * @param toDate (optional) Gets or sets the data to get date up until.
     * @return The goal responses graph for the patient.
     */
    getCurrentGoalResponsesGraph(showCompletedGoals: boolean | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<LineGraphDataViewModel> {
        let url_ = this.baseUrl + "/api/Graph/getCurrentGoalResponsesGraph?";
        if (showCompletedGoals === null)
            throw new Error("The parameter 'showCompletedGoals' cannot be null.");
        else if (showCompletedGoals !== undefined)
            url_ += "ShowCompletedGoals=" + encodeURIComponent("" + showCompletedGoals) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentGoalResponsesGraph(_response);
        });
    }

    protected processGetCurrentGoalResponsesGraph(response: Response): Promise<LineGraphDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LineGraphDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LineGraphDataViewModel>(null as any);
    }
}

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCheckURL(){
        let url_ = this.baseUrl + "/api/check";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Returns 200 if service is alive.
     * @return A 200 if alive.
     */
    check(): Promise<void> {
        let url_ = this.baseUrl + "/api/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class IdentityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getIsAuthedURL(){
        let url_ = this.baseUrl + "/api/Identity/isAuthed";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the UserViewModel if the user is authed.
     * @return A User object.
     */
    isAuthed(): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/Identity/isAuthed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsAuthed(_response);
        });
    }

    protected processIsAuthed(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getAuthURL(redirectUrl: string | null | undefined){
        let url_ = this.baseUrl + "/api/Identity/auth?";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Redirects the user to requested page after auth.
     * @param redirectUrl (optional) Url that the user will be redirected to after login.
     * @return A redirect to the requested page.
     */
    auth(redirectUrl: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Identity/auth?";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuth(_response);
        });
    }

    protected processAuth(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getChangePasswordURL(){
        let url_ = this.baseUrl + "/api/Identity/changePassword";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Redirects the user to the Identity provider change password screen.
     */
    changePassword(): Promise<void> {
        let url_ = this.baseUrl + "/api/Identity/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getLogoutURL(){
        let url_ = this.baseUrl + "/api/Identity/logout";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Logs the user out.
     * @return Completed Task.
     */
    logout(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Identity/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getLogoutToRedirectLinkURL(redirectUrl: string | null | undefined){
        let url_ = this.baseUrl + "/api/Identity/logoutToRedirectLink?";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Logs out a user redirecting them to requested URL.
     * @param redirectUrl (optional) Requested url to be redirected to.
     * @return A redirect to the redirect URL logging out a user first.
     */
    logoutToRedirectLink(redirectUrl: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Identity/logoutToRedirectLink?";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogoutToRedirectLink(_response);
        });
    }

    protected processLogoutToRedirectLink(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getKeepAliveURL(){
        let url_ = this.baseUrl + "/api/Identity";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Empty api ping to keep session alive.
     * @return True.
     */
    keepAlive(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Identity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processKeepAlive(_response);
        });
    }

    protected processKeepAlive(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class MedicationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateMedicationURL(medication: MedicationViewModel){
        let url_ = this.baseUrl + "/api/Medication/createMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Create new Medication.
     * @param medication The Medication to create.
     * @return Status result 400 if error, 200 if successful.
     */
    createMedication(medication: MedicationViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Medication/createMedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMedication(_response);
        });
    }

    protected processCreateMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateMedicationCategoryURL(medicationCategory: MedicationCategoryViewModel){
        let url_ = this.baseUrl + "/api/Medication/createMedicationCategory";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Create new MedicationCategory.
     * @param medicationCategory The MedicationCategory to create.
     * @return Status result 400 if error, 200 if successful.
     */
    createMedicationCategory(medicationCategory: MedicationCategoryViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Medication/createMedicationCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationCategory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMedicationCategory(_response);
        });
    }

    protected processCreateMedicationCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetTenantMedicationCategoriesURL(){
        let url_ = this.baseUrl + "/api/Medication/getTenantMedicationCategories";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets tenant specific MedicationCategorys.
     * @return Tenant specific MedicationCategoryViewModels.
     */
    getTenantMedicationCategories(): Promise<MedicationCategoryViewModel[]> {
        let url_ = this.baseUrl + "/api/Medication/getTenantMedicationCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantMedicationCategories(_response);
        });
    }

    protected processGetTenantMedicationCategories(response: Response): Promise<MedicationCategoryViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicationCategoryViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationCategoryViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetMedicationsLinkedToMedicationCategoryURL(medicationCategoryId: number | undefined){
        let url_ = this.baseUrl + "/api/Medication/getMedicationsLinkedToMedicationCategory?";
        if (medicationCategoryId === null)
            throw new Error("The parameter 'medicationCategoryId' cannot be null.");
        else if (medicationCategoryId !== undefined)
            url_ += "medicationCategoryId=" + encodeURIComponent("" + medicationCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets Medications linked to specified medication category.
     * @param medicationCategoryId (optional) Medication category to get linked medications.
     * @return MedicationViewModels linked to medication category.
     */
    getMedicationsLinkedToMedicationCategory(medicationCategoryId: number | undefined): Promise<MedicationViewModel[]> {
        let url_ = this.baseUrl + "/api/Medication/getMedicationsLinkedToMedicationCategory?";
        if (medicationCategoryId === null)
            throw new Error("The parameter 'medicationCategoryId' cannot be null.");
        else if (medicationCategoryId !== undefined)
            url_ += "medicationCategoryId=" + encodeURIComponent("" + medicationCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedicationsLinkedToMedicationCategory(_response);
        });
    }

    protected processGetMedicationsLinkedToMedicationCategory(response: Response): Promise<MedicationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateMedicationURL(medication: MedicationViewModel){
        let url_ = this.baseUrl + "/api/Medication/updateMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates Medication.
     * @param medication The Medication to update.
     * @return Status result 400 if error, 200 if successful.
     */
    updateMedication(medication: MedicationViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Medication/updateMedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMedication(_response);
        });
    }

    protected processUpdateMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateMedicationCategoryURL(medicationCategory: MedicationCategoryViewModel){
        let url_ = this.baseUrl + "/api/Medication/updateMedicationCategory";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates MedicationCategory.
     * @param medicationCategory The MedicationCategory to update.
     * @return Status result 400 if error, 200 if successful.
     */
    updateMedicationCategory(medicationCategory: MedicationCategoryViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Medication/updateMedicationCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationCategory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMedicationCategory(_response);
        });
    }

    protected processUpdateMedicationCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteMedicationURL(medication: MedicationViewModel){
        let url_ = this.baseUrl + "/api/Medication/deleteMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes Medication.
     * @param medication The Medication to delete.
     * @return Status result 400 if error, 200 if successful.
     */
    deleteMedication(medication: MedicationViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Medication/deleteMedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMedication(_response);
        });
    }

    protected processDeleteMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteMedicationCategoryURL(medicationCategory: MedicationCategoryViewModel){
        let url_ = this.baseUrl + "/api/Medication/deleteMedicationCategory";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes MedicationCategory.
     * @param medicationCategory The MedicationCategory to delete.
     * @return Status result 400 if error, 200 if successful.
     */
    deleteMedicationCategory(medicationCategory: MedicationCategoryViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Medication/deleteMedicationCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medicationCategory);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMedicationCategory(_response);
        });
    }

    protected processDeleteMedicationCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetTenantMedicationsURL(){
        let url_ = this.baseUrl + "/api/Medication/getTenantMedications";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets tenant specific Medications.
     * @return Tenant specific MedicationViewModels.
     */
    getTenantMedications(): Promise<MedicationViewModel[]> {
        let url_ = this.baseUrl + "/api/Medication/getTenantMedications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantMedications(_response);
        });
    }

    protected processGetTenantMedications(response: Response): Promise<MedicationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetMedicationURL(medicationId: number | undefined){
        let url_ = this.baseUrl + "/api/Medication/getMedication?";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "medicationId=" + encodeURIComponent("" + medicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets specific Medication.
     * @param medicationId (optional) Id of the medication.
     * @return Tenant specific MedicationViewModels.
     */
    getMedication(medicationId: number | undefined): Promise<MedicationViewModel> {
        let url_ = this.baseUrl + "/api/Medication/getMedication?";
        if (medicationId === null)
            throw new Error("The parameter 'medicationId' cannot be null.");
        else if (medicationId !== undefined)
            url_ += "medicationId=" + encodeURIComponent("" + medicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedication(_response);
        });
    }

    protected processGetMedication(response: Response): Promise<MedicationViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicationViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicationViewModel>(null as any);
    }
}

export class PatientClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreatePatientURL(patient: PatientViewModel, caseloadIds: number[] | null | undefined){
        let url_ = this.baseUrl + "/api/Patient?";
        if (caseloadIds !== undefined && caseloadIds !== null)
            caseloadIds && caseloadIds.forEach(item => { url_ += "caseloadIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Creates a patient.
     * @param patient The PatientViewModel to create.
     * @param caseloadIds (optional) The list of ids of CaseloadViewModels to link the patient to.
     * @return The created PatientViewModel.
     */
    createPatient(patient: PatientViewModel, caseloadIds: number[] | null | undefined): Promise<PatientViewModel> {
        let url_ = this.baseUrl + "/api/Patient?";
        if (caseloadIds !== undefined && caseloadIds !== null)
            caseloadIds && caseloadIds.forEach(item => { url_ += "caseloadIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patient);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePatient(_response);
        });
    }

    protected processCreatePatient(response: Response): Promise<PatientViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateMessagingPreferencesURL(patientId: number | undefined, messagingPreferences: PreferredContact | undefined){
        let url_ = this.baseUrl + "/api/Patient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (messagingPreferences === null)
            throw new Error("The parameter 'messagingPreferences' cannot be null.");
        else if (messagingPreferences !== undefined)
            url_ += "messagingPreferences=" + encodeURIComponent("" + messagingPreferences) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates patient contact preference.
     * @param patientId (optional) Patient to update.
     * @param messagingPreferences (optional) New preferences, will be count of two for both.
     * @return True if updated bad status otherwise.
     */
    updateMessagingPreferences(patientId: number | undefined, messagingPreferences: PreferredContact | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Patient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (messagingPreferences === null)
            throw new Error("The parameter 'messagingPreferences' cannot be null.");
        else if (messagingPreferences !== undefined)
            url_ += "messagingPreferences=" + encodeURIComponent("" + messagingPreferences) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMessagingPreferences(_response);
        });
    }

    protected processUpdateMessagingPreferences(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getBatchCreatePatientsURL(file: FileParameter | null | undefined, caseloadIds: number[] | null | undefined){
        let url_ = this.baseUrl + "/api/Patient/batchCreate?";
        if (caseloadIds !== undefined && caseloadIds !== null)
            caseloadIds && caseloadIds.forEach(item => { url_ += "caseloadIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Batch creates patients from a csv file.
     * @param file (optional) The file that has been uploaded.
     * @param caseloadIds (optional) The list of ids of CaseloadViewModels to link the patient to.
     * @return The created PatientViewModel.
     */
    batchCreatePatients(file: FileParameter | null | undefined, caseloadIds: number[] | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Patient/batchCreate?";
        if (caseloadIds !== undefined && caseloadIds !== null)
            caseloadIds && caseloadIds.forEach(item => { url_ += "caseloadIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBatchCreatePatients(_response);
        });
    }

    protected processBatchCreatePatients(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Patient/patient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a PatientViewModel based on their true colours ID.
     * @param patientId (optional) The patient's ID.
     * @return A patient.
     */
    getPatient(patientId: number | undefined): Promise<PatientViewModel> {
        let url_ = this.baseUrl + "/api/Patient/patient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatient(_response);
        });
    }

    protected processGetPatient(response: Response): Promise<PatientViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentPatientURL(){
        let url_ = this.baseUrl + "/api/Patient/currentPatient";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the PatientViewModel for this patient user.
     * @return The patient.
     */
    getCurrentPatient(): Promise<PatientViewModel> {
        let url_ = this.baseUrl + "/api/Patient/currentPatient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentPatient(_response);
        });
    }

    protected processGetCurrentPatient(response: Response): Promise<PatientViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatientViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateDetailsURL(patient: PatientViewModel){
        let url_ = this.baseUrl + "/api/Patient/updateDetails";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates the details of a patient.
     * @param patient The PatientViewModel to update.
     * @return True if updated, false otherwise.
     */
    updateDetails(patient: PatientViewModel): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Patient/updateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patient);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDetails(_response);
        });
    }

    protected processUpdateDetails(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientTimelineURL(patientId: number | undefined, limitBy: number | undefined, offset: number | undefined){
        let url_ = this.baseUrl + "/api/Patient/getPatientTimeline?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a timeline for a patient.
     * @param patientId (optional) Patient Id.
     * @param limitBy (optional) Limits results by this amount.
     * @param offset (optional) Offset for the database query so not all the data is loaded on load more.
     * @return Timeline of the patient limited and total length of patient's timeline unlimited.
     */
    getPatientTimeline(patientId: number | undefined, limitBy: number | undefined, offset: number | undefined): Promise<PatientTimelineDataViewModel[]> {
        let url_ = this.baseUrl + "/api/Patient/getPatientTimeline?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatientTimeline(_response);
        });
    }

    protected processGetPatientTimeline(response: Response): Promise<PatientTimelineDataViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientTimelineDataViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientTimelineDataViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentPatientTimelineURL(limitBy: number | undefined, offset: number | undefined){
        let url_ = this.baseUrl + "/api/Patient/getCurrentPatientTimeline?";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the timeline for this patient user.
     * @param limitBy (optional) Limits results by this amount.
     * @param offset (optional) Offset for the database query so not all the data is loaded on load more.
     * @return Timeline of the patient limited and total length of patient's timeline unlimited.
     */
    getCurrentPatientTimeline(limitBy: number | undefined, offset: number | undefined): Promise<PatientTimelineDataViewModel[]> {
        let url_ = this.baseUrl + "/api/Patient/getCurrentPatientTimeline?";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentPatientTimeline(_response);
        });
    }

    protected processGetCurrentPatientTimeline(response: Response): Promise<PatientTimelineDataViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientTimelineDataViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientTimelineDataViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientTimelineCountURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Patient/getPatientTimelineCount?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a total timeline count for a patient.
     * @param patientId (optional) Patient Id.
     * @return Total count of timeline for a patient.
     */
    getPatientTimelineCount(patientId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Patient/getPatientTimelineCount?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatientTimelineCount(_response);
        });
    }

    protected processGetPatientTimelineCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentPatientTimelineCountURL(){
        let url_ = this.baseUrl + "/api/Patient/getCurrentPatientTimelineCount";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a total timeline count for this patient user.
     * @return Total count of timeline for the patient.
     */
    getCurrentPatientTimelineCount(): Promise<number> {
        let url_ = this.baseUrl + "/api/Patient/getCurrentPatientTimelineCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentPatientTimelineCount(_response);
        });
    }

    protected processGetCurrentPatientTimelineCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getFilterPatientTimelineURL(patientId: number | undefined, searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined, limitBy: number | undefined, offset: number | undefined){
        let url_ = this.baseUrl + "/api/Patient/filterPatientTimeline?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a filtered patient timeline with specified parameters.
     * @param patientId (optional) Id of the patient that timeline is to be filtered.
     * @param searchTerm (optional) Search term string for searching questionnaire name or goal question.
     * @param dateRangeStart (optional) Start date of the filtering.
     * @param dateRangeEnd (optional) End date of the filtering, will exclude this date.
     * @param timelinecardType (optional) Type of timeline card to filter on.
     * @param limitBy (optional) Limit the database search by.
     * @param offset (optional) Offset for the database query so not all the data is loaded on load more.
     * @return Patient timeline filtered to the request.
     */
    filterPatientTimeline(patientId: number | undefined, searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined, limitBy: number | undefined, offset: number | undefined): Promise<PatientTimelineDataViewModel[]> {
        let url_ = this.baseUrl + "/api/Patient/filterPatientTimeline?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilterPatientTimeline(_response);
        });
    }

    protected processFilterPatientTimeline(response: Response): Promise<PatientTimelineDataViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientTimelineDataViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientTimelineDataViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getFilterCurrentPatientTimelineURL(searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined, limitBy: number | undefined, offset: number | undefined){
        let url_ = this.baseUrl + "/api/Patient/filterCurrentPatientTimeline?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a filtered timeline for this patient user with specified parameters.
     * @param searchTerm (optional) Search term string for searching questionnaire name or goal question.
     * @param dateRangeStart (optional) Start date of the filtering.
     * @param dateRangeEnd (optional) End date of the filtering, will exclude this date.
     * @param timelinecardType (optional) Type of timeline card to filter on.
     * @param limitBy (optional) Limit the database search by.
     * @param offset (optional) Offset for the database query so not all the data is loaded on load more.
     * @return Patient timeline filtered to the request.
     */
    filterCurrentPatientTimeline(searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined, limitBy: number | undefined, offset: number | undefined): Promise<PatientTimelineDataViewModel[]> {
        let url_ = this.baseUrl + "/api/Patient/filterCurrentPatientTimeline?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        if (limitBy === null)
            throw new Error("The parameter 'limitBy' cannot be null.");
        else if (limitBy !== undefined)
            url_ += "limitBy=" + encodeURIComponent("" + limitBy) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFilterCurrentPatientTimeline(_response);
        });
    }

    protected processFilterCurrentPatientTimeline(response: Response): Promise<PatientTimelineDataViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientTimelineDataViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientTimelineDataViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetFilteredPatientTimelineCountURL(patientId: number | undefined, searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined){
        let url_ = this.baseUrl + "/api/Patient/getFilteredPatientTimelineCount?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the total count of the filtered timeline with params specified.
     * @param patientId (optional) Id of the patient that timeline is to be filtered.
     * @param searchTerm (optional) Search term string for searching questionnaire name or goal question.
     * @param dateRangeStart (optional) Start date of the filtering.
     * @param dateRangeEnd (optional) End date of the filtering, will exclude this date.
     * @param timelinecardType (optional) Type of timeline card to filter on.
     * @return Total count of the filtered timeline.
     */
    getFilteredPatientTimelineCount(patientId: number | undefined, searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Patient/getFilteredPatientTimelineCount?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredPatientTimelineCount(_response);
        });
    }

    protected processGetFilteredPatientTimelineCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetFilteredCurrentPatientTimelineCountURL(searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined){
        let url_ = this.baseUrl + "/api/Patient/getFilteredCurrentPatientTimelineCount?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the total count of the filtered timeline for this patient user with params specified.
     * @param searchTerm (optional) Search term string for searching questionnaire name or goal question.
     * @param dateRangeStart (optional) Start date of the filtering.
     * @param dateRangeEnd (optional) End date of the filtering, will exclude this date.
     * @param timelinecardType (optional) Type of timeline card to filter on.
     * @return Total count of the filtered timeline.
     */
    getFilteredCurrentPatientTimelineCount(searchTerm: string | null | undefined, dateRangeStart: string | null | undefined, dateRangeEnd: string | null | undefined, timelinecardType: TimelineCardType | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Patient/getFilteredCurrentPatientTimelineCount?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (dateRangeStart !== undefined && dateRangeStart !== null)
            url_ += "dateRangeStart=" + encodeURIComponent("" + dateRangeStart) + "&";
        if (dateRangeEnd !== undefined && dateRangeEnd !== null)
            url_ += "dateRangeEnd=" + encodeURIComponent("" + dateRangeEnd) + "&";
        if (timelinecardType === null)
            throw new Error("The parameter 'timelinecardType' cannot be null.");
        else if (timelinecardType !== undefined)
            url_ += "timelinecardType=" + encodeURIComponent("" + timelinecardType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFilteredCurrentPatientTimelineCount(_response);
        });
    }

    protected processGetFilteredCurrentPatientTimelineCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getAssignCaseloadsToPatientURL(patientId: number | undefined, caseloadIds: number[] | null | undefined){
        let url_ = this.baseUrl + "/api/Patient/assignCaseloads?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (caseloadIds !== undefined && caseloadIds !== null)
            caseloadIds && caseloadIds.forEach(item => { url_ += "caseloadIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Assigns caseloads to patient.
     * @param patientId (optional) Id of the patient.
     * @param caseloadIds (optional) The ids of the caseloads linked to patient.
     * @return True if assigned, false otherwise.
     */
    assignCaseloadsToPatient(patientId: number | undefined, caseloadIds: number[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Patient/assignCaseloads?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        if (caseloadIds !== undefined && caseloadIds !== null)
            caseloadIds && caseloadIds.forEach(item => { url_ += "caseloadIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignCaseloadsToPatient(_response);
        });
    }

    protected processAssignCaseloadsToPatient(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientsURL(){
        let url_ = this.baseUrl + "/api/Patient/getPatients";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets all active patients.
     * @return All the active patients as an Ok result.
     */
    getPatients(): Promise<PatientViewModel[]> {
        let url_ = this.baseUrl + "/api/Patient/getPatients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatients(_response);
        });
    }

    protected processGetPatients(response: Response): Promise<PatientViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSearchPatientByNameURL(searchCriteria: string | null | undefined){
        let url_ = this.baseUrl + "/api/Patient/searchPatientByName?";
        if (searchCriteria !== undefined && searchCriteria !== null)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets patients based on searched name limited by 20.
     * @param searchCriteria (optional) The search criteria.
     * @return List of patients with matching search criteria.
     */
    searchPatientByName(searchCriteria: string | null | undefined): Promise<PatientViewModel[]> {
        let url_ = this.baseUrl + "/api/Patient/searchPatientByName?";
        if (searchCriteria !== undefined && searchCriteria !== null)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchPatientByName(_response);
        });
    }

    protected processSearchPatientByName(response: Response): Promise<PatientViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetLastPatientDataInputDateURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Patient/getLastPatientDataInputDate?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the patient's last input date.
     * @param patientId (optional) Patient to check.
     * @return Date of last input.
     */
    getLastPatientDataInputDate(patientId: number | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/Patient/getLastPatientDataInputDate?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLastPatientDataInputDate(_response);
        });
    }

    protected processGetLastPatientDataInputDate(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? new Date(resultData200.toString()) : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(null as any);
    }
}

export class PatientDatasetClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreatePatientDatasetURL(patientDataset: PatientDatasetViewModel){
        let url_ = this.baseUrl + "/api/PatientDataset/createPatientDataset";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Create new PatientDataset.
     * @param patientDataset The PatientDataset to create.
     * @return Status result 400 if error, 200 if successful.
     */
    createPatientDataset(patientDataset: PatientDatasetViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/PatientDataset/createPatientDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientDataset);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePatientDataset(_response);
        });
    }

    protected processCreatePatientDataset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdatePatientDatasetURL(patientDataset: PatientDatasetViewModel){
        let url_ = this.baseUrl + "/api/PatientDataset/updatePatientDataset";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates PatientDataset.
     * @param patientDataset The PatientDataset to update.
     * @return Status result 400 if error, 200 if successful.
     */
    updatePatientDataset(patientDataset: PatientDatasetViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/PatientDataset/updatePatientDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientDataset);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePatientDataset(_response);
        });
    }

    protected processUpdatePatientDataset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientDatasetLinkedToPatientURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/PatientDataset/getPatientDatasetLinkedToPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets patient specific PatientDatasets.
     * @param patientId (optional) Specified patient id.
     * @return Patient specific PatientDatasetViewModels.
     */
    getPatientDatasetLinkedToPatient(patientId: number | undefined): Promise<PatientDatasetViewModel[]> {
        let url_ = this.baseUrl + "/api/PatientDataset/getPatientDatasetLinkedToPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatientDatasetLinkedToPatient(_response);
        });
    }

    protected processGetPatientDatasetLinkedToPatient(response: Response): Promise<PatientDatasetViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientDatasetViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientDatasetViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeletePatientDatasetURL(patientDataset: PatientDatasetViewModel){
        let url_ = this.baseUrl + "/api/PatientDataset/deletePatientDataset";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes PatientDataset.
     * @param patientDataset The PatientDataset to delete.
     * @return Status result 400 if error, 200 if successful.
     */
    deletePatientDataset(patientDataset: PatientDatasetViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/PatientDataset/deletePatientDataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientDataset);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePatientDataset(_response);
        });
    }

    protected processDeletePatientDataset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PatientMedicationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreatePatientMedicationURL(patientMedication: PatientMedicationViewModel){
        let url_ = this.baseUrl + "/api/PatientMedication/createPatientMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Create new PatientMedication.
     * @param patientMedication The PatientMedication to create.
     * @return Status result 400 if error, 200 if successful.
     */
    createPatientMedication(patientMedication: PatientMedicationViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/PatientMedication/createPatientMedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientMedication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePatientMedication(_response);
        });
    }

    protected processCreatePatientMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdatePatientMedicationURL(patientMedication: PatientMedicationViewModel){
        let url_ = this.baseUrl + "/api/PatientMedication/updatePatientMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates PatientMedication.
     * @param patientMedication The PatientMedication to update.
     * @return Status result 400 if error, 200 if successful.
     */
    updatePatientMedication(patientMedication: PatientMedicationViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/PatientMedication/updatePatientMedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientMedication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePatientMedication(_response);
        });
    }

    protected processUpdatePatientMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientMedicationLinkedToPatientURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/PatientMedication/getPatientMedicationLinkedToPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets patient specific PatientMedications.
     * @param patientId (optional) Specified patient id.
     * @return Patient specific PatientMedicationViewModels.
     */
    getPatientMedicationLinkedToPatient(patientId: number | undefined): Promise<PatientMedicationViewModel[]> {
        let url_ = this.baseUrl + "/api/PatientMedication/getPatientMedicationLinkedToPatient?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatientMedicationLinkedToPatient(_response);
        });
    }

    protected processGetPatientMedicationLinkedToPatient(response: Response): Promise<PatientMedicationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMedicationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientMedicationViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientMedicationLinkedToCurrentPatientURL(){
        let url_ = this.baseUrl + "/api/PatientMedication/getPatientMedicationLinkedToCurrentPatient";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets patient specific PatientMedications for this user.
     * @return Patient specific PatientMedicationViewModels.
     */
    getPatientMedicationLinkedToCurrentPatient(): Promise<PatientMedicationViewModel[]> {
        let url_ = this.baseUrl + "/api/PatientMedication/getPatientMedicationLinkedToCurrentPatient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatientMedicationLinkedToCurrentPatient(_response);
        });
    }

    protected processGetPatientMedicationLinkedToCurrentPatient(response: Response): Promise<PatientMedicationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientMedicationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientMedicationViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeletePatientMedicationURL(patientMedication: PatientMedicationViewModel){
        let url_ = this.baseUrl + "/api/PatientMedication/deletePatientMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes PatientMedication.
     * @param patientMedication The PatientMedication to delete.
     * @return Status result 400 if error, 200 if successful.
     */
    deletePatientMedication(patientMedication: PatientMedicationViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/PatientMedication/deletePatientMedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientMedication);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePatientMedication(_response);
        });
    }

    protected processDeletePatientMedication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getBatchCreateMedicationURL(file: FileParameter | null | undefined){
        let url_ = this.baseUrl + "/api/PatientMedication/batchCreateMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Batch creates patient medication from a csv file.
     * @param file (optional) The file that has been uploaded.
     * @return The created MedicationViewModel.
     */
    batchCreateMedication(file: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/PatientMedication/batchCreateMedication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBatchCreateMedication(_response);
        });
    }

    protected processBatchCreateMedication(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PatientNoteClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreatePatientNoteURL(patientNote: PatientNoteViewModel){
        let url_ = this.baseUrl + "/api/PatientNote";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Creates a patient note with specified information.
     * @param patientNote The patient note to create.
     * @return Ok result if created, bad request otherwise.
     */
    createPatientNote(patientNote: PatientNoteViewModel): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PatientNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientNote);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePatientNote(_response);
        });
    }

    protected processCreatePatientNote(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetPatientNotesURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/PatientNote/getPatientNotes?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a specific patient's notes.
     * @param patientId (optional) The id of the patient.
     * @return The patient notes.
     */
    getPatientNotes(patientId: number | undefined): Promise<PatientNoteViewModel[]> {
        let url_ = this.baseUrl + "/api/PatientNote/getPatientNotes?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPatientNotes(_response);
        });
    }

    protected processGetPatientNotes(response: Response): Promise<PatientNoteViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientNoteViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientNoteViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentPatientNotesURL(){
        let url_ = this.baseUrl + "/api/PatientNote/getCurrentPatientNotes";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets this patient's notes.
     * @return The patient notes.
     */
    getCurrentPatientNotes(): Promise<PatientNoteViewModel[]> {
        let url_ = this.baseUrl + "/api/PatientNote/getCurrentPatientNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentPatientNotes(_response);
        });
    }

    protected processGetCurrentPatientNotes(response: Response): Promise<PatientNoteViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientNoteViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientNoteViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeletePatientNoteURL(patientNode: PatientNoteViewModel){
        let url_ = this.baseUrl + "/api/PatientNote/deletePatientNote";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes a patient note.
     * @param patientNode The patient note to delete.
     * @return Ok result if deleted bad request otherwise.
     */
    deletePatientNote(patientNode: PatientNoteViewModel): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PatientNote/deletePatientNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientNode);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePatientNote(_response);
        });
    }

    protected processDeletePatientNote(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getEditPatientNoteURL(patientNote: PatientNoteViewModel){
        let url_ = this.baseUrl + "/api/PatientNote/editPatientNote";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Edits a patient note.
     * @param patientNote Edited patient note.
     * @return Ok result if edited bad request otherwise.
     */
    editPatientNote(patientNote: PatientNoteViewModel): Promise<boolean> {
        let url_ = this.baseUrl + "/api/PatientNote/editPatientNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patientNote);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditPatientNote(_response);
        });
    }

    protected processEditPatientNote(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class QuestionnaireClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getPrepareQuestionnaireResponsesURL(model: QuestionnaireSetViewModel){
        let url_ = this.baseUrl + "/api/Questionnaire/Responses";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of the tokens needed for GetQuestionnaireViaToken.
     * @param model the questionnaire set model.
     * @return The expected questionnaires.
     */
    prepareQuestionnaireResponses(model: QuestionnaireSetViewModel): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/Responses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPrepareQuestionnaireResponses(_response);
        });
    }

    protected processPrepareQuestionnaireResponses(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnaireViaTokenURL(token: string | null | undefined, editing: boolean | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/getViaToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (editing === null)
            throw new Error("The parameter 'editing' cannot be null.");
        else if (editing !== undefined)
            url_ += "editing=" + encodeURIComponent("" + editing) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of the requested questionnaire via token.
     * @param token (optional) the questionnaire tokens.
     * @param editing (optional) If questionnaire response is being edited. False by default.
     * @return The expected questionnaire.
     */
    getQuestionnaireViaToken(token: string | null | undefined, editing: boolean | undefined): Promise<QuestionnaireViewModel> {
        let url_ = this.baseUrl + "/api/Questionnaire/getViaToken?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (editing === null)
            throw new Error("The parameter 'editing' cannot be null.");
        else if (editing !== undefined)
            url_ += "editing=" + encodeURIComponent("" + editing) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireViaToken(_response);
        });
    }

    protected processGetQuestionnaireViaToken(response: Response): Promise<QuestionnaireViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetLatestQuestionnaireVersionURL(questionnaireId: number | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/getLatestVersion?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of the latest questionnaire version.
     * @param questionnaireId (optional) the questionnaire id.
     * @return Latest version of the expected questionnaire.
     */
    getLatestQuestionnaireVersion(questionnaireId: number | undefined): Promise<QuestionnaireViewModel> {
        let url_ = this.baseUrl + "/api/Questionnaire/getLatestVersion?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestQuestionnaireVersion(_response);
        });
    }

    protected processGetLatestQuestionnaireVersion(response: Response): Promise<QuestionnaireViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnaireViaVersionURL(questionnaireId: number | undefined, version: number | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/getViaVersion?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of the requested questionnaire version.
     * @param questionnaireId (optional) the questionnaire id.
     * @param version (optional) the questionnaire version.
     * @return The expected questionnaire.
     */
    getQuestionnaireViaVersion(questionnaireId: number | undefined, version: number | undefined): Promise<QuestionnaireViewModel> {
        let url_ = this.baseUrl + "/api/Questionnaire/getViaVersion?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireViaVersion(_response);
        });
    }

    protected processGetQuestionnaireViaVersion(response: Response): Promise<QuestionnaireViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnaireScoreFromResponseURL(responses: string | null | undefined, questionnaireId: number | undefined, version: number | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/getScoreViaResponse?";
        if (responses !== undefined && responses !== null)
            url_ += "responses=" + encodeURIComponent("" + responses) + "&";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 from a response.
     * @param responses (optional) the responses.
     * @param questionnaireId (optional) the questionnaire id.
     * @param version (optional) the questionnaire version.
     * @return The Scores.
     */
    getQuestionnaireScoreFromResponse(responses: string | null | undefined, questionnaireId: number | undefined, version: number | undefined): Promise<QuestionnaireResponseScoreViewModel> {
        let url_ = this.baseUrl + "/api/Questionnaire/getScoreViaResponse?";
        if (responses !== undefined && responses !== null)
            url_ += "responses=" + encodeURIComponent("" + responses) + "&";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireScoreFromResponse(_response);
        });
    }

    protected processGetQuestionnaireScoreFromResponse(response: Response): Promise<QuestionnaireResponseScoreViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireResponseScoreViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireResponseScoreViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSubmitQuestionnaireResponseURL(token: string | null | undefined, responses: QuestionnaireResponseViewModel[], editing: boolean | undefined, editingDate: boolean | undefined, state: ResponseState | undefined, submissionDate: Date | null | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (editing === null)
            throw new Error("The parameter 'editing' cannot be null.");
        else if (editing !== undefined)
            url_ += "editing=" + encodeURIComponent("" + editing) + "&";
        if (editingDate === null)
            throw new Error("The parameter 'editingDate' cannot be null.");
        else if (editingDate !== undefined)
            url_ += "editingDate=" + encodeURIComponent("" + editingDate) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (submissionDate !== undefined && submissionDate !== null)
            url_ += "submissionDate=" + encodeURIComponent(submissionDate ? "" + submissionDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Posts responses to return a score.
     * @param token (optional) Token of the response.
     * @param responses responses to add.
     * @param editing (optional) If submitted questionnaire response was during editing.
     * @param editingDate (optional) If a custom response date is being submitted.
     * @param state (optional) The state of the response (new, draft, submitted).
     * @param submissionDate (optional) Date of submission for the response.
     * @return If the response was updated successfully.
     */
    submitQuestionnaireResponse(token: string | null | undefined, responses: QuestionnaireResponseViewModel[], editing: boolean | undefined, editingDate: boolean | undefined, state: ResponseState | undefined, submissionDate: Date | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Questionnaire?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (editing === null)
            throw new Error("The parameter 'editing' cannot be null.");
        else if (editing !== undefined)
            url_ += "editing=" + encodeURIComponent("" + editing) + "&";
        if (editingDate === null)
            throw new Error("The parameter 'editingDate' cannot be null.");
        else if (editingDate !== undefined)
            url_ += "editingDate=" + encodeURIComponent("" + editingDate) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (submissionDate !== undefined && submissionDate !== null)
            url_ += "submissionDate=" + encodeURIComponent(submissionDate ? "" + submissionDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(responses);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitQuestionnaireResponse(_response);
        });
    }

    protected processSubmitQuestionnaireResponse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteQuestionnaireResponseURL(id: number){
        let url_ = this.baseUrl + "/api/Questionnaire/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes a questionnaire response.
     * @param id The id of the QuestionnaireResponse to delete.
     * @return True if successful, false otherwise.
     */
    deleteQuestionnaireResponse(id: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Questionnaire/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionnaireResponse(_response);
        });
    }

    protected processDeleteQuestionnaireResponse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteQuestionnaireVersionURL(version: QuestionnaireVersionViewModel){
        let url_ = this.baseUrl + "/api/Questionnaire/deleteQuestionnaireVersion";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes a questionnaire version.
     * @param version The version view model to be deleted.
     * @return True if successful, false otherwise.
     */
    deleteQuestionnaireVersion(version: QuestionnaireVersionViewModel): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Questionnaire/deleteQuestionnaireVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(version);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionnaireVersion(_response);
        });
    }

    protected processDeleteQuestionnaireVersion(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetDashboardConfigurableQuestionnairesURL(){
        let url_ = this.baseUrl + "/api/Questionnaire/getDashboardConfigurableQuestionnaires";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of questionnaires in a tenancy with configurable questionnaire options.
     * @return Gets a list of dashboard configurable questionnaires.
     */
    getDashboardConfigurableQuestionnaires(): Promise<QuestionnaireViewModel[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/getDashboardConfigurableQuestionnaires";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDashboardConfigurableQuestionnaires(_response);
        });
    }

    protected processGetDashboardConfigurableQuestionnaires(response: Response): Promise<QuestionnaireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnaireResponsesURL(token: string | null | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/getQuestionnaireResponses?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of questionnaire responses linked to a questionnaire token.
     * @param token (optional) The questionnaire token.
     * @return Gets a list of questionnaire responses.
     */
    getQuestionnaireResponses(token: string | null | undefined): Promise<QuestionnaireResponseDataViewModel> {
        let url_ = this.baseUrl + "/api/Questionnaire/getQuestionnaireResponses?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireResponses(_response);
        });
    }

    protected processGetQuestionnaireResponses(response: Response): Promise<QuestionnaireResponseDataViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireResponseDataViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireResponseDataViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getEditResponseDateURL(dateToChange: Date | undefined, questionnaireResponseId: number | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/editResponseDate?";
        if (dateToChange === null)
            throw new Error("The parameter 'dateToChange' cannot be null.");
        else if (dateToChange !== undefined)
            url_ += "dateToChange=" + encodeURIComponent(dateToChange ? "" + dateToChange.toISOString() : "") + "&";
        if (questionnaireResponseId === null)
            throw new Error("The parameter 'questionnaireResponseId' cannot be null.");
        else if (questionnaireResponseId !== undefined)
            url_ += "questionnaireResponseId=" + encodeURIComponent("" + questionnaireResponseId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates response date of questionnaire response.
     * @param dateToChange (optional) Date to update to.
     * @param questionnaireResponseId (optional) Questionnaire response Id for changing date.
     * @return True if success, bad request otherwise.
     */
    editResponseDate(dateToChange: Date | undefined, questionnaireResponseId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questionnaire/editResponseDate?";
        if (dateToChange === null)
            throw new Error("The parameter 'dateToChange' cannot be null.");
        else if (dateToChange !== undefined)
            url_ += "dateToChange=" + encodeURIComponent(dateToChange ? "" + dateToChange.toISOString() : "") + "&";
        if (questionnaireResponseId === null)
            throw new Error("The parameter 'questionnaireResponseId' cannot be null.");
        else if (questionnaireResponseId !== undefined)
            url_ += "questionnaireResponseId=" + encodeURIComponent("" + questionnaireResponseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditResponseDate(_response);
        });
    }

    protected processEditResponseDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetAllQuestionnairesURL(onlyPublished: boolean | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/getAllQuestionnaires?";
        if (onlyPublished === null)
            throw new Error("The parameter 'onlyPublished' cannot be null.");
        else if (onlyPublished !== undefined)
            url_ += "onlyPublished=" + encodeURIComponent("" + onlyPublished) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of all active questionnaires.
    onlyPublished Gets only published questionnaires if true, otherwise gets all questionnaires.
     * @param onlyPublished (optional) Gets only published questionnaires if true, otherwise gets all questionnaires.
     * @return Gets a list of all active questionnaires.
     */
    getAllQuestionnaires(onlyPublished: boolean | undefined): Promise<QuestionnaireViewModel[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/getAllQuestionnaires?";
        if (onlyPublished === null)
            throw new Error("The parameter 'onlyPublished' cannot be null.");
        else if (onlyPublished !== undefined)
            url_ += "onlyPublished=" + encodeURIComponent("" + onlyPublished) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllQuestionnaires(_response);
        });
    }

    protected processGetAllQuestionnaires(response: Response): Promise<QuestionnaireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSubmitPaxDResponseURL(result: PaxDViewModel){
        let url_ = this.baseUrl + "/api/Questionnaire/submitPaxDResponse";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Submits Pax tool response.
     * @param result User's result from the pax tool.
     * @return Ok result if submitted successfully.
     */
    submitPaxDResponse(result: PaxDViewModel): Promise<PatientViewModel[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/submitPaxDResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(result);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitPaxDResponse(_response);
        });
    }

    protected processSubmitPaxDResponse(response: Response): Promise<PatientViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getPublishQuestionnaireVersionURL(id: number | undefined, version: number | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/publishQuestionnaireVersion?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Publishes a specific questionnaire version.
     * @param id (optional) The questionnaireId to publish.
     * @param version (optional) The questionnaire version to publish.
     * @return Ok result if submitted successfully.
     */
    publishQuestionnaireVersion(id: number | undefined, version: number | undefined): Promise<PatientViewModel[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/publishQuestionnaireVersion?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishQuestionnaireVersion(_response);
        });
    }

    protected processPublishQuestionnaireVersion(response: Response): Promise<PatientViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatientViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDiscardDraftResponsesURL(token: string | null | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/discardDraftResponses?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Discards the draft responses if the user wishes to start a draft from scratch.
     * @param token (optional) The token id of the response to edit.
     * @return True if the response was updated.
     */
    discardDraftResponses(token: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questionnaire/discardDraftResponses?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiscardDraftResponses(_response);
        });
    }

    protected processDiscardDraftResponses(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetQuestionnaireVersionsURL(questionnaireId: number | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/getQuestionnaireVersions?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of all versions for the given questionnaire.
     * @param questionnaireId (optional) The ID of the questionnaire.
     * @return Gets a list of all active questionnaires.
     */
    getQuestionnaireVersions(questionnaireId: number | undefined): Promise<QuestionnaireVersionViewModel[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/getQuestionnaireVersions?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireVersions(_response);
        });
    }

    protected processGetQuestionnaireVersions(response: Response): Promise<QuestionnaireVersionViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionnaireVersionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireVersionViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDeleteQuestionnaireURL(questionnaireId: number | undefined){
        let url_ = this.baseUrl + "/api/Questionnaire/deleteQuestionnaire?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Deletes the given questionnaire.
     * @param questionnaireId (optional) The ID of the questionnaire.
     * @return Success response when deleted.
     */
    deleteQuestionnaire(questionnaireId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Questionnaire/deleteQuestionnaire?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionnaire(_response);
        });
    }

    protected processDeleteQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getRenameQuestionnaireURL(questionnaire: QuestionnaireViewModel){
        let url_ = this.baseUrl + "/api/Questionnaire/renameQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Renames the given questionnaire.
     * @param questionnaire The questionnaire details.
     * @return Success response when updated.
     */
    renameQuestionnaire(questionnaire: QuestionnaireViewModel): Promise<void> {
        let url_ = this.baseUrl + "/api/Questionnaire/renameQuestionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questionnaire);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenameQuestionnaire(_response);
        });
    }

    protected processRenameQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSaveQuestionnaireVersionURL(viewModelJSON: string){
        let url_ = this.baseUrl + "/api/Questionnaire/saveQuestionnaireVersion";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Saves the current builder questionnaire version.
     * @param viewModelJSON The JSON of the questionnaire view model to save.
     * @return The QuestionnaireViewModel with matching Id and Version.
     */
    saveQuestionnaireVersion(viewModelJSON: string): Promise<number> {
        let url_ = this.baseUrl + "/api/Questionnaire/saveQuestionnaireVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModelJSON);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveQuestionnaireVersion(_response);
        });
    }

    protected processSaveQuestionnaireVersion(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ScheduleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetSchedulesForPatientURL(patientId: number){
        let url_ = this.baseUrl + "/api/Schedule/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets schedules for a patient.
     * @param patientId The id of the patient to get the schedules for.
     * @return The schedules that belong to a patient.
     */
    getSchedulesForPatient(patientId: number): Promise<ScheduleViewModel[]> {
        let url_ = this.baseUrl + "/api/Schedule/{patientId}";
        if (patientId === undefined || patientId === null)
            throw new Error("The parameter 'patientId' must be defined.");
        url_ = url_.replace("{patientId}", encodeURIComponent("" + patientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSchedulesForPatient(_response);
        });
    }

    protected processGetSchedulesForPatient(response: Response): Promise<ScheduleViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateScheduleURL(schedule: ScheduleViewModel){
        let url_ = this.baseUrl + "/api/Schedule";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Creates a schedule.
     * @param schedule The ScheduleViewModel to create.
     * @return The created ScheduleViewModel.
     */
    createSchedule(schedule: ScheduleViewModel): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schedule);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSchedule(_response);
        });
    }

    protected processCreateSchedule(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getPutScheduleURL(schedule: ScheduleViewModel){
        let url_ = this.baseUrl + "/api/Schedule";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates a schedule.
     * @param schedule The ScheduleViewModel to update.
     * @return The updated ScheduleViewModel.
     */
    putSchedule(schedule: ScheduleViewModel): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schedule);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPutSchedule(_response);
        });
    }

    protected processPutSchedule(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getArchiveScheduleURL(scheduleId: number | undefined){
        let url_ = this.baseUrl + "/api/Schedule/archive?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Archives a schedule.
     * @param scheduleId (optional) The id of the ScheduleViewModel to archive.
     * @return True if successful, false otherwise.
     */
    archiveSchedule(scheduleId: number | undefined): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule/archive?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveSchedule(_response);
        });
    }

    protected processArchiveSchedule(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getArchiveAllSchedulesForUserURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Schedule/archiveall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Archives all schedules for a user.
     * @param patientId (optional) The id of the patient to archive all ScheduleViewModels for.
     * @return True if successful, false otherwise.
     */
    archiveAllSchedulesForUser(patientId: number | undefined): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule/archiveall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveAllSchedulesForUser(_response);
        });
    }

    protected processArchiveAllSchedulesForUser(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSuspendScheduleURL(scheduleId: number | undefined){
        let url_ = this.baseUrl + "/api/Schedule/suspend?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Suspends a schedule.
     * @param scheduleId (optional) The id of the ScheduleViewModel to suspend.
     * @return True if successful, false otherwise.
     */
    suspendSchedule(scheduleId: number | undefined): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule/suspend?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuspendSchedule(_response);
        });
    }

    protected processSuspendSchedule(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSuspendAllSchedulesForUserURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Schedule/suspendall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Suspends all schedules for a user.
     * @param patientId (optional) The id of the patient to suspend all ScheduleViewModels for.
     * @return True if successful, false otherwise.
     */
    suspendAllSchedulesForUser(patientId: number | undefined): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule/suspendall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuspendAllSchedulesForUser(_response);
        });
    }

    protected processSuspendAllSchedulesForUser(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getResumeScheduleURL(scheduleId: number | undefined){
        let url_ = this.baseUrl + "/api/Schedule/resume?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Resumes a schedule.
     * @param scheduleId (optional) The id of the ScheduleViewModel to resume.
     * @return True if successful, false otherwise.
     */
    resumeSchedule(scheduleId: number | undefined): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule/resume?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResumeSchedule(_response);
        });
    }

    protected processResumeSchedule(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getResumeAllSchedulesForUserURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Schedule/resumeall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Resumes all schedules for a user.
     * @param patientId (optional) The id of the patient to resumes all ScheduleViewModels for.
     * @return True if successful, false otherwise.
     */
    resumeAllSchedulesForUser(patientId: number | undefined): Promise<ScheduleViewModel> {
        let url_ = this.baseUrl + "/api/Schedule/resumeall?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResumeAllSchedulesForUser(_response);
        });
    }

    protected processResumeAllSchedulesForUser(response: Response): Promise<ScheduleViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUnarchiveScheduleURL(scheduleId: number | undefined){
        let url_ = this.baseUrl + "/api/Schedule/unarchive?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Unarchive a schedule.
     * @param scheduleId (optional) The id of the schedule to unarchive.
     * @return True if successful, false otherwise.
     */
    unarchiveSchedule(scheduleId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Schedule/unarchive?";
        if (scheduleId === null)
            throw new Error("The parameter 'scheduleId' cannot be null.");
        else if (scheduleId !== undefined)
            url_ += "scheduleId=" + encodeURIComponent("" + scheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnarchiveSchedule(_response);
        });
    }

    protected processUnarchiveSchedule(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class StaffClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getCreateStaffURL(staff: StaffViewModel, role: Role | undefined){
        let url_ = this.baseUrl + "/api/Staff/create?";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Create a Staff member.
     * @param staff The Staff to create.
     * @param role (optional) The Role of the Staff member to create.
     * @return The created StaffViewModel.
     */
    createStaff(staff: StaffViewModel, role: Role | undefined): Promise<StaffViewModel> {
        let url_ = this.baseUrl + "/api/Staff/create?";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staff);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateStaff(_response);
        });
    }

    protected processCreateStaff(response: Response): Promise<StaffViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaffViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getIsClinicianLinkedToPatientURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Staff?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Check if a staff member is linked to patient returning true if they are.
     * @param patientId (optional) Id of the patient in question.
     * @return If the staff is linked to queried patient.
     */
    isClinicianLinkedToPatient(patientId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Staff?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsClinicianLinkedToPatient(_response);
        });
    }

    protected processIsClinicianLinkedToPatient(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getAddPatientToPersonalCaseloadURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Staff?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Adds a patient to the clinician's personal caseload.
     * @param patientId (optional) Id of the patient in question.
     * @return True if successful, false otherwise.
     */
    addPatientToPersonalCaseload(patientId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Staff?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPatientToPersonalCaseload(_response);
        });
    }

    protected processAddPatientToPersonalCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getIsPatientInPersonalCaseloadURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Staff/patientInPersonalClinicianCaseload?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Check if the patient is in the clinician's personal caseload.
     * @param patientId (optional) Id of the patient in question.
     * @return If the patient is in the clinician's personal caseload.
     */
    isPatientInPersonalCaseload(patientId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Staff/patientInPersonalClinicianCaseload?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsPatientInPersonalCaseload(_response);
        });
    }

    protected processIsPatientInPersonalCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getRemovePatientFromPersonalCaseloadURL(patientId: number | undefined){
        let url_ = this.baseUrl + "/api/Staff/removeFromCaseload?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Removes a patient from the clinician's personal caseload.
     * @param patientId (optional) Id of the patient in question.
     * @return True if successful, false otherwise.
     */
    removePatientFromPersonalCaseload(patientId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Staff/removeFromCaseload?";
        if (patientId === null)
            throw new Error("The parameter 'patientId' cannot be null.");
        else if (patientId !== undefined)
            url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemovePatientFromPersonalCaseload(_response);
        });
    }

    protected processRemovePatientFromPersonalCaseload(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetStaffFromCurrentUserIdURL(){
        let url_ = this.baseUrl + "/api/Staff/staffFromCurrentUser";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the staff object of the current user.
     * @return Current user's staff ID.
     */
    getStaffFromCurrentUserId(): Promise<Staff> {
        let url_ = this.baseUrl + "/api/Staff/staffFromCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStaffFromCurrentUserId(_response);
        });
    }

    protected processGetStaffFromCurrentUserId(response: Response): Promise<Staff> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Staff.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Staff>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetStaffURL(staffId: number | undefined){
        let url_ = this.baseUrl + "/api/Staff/getStaff?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets staff from staff Id.
     * @param staffId (optional) Id of the staff that is reqwuested.
     * @return Staff with stated staff id.
     */
    getStaff(staffId: number | undefined): Promise<StaffViewModel> {
        let url_ = this.baseUrl + "/api/Staff/getStaff?";
        if (staffId === null)
            throw new Error("The parameter 'staffId' cannot be null.");
        else if (staffId !== undefined)
            url_ += "staffId=" + encodeURIComponent("" + staffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStaff(_response);
        });
    }

    protected processGetStaff(response: Response): Promise<StaffViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StaffViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaffViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCliniciansURL(){
        let url_ = this.baseUrl + "/api/Staff/getAllClinicians";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets all active staff whose role is clinician.
     * @return All active clinicians.
     */
    getClinicians(): Promise<StaffViewModel[]> {
        let url_ = this.baseUrl + "/api/Staff/getAllClinicians";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClinicians(_response);
        });
    }

    protected processGetClinicians(response: Response): Promise<StaffViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StaffViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaffViewModel[]>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateDetailsURL(staff: StaffViewModel){
        let url_ = this.baseUrl + "/api/Staff/updateDetails";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Updates the details of a Staff member.
     * @param staff The StaffViewModel to update.
     * @return True if successful, false otherwise.
     */
    updateDetails(staff: StaffViewModel): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Staff/updateDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staff);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDetails(_response);
        });
    }

    protected processUpdateDetails(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDownloadPatientResponsesWorkbookURL(caseloadId: number | undefined, groupByQuestionnaire: boolean | undefined, excludeGoals: boolean | undefined, excludeExternalDatasets: boolean | undefined){
        let url_ = this.baseUrl + "/api/Staff/downloadPatientResponsesWorkbook?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (groupByQuestionnaire === null)
            throw new Error("The parameter 'groupByQuestionnaire' cannot be null.");
        else if (groupByQuestionnaire !== undefined)
            url_ += "groupByQuestionnaire=" + encodeURIComponent("" + groupByQuestionnaire) + "&";
        if (excludeGoals === null)
            throw new Error("The parameter 'excludeGoals' cannot be null.");
        else if (excludeGoals !== undefined)
            url_ += "excludeGoals=" + encodeURIComponent("" + excludeGoals) + "&";
        if (excludeExternalDatasets === null)
            throw new Error("The parameter 'excludeExternalDatasets' cannot be null.");
        else if (excludeExternalDatasets !== undefined)
            url_ += "excludeExternalDatasets=" + encodeURIComponent("" + excludeExternalDatasets) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Download patient responses against a caseload.
     * @param caseloadId (optional) Caseload id to download patient responses against.
     * @param groupByQuestionnaire (optional) Group by questionnaire in workbook.
     * @param excludeGoals (optional) Exclude goals from the workbook.
     * @param excludeExternalDatasets (optional) Exclude external datasets from the workbook.
     * @return Stream of the excel workbook file.
     */
    downloadPatientResponsesWorkbook(caseloadId: number | undefined, groupByQuestionnaire: boolean | undefined, excludeGoals: boolean | undefined, excludeExternalDatasets: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Staff/downloadPatientResponsesWorkbook?";
        if (caseloadId === null)
            throw new Error("The parameter 'caseloadId' cannot be null.");
        else if (caseloadId !== undefined)
            url_ += "caseloadId=" + encodeURIComponent("" + caseloadId) + "&";
        if (groupByQuestionnaire === null)
            throw new Error("The parameter 'groupByQuestionnaire' cannot be null.");
        else if (groupByQuestionnaire !== undefined)
            url_ += "groupByQuestionnaire=" + encodeURIComponent("" + groupByQuestionnaire) + "&";
        if (excludeGoals === null)
            throw new Error("The parameter 'excludeGoals' cannot be null.");
        else if (excludeGoals !== undefined)
            url_ += "excludeGoals=" + encodeURIComponent("" + excludeGoals) + "&";
        if (excludeExternalDatasets === null)
            throw new Error("The parameter 'excludeExternalDatasets' cannot be null.");
        else if (excludeExternalDatasets !== undefined)
            url_ += "excludeExternalDatasets=" + encodeURIComponent("" + excludeExternalDatasets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPatientResponsesWorkbook(_response);
        });
    }

    protected processDownloadPatientResponsesWorkbook(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSearchCliniciansByNameURL(searchCriteria: string | null | undefined){
        let url_ = this.baseUrl + "/api/Staff/searchPatientByName?";
        if (searchCriteria !== undefined && searchCriteria !== null)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets clinician based on searched name limited by 20.
     * @param searchCriteria (optional) The search criteria.
     * @return List of clinician with search criteria.
     */
    searchCliniciansByName(searchCriteria: string | null | undefined): Promise<StaffViewModel[]> {
        let url_ = this.baseUrl + "/api/Staff/searchPatientByName?";
        if (searchCriteria !== undefined && searchCriteria !== null)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchCliniciansByName(_response);
        });
    }

    protected processSearchCliniciansByName(response: Response): Promise<StaffViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StaffViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaffViewModel[]>(null as any);
    }
}

export class TemporaryAccessLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getInsertTemporaryAccessLogURL(temporaryAccessLog: TemporaryAccessLogViewModel){
        let url_ = this.baseUrl + "/api/TemporaryAccessLog";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Insert a temporary access log.
     * @param temporaryAccessLog The temporary access log to insert.
     * @return If the log was inserted.
     */
    insertTemporaryAccessLog(temporaryAccessLog: TemporaryAccessLogViewModel): Promise<boolean> {
        let url_ = this.baseUrl + "/api/TemporaryAccessLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(temporaryAccessLog);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertTemporaryAccessLog(_response);
        });
    }

    protected processInsertTemporaryAccessLog(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getDownloadTemporaryAccessCSVBetweenDatesURL(fromDate: string | null | undefined, toDate: string | null | undefined){
        let url_ = this.baseUrl + "/api/TemporaryAccessLog?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Downloads CSV file of temporary access logs between specified dates on specified tenancy.
     * @param fromDate (optional) Start date.
     * @param toDate (optional) End date.
     * @return File stream result for download on front end.
     */
    downloadTemporaryAccessCSVBetweenDates(fromDate: string | null | undefined, toDate: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TemporaryAccessLog?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadTemporaryAccessCSVBetweenDates(_response);
        });
    }

    protected processDownloadTemporaryAccessCSVBetweenDates(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TenantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetIsTenantIntegratedURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantIntegration";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant is using integration.
     * @return If the user's tenant is using integration.
     */
    getIsTenantIntegrated(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantIntegration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIsTenantIntegrated(_response);
        });
    }

    protected processGetIsTenantIntegrated(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetMedicationEnabledURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantMedication";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant is using medication.
     * @return If the user's tenant is using medication.
     */
    getMedicationEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantMedication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMedicationEnabled(_response);
        });
    }

    protected processGetMedicationEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetDashboardEnabledURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantDashboard";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant is using dashboard.
     * @return If the user's tenant is using dashboard.
     */
    getDashboardEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantDashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDashboardEnabled(_response);
        });
    }

    protected processGetDashboardEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCustomPatientIdEnabledURL(){
        let url_ = this.baseUrl + "/api/Tenant/customPatientId";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant is using custom patient Ids.
     * @return If the user's tenant is using custom patient Ids.
     */
    getCustomPatientIdEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/customPatientId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCustomPatientIdEnabled(_response);
        });
    }

    protected processGetCustomPatientIdEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetTenantGraphSeperationDefaultURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantGraphSeperationDefault";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant seperates summary graphs by default.
     * @return If the user's tenant seperates summary graphs by default.
     */
    getTenantGraphSeperationDefault(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantGraphSeperationDefault";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantGraphSeperationDefault(_response);
        });
    }

    protected processGetTenantGraphSeperationDefault(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetExternalDataEnabledURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantExternalData";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant is using external datasets.
     * @return If the user's tenant is using external datasets.
     */
    getExternalDataEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantExternalData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExternalDataEnabled(_response);
        });
    }

    protected processGetExternalDataEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetClinicianEditEnabledURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantClinicianEdit";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant allows clinicians to edit responses.
     * @return If the user's tenant allows clinicians to edit responses.
     */
    getClinicianEditEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantClinicianEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClinicianEditEnabled(_response);
        });
    }

    protected processGetClinicianEditEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetNHSNumberRequiredURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantNHSNumber";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant requires patients to have an NHS number.
     * @return If the user's tenant requires patients to have an NHS number.
     */
    getNHSNumberRequired(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantNHSNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNHSNumberRequired(_response);
        });
    }

    protected processGetNHSNumberRequired(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetEditQuestionnairesEnabledURL(){
        let url_ = this.baseUrl + "/api/Tenant/tenantEditQuestionnaires";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Checks if the user's tenant allows admins to edit questionnaires.
     * @return If the user's tenant allows admins to edit questionnaires.
     */
    getEditQuestionnairesEnabled(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Tenant/tenantEditQuestionnaires";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEditQuestionnairesEnabled(_response);
        });
    }

    protected processGetEditQuestionnairesEnabled(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetTenantURL(tenantId: number | null | undefined){
        let url_ = this.baseUrl + "/api/Tenant/tenant?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets details for a tenancy.
     * @param tenantId (optional) Optional tenant id for unauthed routes.
     * @return Tenant View model.
     */
    getTenant(tenantId: number | null | undefined): Promise<TenantViewModel> {
        let url_ = this.baseUrl + "/api/Tenant/tenant?";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenant(_response);
        });
    }

    protected processGetTenant(response: Response): Promise<TenantViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetUserTenanciesURL(){
        let url_ = this.baseUrl + "/api/Tenant/userTenancies";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets current user tenancies.
     * @return Tenant View models for current user.
     */
    getUserTenancies(): Promise<TenantViewModel[]> {
        let url_ = this.baseUrl + "/api/Tenant/userTenancies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserTenancies(_response);
        });
    }

    protected processGetUserTenancies(response: Response): Promise<TenantViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantViewModel[]>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSearchUsersURL(searchCriteria: string | null | undefined, searchDate: string | null | undefined, caseloadid: number | null | undefined, role: Role | undefined, sort: SortType | null | undefined, sortDirection: SortDirectionType | null | undefined, userId: number | undefined, page: number | null | undefined){
        let url_ = this.baseUrl + "/api/User?";
        if (searchCriteria !== undefined && searchCriteria !== null)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        if (searchDate !== undefined && searchDate !== null)
            url_ += "searchDate=" + encodeURIComponent("" + searchDate) + "&";
        if (caseloadid !== undefined && caseloadid !== null)
            url_ += "caseloadid=" + encodeURIComponent("" + caseloadid) + "&";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets a List`1 of users based of searchCriteria.
     * @param searchCriteria (optional) The search criteria.
     * @param searchDate (optional) The search date.
     * @param caseloadid (optional) The caseload id to search.
     * @param role (optional) The role of the users to filter.
     * @param sort (optional) The field to sort by.
     * @param sortDirection (optional) The directrion to sort in.
     * @param userId (optional) ID of the current user.
     * @param page (optional) The page to filter to.
     * @return A tuple with the list of users and total pages.
    or
    A tuple with the list of users and total pages.
     */
    searchUsers(searchCriteria: string | null | undefined, searchDate: string | null | undefined, caseloadid: number | null | undefined, role: Role | undefined, sort: SortType | null | undefined, sortDirection: SortDirectionType | null | undefined, userId: number | undefined, page: number | null | undefined): Promise<any> {
        let url_ = this.baseUrl + "/api/User?";
        if (searchCriteria !== undefined && searchCriteria !== null)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        if (searchDate !== undefined && searchDate !== null)
            url_ += "searchDate=" + encodeURIComponent("" + searchDate) + "&";
        if (caseloadid !== undefined && caseloadid !== null)
            url_ += "caseloadid=" + encodeURIComponent("" + caseloadid) + "&";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentUserURL(){
        let url_ = this.baseUrl + "/api/User/getCurrentUser";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the UserViewModel if the user is authed.
     * @return A User object.
     */
    getCurrentUser(): Promise<UserViewModel> {
        let url_ = this.baseUrl + "/api/User/getCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetContactDetailsURL(){
        let url_ = this.baseUrl + "/api/User/GetContactDetails";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the ContactDetailsViewModel if the user is authed.
     * @return A contact details object.
     */
    getContactDetails(): Promise<ContactDetailsViewModel> {
        let url_ = this.baseUrl + "/api/User/GetContactDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContactDetails(_response);
        });
    }

    protected processGetContactDetails(response: Response): Promise<ContactDetailsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDetailsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDetailsViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getUpdateContactDetailsURL(details: ContactDetailsViewModel){
        let url_ = this.baseUrl + "/api/User/UpdateContactDetails";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Sets the updated contact details if the user is authed.
     * @param details The contact details to update.
     * @return A contact details object.
     */
    updateContactDetails(details: ContactDetailsViewModel): Promise<ContactDetailsViewModel> {
        let url_ = this.baseUrl + "/api/User/UpdateContactDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContactDetails(_response);
        });
    }

    protected processUpdateContactDetails(response: Response): Promise<ContactDetailsViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDetailsViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDetailsViewModel>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getSetCurrentTenancyURL(tenantId: number){
        let url_ = this.baseUrl + "/api/User/setCurrentTenancy";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Sets the current tenancy for a user.
     * @param tenantId The tenancy id to change to.
     * @return True on success.
     */
    setCurrentTenancy(tenantId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/setCurrentTenancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenantId);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetCurrentTenancy(_response);
        });
    }

    protected processSetCurrentTenancy(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets the url for the request.
     * @return The URL for the request.
     */
    getGetCurrentTenancyURL(){
        let url_ = this.baseUrl + "/api/User/getCurrentTenancy";
        url_ = url_.replace(/[?&]$/, "");
        return url_;
    }

    /**
     * Gets the current tenancy for a user.
     * @return TenantId of current tenancy.
     */
    getCurrentTenancy(): Promise<number> {
        let url_ = this.baseUrl + "/api/User/getCurrentTenancy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentTenancy(_response);
        });
    }

    protected processGetCurrentTenancy(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

/** An entity that defines the HasIDViewModel. */
export class HasIdViewModel implements IHasIdViewModel {
    /** Gets or sets the Id. */
    id!: number;

    constructor(data?: IHasIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HasIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HasIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

/** An entity that defines the HasIDViewModel. */
export interface IHasIdViewModel {
    /** Gets or sets the Id. */
    id: number;
}

/** Defines the ViewModelBase. */
export class ViewModelBase extends HasIdViewModel implements IViewModelBase {
    /** Gets or sets a value indicating whether the entity is active. */
    active!: boolean;
    /** Gets or sets when the entity was created. */
    created!: Date;
    /** Gets or sets when the entity was Updated. */
    updated!: Date;

    constructor(data?: IViewModelBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ViewModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new ViewModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Defines the ViewModelBase. */
export interface IViewModelBase extends IHasIdViewModel {
    /** Gets or sets a value indicating whether the entity is active. */
    active: boolean;
    /** Gets or sets when the entity was created. */
    created: Date;
    /** Gets or sets when the entity was Updated. */
    updated: Date;
}

/** Defines the CaseloadViewModel. */
export class CaseloadViewModel extends ViewModelBase implements ICaseloadViewModel {
    /** Gets or sets the CaseloadName. */
    name?: string | undefined;
    /** Gets or sets the ShortName. */
    shortName?: string | undefined;
    /** Gets or sets the description of the caseload. */
    description?: string | undefined;
    /** Gets or sets tHe type of the caseload. */
    type?: CaseloadType | undefined;

    constructor(data?: ICaseloadViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CaseloadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseloadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

/** Defines the CaseloadViewModel. */
export interface ICaseloadViewModel extends IViewModelBase {
    /** Gets or sets the CaseloadName. */
    name?: string | undefined;
    /** Gets or sets the ShortName. */
    shortName?: string | undefined;
    /** Gets or sets the description of the caseload. */
    description?: string | undefined;
    /** Gets or sets tHe type of the caseload. */
    type?: CaseloadType | undefined;
}

/** A caseload type. */
export enum CaseloadType {
    Personal = 0,
    Shared = 1,
    Both = 2,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

/** Defines the UserViewModel. */
export class UserViewModel extends ViewModelBase implements IUserViewModel {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the Role. */
    role?: Role | undefined;
    /** Gets or sets the UserName. */
    userName?: string | undefined;
    /** Gets or sets the Last Login datetime. */
    lastLogin?: Date | undefined;

    constructor(data?: IUserViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
            this.role = _data["role"];
            this.userName = _data["userName"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["role"] = this.role;
        data["userName"] = this.userName;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Defines the UserViewModel. */
export interface IUserViewModel extends IViewModelBase {
    /** Gets or sets the email. */
    email?: string | undefined;
    /** Gets or sets the Role. */
    role?: Role | undefined;
    /** Gets or sets the UserName. */
    userName?: string | undefined;
    /** Gets or sets the Last Login datetime. */
    lastLogin?: Date | undefined;
}

/** Defines the PatientViewModel. */
export class PatientViewModel extends UserViewModel implements IPatientViewModel {
    /** Gets or sets the User Id. */
    userId!: number;
    /** Gets or sets the NHS number. */
    nhsNumber?: number | undefined;
    /** Gets or sets the FirstName. */
    firstName?: string | undefined;
    /** Gets or sets the LastName. */
    lastName?: string | undefined;
    /** Gets or sets last reponse time of contact. */
    lastResponse?: Date | undefined;
    /** Gets or sets date of birth. */
    dateOfBirth?: Date | undefined;
    /** Gets or sets the Gender. */
    gender?: Gender | undefined;
    /** Gets or sets the DeceasedBoolean. */
    deceasedBoolean?: boolean | undefined;
    /** Gets or sets DeceasedDateTime. */
    deceasedDateTime?: Date | undefined;
    /** Gets or sets the patient preferred contact type. */
    preferredContact!: PreferredContact;
    /** Gets or sets the contact email. */
    contactEmail?: string | undefined;
    /** Gets or sets Mobile Number. */
    mobileNumber?: string | undefined;
    /** Gets or sets DashboardQuestionnaireId. */
    dashboardQuestionnaireId?: number | undefined;
    /** Gets or sets the Custom Patient Id. */
    customPatientId?: string | undefined;
    /** Gets or sets the tenant id. */
    tenantId?: number | undefined;

    constructor(data?: IPatientViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.nhsNumber = _data["nhsNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.lastResponse = _data["lastResponse"] ? new Date(_data["lastResponse"].toString()) : <any>undefined;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.deceasedBoolean = _data["deceasedBoolean"];
            this.deceasedDateTime = _data["deceasedDateTime"] ? new Date(_data["deceasedDateTime"].toString()) : <any>undefined;
            this.preferredContact = _data["preferredContact"];
            this.contactEmail = _data["contactEmail"];
            this.mobileNumber = _data["mobileNumber"];
            this.dashboardQuestionnaireId = _data["dashboardQuestionnaireId"];
            this.customPatientId = _data["customPatientId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): PatientViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["nhsNumber"] = this.nhsNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["lastResponse"] = this.lastResponse ? this.lastResponse.toISOString() : <any>undefined;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["deceasedBoolean"] = this.deceasedBoolean;
        data["deceasedDateTime"] = this.deceasedDateTime ? this.deceasedDateTime.toISOString() : <any>undefined;
        data["preferredContact"] = this.preferredContact;
        data["contactEmail"] = this.contactEmail;
        data["mobileNumber"] = this.mobileNumber;
        data["dashboardQuestionnaireId"] = this.dashboardQuestionnaireId;
        data["customPatientId"] = this.customPatientId;
        data["tenantId"] = this.tenantId;
        super.toJSON(data);
        return data;
    }
}

/** Defines the PatientViewModel. */
export interface IPatientViewModel extends IUserViewModel {
    /** Gets or sets the User Id. */
    userId: number;
    /** Gets or sets the NHS number. */
    nhsNumber?: number | undefined;
    /** Gets or sets the FirstName. */
    firstName?: string | undefined;
    /** Gets or sets the LastName. */
    lastName?: string | undefined;
    /** Gets or sets last reponse time of contact. */
    lastResponse?: Date | undefined;
    /** Gets or sets date of birth. */
    dateOfBirth?: Date | undefined;
    /** Gets or sets the Gender. */
    gender?: Gender | undefined;
    /** Gets or sets the DeceasedBoolean. */
    deceasedBoolean?: boolean | undefined;
    /** Gets or sets DeceasedDateTime. */
    deceasedDateTime?: Date | undefined;
    /** Gets or sets the patient preferred contact type. */
    preferredContact: PreferredContact;
    /** Gets or sets the contact email. */
    contactEmail?: string | undefined;
    /** Gets or sets Mobile Number. */
    mobileNumber?: string | undefined;
    /** Gets or sets DashboardQuestionnaireId. */
    dashboardQuestionnaireId?: number | undefined;
    /** Gets or sets the Custom Patient Id. */
    customPatientId?: string | undefined;
    /** Gets or sets the tenant id. */
    tenantId?: number | undefined;
}

/** Gender of a patient. */
export enum Gender {
    Male = 0,
    Female = 1,
    Other = 2,
    Unknown = 3,
}

/** Enum for patient's preferred contact type. */
export enum PreferredContact {
    Email = 0,
    Mobile = 1,
    Both = 2,
}

/** Role for a user. */
export enum Role {
    NoAccess = 0,
    Patient = 1,
    Clinician = 2,
    Admin = 3,
    SuperAdmin = 4,
}

/** Defines the StaffViewModel. */
export class StaffViewModel extends UserViewModel implements IStaffViewModel {
    /** Gets or sets the user Id. */
    userId!: number;
    /** Gets or sets the FirstName. */
    firstName?: string | undefined;
    /** Gets or sets the LastName. */
    lastName?: string | undefined;
    /** Gets or sets the staff preferred contact type. */
    preferredContact!: PreferredContact;
    /** Gets or sets ContactEmail. */
    contactEmail?: string | undefined;
    /** Gets or sets Mobile Number. */
    mobileNumber?: string | undefined;

    constructor(data?: IStaffViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.preferredContact = _data["preferredContact"];
            this.contactEmail = _data["contactEmail"];
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): StaffViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaffViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["preferredContact"] = this.preferredContact;
        data["contactEmail"] = this.contactEmail;
        data["mobileNumber"] = this.mobileNumber;
        super.toJSON(data);
        return data;
    }
}

/** Defines the StaffViewModel. */
export interface IStaffViewModel extends IUserViewModel {
    /** Gets or sets the user Id. */
    userId: number;
    /** Gets or sets the FirstName. */
    firstName?: string | undefined;
    /** Gets or sets the LastName. */
    lastName?: string | undefined;
    /** Gets or sets the staff preferred contact type. */
    preferredContact: PreferredContact;
    /** Gets or sets ContactEmail. */
    contactEmail?: string | undefined;
    /** Gets or sets Mobile Number. */
    mobileNumber?: string | undefined;
}

/** Defines the QuestionnaireViewModel. */
export class QuestionnaireViewModel extends ViewModelBase implements IQuestionnaireViewModel {
    /** Gets or sets the Name. */
    name?: string | undefined;
    /** Gets or sets the Title. */
    title?: string | undefined;
    /** Gets or sets the Description. */
    description?: string | undefined;
    /** Gets or sets the Sections of the questionnaire. */
    sections?: SectionViewModel[] | undefined;
    /** Gets or sets the questionnaire version. */
    version?: number | undefined;
    /** Gets or sets the response Id. */
    responseId?: number | undefined;
    /** Gets or sets the scoring view model. */
    scoring?: ScoringLogicViewModel[] | undefined;
    /** Gets or sets pax task number if questionnaire is pax task otherwise null. */
    paxTaskNumber?: number | undefined;
    /** Gets or sets the patient dashboard options for the questionnaire. */
    dashboardOptions?: PatientDashboardOptionsViewModel | undefined;
    /** Gets or sets copyright information as html. */
    copyright?: string | undefined;
    /** Gets or sets the cover page for the questionnaire (nullable). */
    coverPage?: string | undefined;
    /** Gets or sets a value indicating whether questionnaire can only come from authenticated routes. */
    authenticatedOnly!: boolean;
    /** Gets or sets a value indicating whether the section selector is present on timeline responses. */
    sectionsSelector!: boolean;
    /** Gets or sets a value indicating whether graphs should be made for this questionnaires responses. */
    disableGraphs!: boolean;

    constructor(data?: IQuestionnaireViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionViewModel.fromJS(item));
            }
            this.version = _data["version"];
            this.responseId = _data["responseId"];
            if (Array.isArray(_data["scoring"])) {
                this.scoring = [] as any;
                for (let item of _data["scoring"])
                    this.scoring!.push(ScoringLogicViewModel.fromJS(item));
            }
            this.paxTaskNumber = _data["paxTaskNumber"];
            this.dashboardOptions = _data["dashboardOptions"] ? PatientDashboardOptionsViewModel.fromJS(_data["dashboardOptions"]) : <any>undefined;
            this.copyright = _data["copyright"];
            this.coverPage = _data["coverPage"];
            this.authenticatedOnly = _data["authenticatedOnly"];
            this.sectionsSelector = _data["sectionsSelector"];
            this.disableGraphs = _data["disableGraphs"];
        }
    }

    static fromJS(data: any): QuestionnaireViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["version"] = this.version;
        data["responseId"] = this.responseId;
        if (Array.isArray(this.scoring)) {
            data["scoring"] = [];
            for (let item of this.scoring)
                data["scoring"].push(item.toJSON());
        }
        data["paxTaskNumber"] = this.paxTaskNumber;
        data["dashboardOptions"] = this.dashboardOptions ? this.dashboardOptions.toJSON() : <any>undefined;
        data["copyright"] = this.copyright;
        data["coverPage"] = this.coverPage;
        data["authenticatedOnly"] = this.authenticatedOnly;
        data["sectionsSelector"] = this.sectionsSelector;
        data["disableGraphs"] = this.disableGraphs;
        super.toJSON(data);
        return data;
    }
}

/** Defines the QuestionnaireViewModel. */
export interface IQuestionnaireViewModel extends IViewModelBase {
    /** Gets or sets the Name. */
    name?: string | undefined;
    /** Gets or sets the Title. */
    title?: string | undefined;
    /** Gets or sets the Description. */
    description?: string | undefined;
    /** Gets or sets the Sections of the questionnaire. */
    sections?: SectionViewModel[] | undefined;
    /** Gets or sets the questionnaire version. */
    version?: number | undefined;
    /** Gets or sets the response Id. */
    responseId?: number | undefined;
    /** Gets or sets the scoring view model. */
    scoring?: ScoringLogicViewModel[] | undefined;
    /** Gets or sets pax task number if questionnaire is pax task otherwise null. */
    paxTaskNumber?: number | undefined;
    /** Gets or sets the patient dashboard options for the questionnaire. */
    dashboardOptions?: PatientDashboardOptionsViewModel | undefined;
    /** Gets or sets copyright information as html. */
    copyright?: string | undefined;
    /** Gets or sets the cover page for the questionnaire (nullable). */
    coverPage?: string | undefined;
    /** Gets or sets a value indicating whether questionnaire can only come from authenticated routes. */
    authenticatedOnly: boolean;
    /** Gets or sets a value indicating whether the section selector is present on timeline responses. */
    sectionsSelector: boolean;
    /** Gets or sets a value indicating whether graphs should be made for this questionnaires responses. */
    disableGraphs: boolean;
}

/** Defines the section view model. */
export class SectionViewModel implements ISectionViewModel {
    /** Gets or sets the section heading. */
    heading?: string | undefined;
    /** Gets or sets what questions this section depends on. */
    dependsOn?: { [key: string]: number[]; } | undefined;
    /** Gets or sets the set of questions in the section. */
    questions?: QuestionViewModel[] | undefined;
    /** Gets or sets the section title. */
    sectionTitle?: string | undefined;

    constructor(data?: ISectionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.heading = _data["heading"];
            if (_data["dependsOn"]) {
                this.dependsOn = {} as any;
                for (let key in _data["dependsOn"]) {
                    if (_data["dependsOn"].hasOwnProperty(key))
                        (<any>this.dependsOn)![key] = _data["dependsOn"][key] !== undefined ? _data["dependsOn"][key] : [];
                }
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionViewModel.fromJS(item));
            }
            this.sectionTitle = _data["sectionTitle"];
        }
    }

    static fromJS(data: any): SectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        if (this.dependsOn) {
            data["dependsOn"] = {};
            for (let key in this.dependsOn) {
                if (this.dependsOn.hasOwnProperty(key))
                    (<any>data["dependsOn"])[key] = (<any>this.dependsOn)[key];
            }
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        data["sectionTitle"] = this.sectionTitle;
        return data;
    }
}

/** Defines the section view model. */
export interface ISectionViewModel {
    /** Gets or sets the section heading. */
    heading?: string | undefined;
    /** Gets or sets what questions this section depends on. */
    dependsOn?: { [key: string]: number[]; } | undefined;
    /** Gets or sets the set of questions in the section. */
    questions?: QuestionViewModel[] | undefined;
    /** Gets or sets the section title. */
    sectionTitle?: string | undefined;
}

/** The question view model. */
export class QuestionViewModel implements IQuestionViewModel {
    /** Gets or sets the question text. */
    text?: string | undefined;
    /** Gets or sets the short text for the question. */
    shortText?: string | undefined;
    /** Gets or sets the question number. */
    number!: number;
    /** Gets or sets the question number or name for display purposes. */
    displayName?: string | undefined;
    /** Gets or sets whether the number should be hidden in the text. */
    hideNumber?: boolean | undefined;
    /** Gets or sets the list of available answers. */
    answers?: AnswerViewModel[] | undefined;
    /** Gets or sets the question type. */
    questionType!: QuestionType;
    /** Gets or sets the subheading. */
    subheading?: string | undefined;
    /** Gets or sets a note for the question. */
    note?: string | undefined;
    /** Gets or sets whether a divider is needed. */
    divider?: boolean | undefined;
    /** Gets or sets whether the question is mandatory. */
    mandatory?: boolean | undefined;
    /** Gets or sets the id of the goal that the question is linked to (if applicable). */
    goalId?: number | undefined;
    /** Gets or sets a dictionary of question numbers and their respective answer numbers required for this question to be scored. */
    dependsOn?: { [key: string]: number[]; } | undefined;
    /** Gets or sets the list of labels on the range slider. */
    labels?: string[] | undefined;
    /** Gets or sets a value indicating the SNOMED code for this question. */
    snomed?: string | undefined;
    /** Gets or sets the maximum number of answers for multi buttons and checklists. */
    maxAnswers?: number | undefined;
    /** Gets or sets the list of record names for a table. */
    rows?: string[] | undefined;
    /** Gets or sets the number of rows for a table. */
    rowNumber?: number | undefined;
    /** Gets or sets the column headers for a MultiSelectTable. */
    headers?: string[] | undefined;
    /** Gets or sets the name of the object that row is defining in a MultiSelectorTable, e.g. person, medication etc. */
    rowObjectName?: string | undefined;
    /** Gets or sets the formatting options for question, e.g. right, tight (currently just used for checkbox). */
    format?: string | undefined;
    /** Gets or sets the boolean for disabling responses, meaning any response for this question wont be shown in the timeline e.g. tight (currently just used for checkbox). */
    disableResponses?: boolean | undefined;

    constructor(data?: IQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.shortText = _data["shortText"];
            this.number = _data["number"];
            this.displayName = _data["displayName"];
            this.hideNumber = _data["hideNumber"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(AnswerViewModel.fromJS(item));
            }
            this.questionType = _data["questionType"];
            this.subheading = _data["subheading"];
            this.note = _data["note"];
            this.divider = _data["divider"];
            this.mandatory = _data["mandatory"];
            this.goalId = _data["goalId"];
            if (_data["dependsOn"]) {
                this.dependsOn = {} as any;
                for (let key in _data["dependsOn"]) {
                    if (_data["dependsOn"].hasOwnProperty(key))
                        (<any>this.dependsOn)![key] = _data["dependsOn"][key] !== undefined ? _data["dependsOn"][key] : [];
                }
            }
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.snomed = _data["snomed"];
            this.maxAnswers = _data["maxAnswers"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(item);
            }
            this.rowNumber = _data["rowNumber"];
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(item);
            }
            this.rowObjectName = _data["rowObjectName"];
            this.format = _data["format"];
            this.disableResponses = _data["disableResponses"];
        }
    }

    static fromJS(data: any): QuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["shortText"] = this.shortText;
        data["number"] = this.number;
        data["displayName"] = this.displayName;
        data["hideNumber"] = this.hideNumber;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["questionType"] = this.questionType;
        data["subheading"] = this.subheading;
        data["note"] = this.note;
        data["divider"] = this.divider;
        data["mandatory"] = this.mandatory;
        data["goalId"] = this.goalId;
        if (this.dependsOn) {
            data["dependsOn"] = {};
            for (let key in this.dependsOn) {
                if (this.dependsOn.hasOwnProperty(key))
                    (<any>data["dependsOn"])[key] = (<any>this.dependsOn)[key];
            }
        }
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["snomed"] = this.snomed;
        data["maxAnswers"] = this.maxAnswers;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item);
        }
        data["rowNumber"] = this.rowNumber;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item);
        }
        data["rowObjectName"] = this.rowObjectName;
        data["format"] = this.format;
        data["disableResponses"] = this.disableResponses;
        return data;
    }
}

/** The question view model. */
export interface IQuestionViewModel {
    /** Gets or sets the question text. */
    text?: string | undefined;
    /** Gets or sets the short text for the question. */
    shortText?: string | undefined;
    /** Gets or sets the question number. */
    number: number;
    /** Gets or sets the question number or name for display purposes. */
    displayName?: string | undefined;
    /** Gets or sets whether the number should be hidden in the text. */
    hideNumber?: boolean | undefined;
    /** Gets or sets the list of available answers. */
    answers?: AnswerViewModel[] | undefined;
    /** Gets or sets the question type. */
    questionType: QuestionType;
    /** Gets or sets the subheading. */
    subheading?: string | undefined;
    /** Gets or sets a note for the question. */
    note?: string | undefined;
    /** Gets or sets whether a divider is needed. */
    divider?: boolean | undefined;
    /** Gets or sets whether the question is mandatory. */
    mandatory?: boolean | undefined;
    /** Gets or sets the id of the goal that the question is linked to (if applicable). */
    goalId?: number | undefined;
    /** Gets or sets a dictionary of question numbers and their respective answer numbers required for this question to be scored. */
    dependsOn?: { [key: string]: number[]; } | undefined;
    /** Gets or sets the list of labels on the range slider. */
    labels?: string[] | undefined;
    /** Gets or sets a value indicating the SNOMED code for this question. */
    snomed?: string | undefined;
    /** Gets or sets the maximum number of answers for multi buttons and checklists. */
    maxAnswers?: number | undefined;
    /** Gets or sets the list of record names for a table. */
    rows?: string[] | undefined;
    /** Gets or sets the number of rows for a table. */
    rowNumber?: number | undefined;
    /** Gets or sets the column headers for a MultiSelectTable. */
    headers?: string[] | undefined;
    /** Gets or sets the name of the object that row is defining in a MultiSelectorTable, e.g. person, medication etc. */
    rowObjectName?: string | undefined;
    /** Gets or sets the formatting options for question, e.g. right, tight (currently just used for checkbox). */
    format?: string | undefined;
    /** Gets or sets the boolean for disabling responses, meaning any response for this question wont be shown in the timeline e.g. tight (currently just used for checkbox). */
    disableResponses?: boolean | undefined;
}

/** The answer view model. */
export class AnswerViewModel implements IAnswerViewModel {
    /** Gets or sets the answer Number. */
    number?: number | undefined;
    /** Gets or sets the answer text. */
    text?: string | undefined;
    /** Gets or sets the answer score. */
    score?: number | undefined;
    /** Gets or sets the minimum value for the range. */
    rangeMin?: number | undefined;
    /** Gets or sets the maximum value for the range. */
    rangeMax?: number | undefined;
    /** Gets or sets the default value for the range. */
    rangeDefault?: number | undefined;
    /** Gets or sets score cap for number questions where any number is allowed but caps on certain score. */
    scoreCap?: number | undefined;
    /** Gets or sets a value that indicates if a range should step by 1 decimal place. */
    rangeDecimal?: boolean | undefined;
    /** Gets or sets the table question type. */
    tableType!: TableQuestionType;
    /** Gets or sets the table question dropdown choices. */
    tableDropdownChoices?: string[] | undefined;
    /** Gets or sets a value that determines if a answers checkbox is checked. */
    checked?: boolean | undefined;

    constructor(data?: IAnswerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.text = _data["text"];
            this.score = _data["score"];
            this.rangeMin = _data["rangeMin"];
            this.rangeMax = _data["rangeMax"];
            this.rangeDefault = _data["rangeDefault"];
            this.scoreCap = _data["scoreCap"];
            this.rangeDecimal = _data["rangeDecimal"];
            this.tableType = _data["tableType"];
            if (Array.isArray(_data["tableDropdownChoices"])) {
                this.tableDropdownChoices = [] as any;
                for (let item of _data["tableDropdownChoices"])
                    this.tableDropdownChoices!.push(item);
            }
            this.checked = _data["checked"];
        }
    }

    static fromJS(data: any): AnswerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnswerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["text"] = this.text;
        data["score"] = this.score;
        data["rangeMin"] = this.rangeMin;
        data["rangeMax"] = this.rangeMax;
        data["rangeDefault"] = this.rangeDefault;
        data["scoreCap"] = this.scoreCap;
        data["rangeDecimal"] = this.rangeDecimal;
        data["tableType"] = this.tableType;
        if (Array.isArray(this.tableDropdownChoices)) {
            data["tableDropdownChoices"] = [];
            for (let item of this.tableDropdownChoices)
                data["tableDropdownChoices"].push(item);
        }
        data["checked"] = this.checked;
        return data;
    }
}

/** The answer view model. */
export interface IAnswerViewModel {
    /** Gets or sets the answer Number. */
    number?: number | undefined;
    /** Gets or sets the answer text. */
    text?: string | undefined;
    /** Gets or sets the answer score. */
    score?: number | undefined;
    /** Gets or sets the minimum value for the range. */
    rangeMin?: number | undefined;
    /** Gets or sets the maximum value for the range. */
    rangeMax?: number | undefined;
    /** Gets or sets the default value for the range. */
    rangeDefault?: number | undefined;
    /** Gets or sets score cap for number questions where any number is allowed but caps on certain score. */
    scoreCap?: number | undefined;
    /** Gets or sets a value that indicates if a range should step by 1 decimal place. */
    rangeDecimal?: boolean | undefined;
    /** Gets or sets the table question type. */
    tableType: TableQuestionType;
    /** Gets or sets the table question dropdown choices. */
    tableDropdownChoices?: string[] | undefined;
    /** Gets or sets a value that determines if a answers checkbox is checked. */
    checked?: boolean | undefined;
}

/** The type of question to display within a table column. */
export enum TableQuestionType {
    Textbox = 0,
    Number = 1,
    Dropdown = 2,
    Checkbox = 3,
    Date = 4,
}

/** The type of question to display. */
export enum QuestionType {
    Buttons = 0,
    Textbox = 1,
    Range = 2,
    Number = 3,
    ButtonsMulti = 4,
    Date = 5,
    Table = 6,
    Sketch = 7,
    Day = 8,
    SkippableRange = 9,
    MultiSelectorTable = 10,
    Goals = 11,
    DropDown = 12,
    CheckBoxList = 13,
    CheckBoxSingle = 14,
}

/** The scoring total view model. */
export class ScoringLogicViewModel implements IScoringLogicViewModel {
    /** Gets or sets the category name. */
    name?: string | undefined;
    /** Gets or sets the list of questions in the total. */
    questions?: number[] | undefined;
    /** Gets or sets the 2 dimensional list of subscales and their questions to perform local max scoring. */
    maxScoringSubscales?: number[][] | undefined;
    /** Gets or sets a value indicating whether the mean score should be calculated. */
    meanScoring?: boolean | undefined;
    /** Gets or sets a value indicating whether the mean score is to a decimal point. */
    meanScoreDecimal?: boolean | undefined;
    /** Gets or sets a value indicating whether the mean score should be attributed to missing answers. */
    meanScoreMissing?: boolean | undefined;
    /** Gets or sets the min number of responses answered for a valid score. */
    minResponses?: number | undefined;
    /** Gets or sets whether score should be treated as borderline or clinical if it is less than (rather than greater than) the borderline or clinical score. */
    scoreLessThanThreshold?: boolean | undefined;
    /** Gets or sets the threshold for a borderline score. */
    borderlineScore?: number | undefined;
    /** Gets or sets the threshold for a clinical score. */
    clinicalScore?: number | undefined;
    /** Gets or sets the maximum score. */
    maxScore?: number | undefined;
    /** Gets or sets the category type. */
    categoryType!: CategoryType;
    /** Gets or sets the scoring rules relevent to this category. */
    scoreRules?: ScoringTransformationViewModel[] | undefined;
    /** Gets or sets the minimum absolute score that the transformed score can be. */
    minTransformedScore?: number | undefined;
    /** Gets or sets the maximum absolute score that the transformed score can be. */
    maxTransformedScore?: number | undefined;
    /** Gets or sets a value indicating the SNOMED code for this category / subscale. */
    snomed?: string | undefined;
    /** Gets or sets a value indicating the threshold for warning after a number of skipped responses code for this category / subscale. */
    skippedWarningThreshold?: number | undefined;

    constructor(data?: IScoringLogicViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(item);
            }
            if (Array.isArray(_data["maxScoringSubscales"])) {
                this.maxScoringSubscales = [] as any;
                for (let item of _data["maxScoringSubscales"])
                    this.maxScoringSubscales!.push(item);
            }
            this.meanScoring = _data["meanScoring"];
            this.meanScoreDecimal = _data["meanScoreDecimal"];
            this.meanScoreMissing = _data["meanScoreMissing"];
            this.minResponses = _data["minResponses"];
            this.scoreLessThanThreshold = _data["scoreLessThanThreshold"];
            this.borderlineScore = _data["borderlineScore"];
            this.clinicalScore = _data["clinicalScore"];
            this.maxScore = _data["maxScore"];
            this.categoryType = _data["categoryType"];
            if (Array.isArray(_data["scoreRules"])) {
                this.scoreRules = [] as any;
                for (let item of _data["scoreRules"])
                    this.scoreRules!.push(ScoringTransformationViewModel.fromJS(item));
            }
            this.minTransformedScore = _data["minTransformedScore"];
            this.maxTransformedScore = _data["maxTransformedScore"];
            this.snomed = _data["snomed"];
            this.skippedWarningThreshold = _data["skippedWarningThreshold"];
        }
    }

    static fromJS(data: any): ScoringLogicViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringLogicViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item);
        }
        if (Array.isArray(this.maxScoringSubscales)) {
            data["maxScoringSubscales"] = [];
            for (let item of this.maxScoringSubscales)
                data["maxScoringSubscales"].push(item);
        }
        data["meanScoring"] = this.meanScoring;
        data["meanScoreDecimal"] = this.meanScoreDecimal;
        data["meanScoreMissing"] = this.meanScoreMissing;
        data["minResponses"] = this.minResponses;
        data["scoreLessThanThreshold"] = this.scoreLessThanThreshold;
        data["borderlineScore"] = this.borderlineScore;
        data["clinicalScore"] = this.clinicalScore;
        data["maxScore"] = this.maxScore;
        data["categoryType"] = this.categoryType;
        if (Array.isArray(this.scoreRules)) {
            data["scoreRules"] = [];
            for (let item of this.scoreRules)
                data["scoreRules"].push(item.toJSON());
        }
        data["minTransformedScore"] = this.minTransformedScore;
        data["maxTransformedScore"] = this.maxTransformedScore;
        data["snomed"] = this.snomed;
        data["skippedWarningThreshold"] = this.skippedWarningThreshold;
        return data;
    }
}

/** The scoring total view model. */
export interface IScoringLogicViewModel {
    /** Gets or sets the category name. */
    name?: string | undefined;
    /** Gets or sets the list of questions in the total. */
    questions?: number[] | undefined;
    /** Gets or sets the 2 dimensional list of subscales and their questions to perform local max scoring. */
    maxScoringSubscales?: number[][] | undefined;
    /** Gets or sets a value indicating whether the mean score should be calculated. */
    meanScoring?: boolean | undefined;
    /** Gets or sets a value indicating whether the mean score is to a decimal point. */
    meanScoreDecimal?: boolean | undefined;
    /** Gets or sets a value indicating whether the mean score should be attributed to missing answers. */
    meanScoreMissing?: boolean | undefined;
    /** Gets or sets the min number of responses answered for a valid score. */
    minResponses?: number | undefined;
    /** Gets or sets whether score should be treated as borderline or clinical if it is less than (rather than greater than) the borderline or clinical score. */
    scoreLessThanThreshold?: boolean | undefined;
    /** Gets or sets the threshold for a borderline score. */
    borderlineScore?: number | undefined;
    /** Gets or sets the threshold for a clinical score. */
    clinicalScore?: number | undefined;
    /** Gets or sets the maximum score. */
    maxScore?: number | undefined;
    /** Gets or sets the category type. */
    categoryType: CategoryType;
    /** Gets or sets the scoring rules relevent to this category. */
    scoreRules?: ScoringTransformationViewModel[] | undefined;
    /** Gets or sets the minimum absolute score that the transformed score can be. */
    minTransformedScore?: number | undefined;
    /** Gets or sets the maximum absolute score that the transformed score can be. */
    maxTransformedScore?: number | undefined;
    /** Gets or sets a value indicating the SNOMED code for this category / subscale. */
    snomed?: string | undefined;
    /** Gets or sets a value indicating the threshold for warning after a number of skipped responses code for this category / subscale. */
    skippedWarningThreshold?: number | undefined;
}

/** The category type for questionnaire scoring. */
export enum CategoryType {
    Subscale = 0,
    Total = 1,
    Scale = 2,
}

/** The scoring view model. */
export class ScoringTransformationViewModel implements IScoringTransformationViewModel {
    /** Gets or sets the list of categories. */
    rules?: ScoringRuleViewModel[] | undefined;
    /** Gets or sets the rule operator. */
    operator?: ScoringRuleOperator | undefined;
    /** Gets or sets the transformed scores. */
    transformation?: number[] | undefined;
    /** Gets or sets a value indicating whether a graph should be added for a tscore. */
    hideGraph!: boolean;
    /** Gets or sets a score that overrides the borderline score. */
    borderlineOverride?: number | undefined;
    /** Gets or sets a score that overrides the clinical score. */
    clinicalOverride?: number | undefined;

    constructor(data?: IScoringTransformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ScoringRuleViewModel.fromJS(item));
            }
            this.operator = _data["operator"];
            if (Array.isArray(_data["transformation"])) {
                this.transformation = [] as any;
                for (let item of _data["transformation"])
                    this.transformation!.push(item);
            }
            this.hideGraph = _data["hideGraph"];
            this.borderlineOverride = _data["borderlineOverride"];
            this.clinicalOverride = _data["clinicalOverride"];
        }
    }

    static fromJS(data: any): ScoringTransformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringTransformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        data["operator"] = this.operator;
        if (Array.isArray(this.transformation)) {
            data["transformation"] = [];
            for (let item of this.transformation)
                data["transformation"].push(item);
        }
        data["hideGraph"] = this.hideGraph;
        data["borderlineOverride"] = this.borderlineOverride;
        data["clinicalOverride"] = this.clinicalOverride;
        return data;
    }
}

/** The scoring view model. */
export interface IScoringTransformationViewModel {
    /** Gets or sets the list of categories. */
    rules?: ScoringRuleViewModel[] | undefined;
    /** Gets or sets the rule operator. */
    operator?: ScoringRuleOperator | undefined;
    /** Gets or sets the transformed scores. */
    transformation?: number[] | undefined;
    /** Gets or sets a value indicating whether a graph should be added for a tscore. */
    hideGraph: boolean;
    /** Gets or sets a score that overrides the borderline score. */
    borderlineOverride?: number | undefined;
    /** Gets or sets a score that overrides the clinical score. */
    clinicalOverride?: number | undefined;
}

/** The scoring rule view model. */
export class ScoringRuleViewModel implements IScoringRuleViewModel {
    /** Gets or sets the question the rule applies to. */
    question?: number | undefined;
    /** Gets or sets the expected answer for the rule. */
    answer?: string | undefined;
    /** Gets or sets the comparison operator to evaluate the rule with. */
    operator?: ScoringRuleOperator | undefined;

    constructor(data?: IScoringRuleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.operator = _data["operator"];
        }
    }

    static fromJS(data: any): ScoringRuleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScoringRuleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["operator"] = this.operator;
        return data;
    }
}

/** The scoring rule view model. */
export interface IScoringRuleViewModel {
    /** Gets or sets the question the rule applies to. */
    question?: number | undefined;
    /** Gets or sets the expected answer for the rule. */
    answer?: string | undefined;
    /** Gets or sets the comparison operator to evaluate the rule with. */
    operator?: ScoringRuleOperator | undefined;
}

/** The scoring rule operators. */
export enum ScoringRuleOperator {
    And = 0,
    Or = 1,
}

/** The patient dashboard options for a given questionnaire. */
export class PatientDashboardOptionsViewModel implements IPatientDashboardOptionsViewModel {
    /** Gets or sets the disclaimer text for the patient dashboard questionnaire options. */
    disclaimerText?: string | undefined;
    /** Gets or sets the clear settings for the patient dashboard questionnaire options. */
    clearRegion?: PatientDashboardRegionOptionsViewModel | undefined;
    /** Gets or sets the stable settings for the patient dashboard questionnaire options. */
    stableRegion?: PatientDashboardRegionOptionsViewModel | undefined;
    /** Gets or sets the borderline settings for the patient dashboard questionnaire options. */
    borderlineRegion?: PatientDashboardRegionOptionsViewModel | undefined;
    /** Gets or sets the clinical settings for the patient dashboard questionnaire options. */
    clinicalRegion?: PatientDashboardRegionOptionsViewModel | undefined;

    constructor(data?: IPatientDashboardOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disclaimerText = _data["disclaimerText"];
            this.clearRegion = _data["clearRegion"] ? PatientDashboardRegionOptionsViewModel.fromJS(_data["clearRegion"]) : <any>undefined;
            this.stableRegion = _data["stableRegion"] ? PatientDashboardRegionOptionsViewModel.fromJS(_data["stableRegion"]) : <any>undefined;
            this.borderlineRegion = _data["borderlineRegion"] ? PatientDashboardRegionOptionsViewModel.fromJS(_data["borderlineRegion"]) : <any>undefined;
            this.clinicalRegion = _data["clinicalRegion"] ? PatientDashboardRegionOptionsViewModel.fromJS(_data["clinicalRegion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientDashboardOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDashboardOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disclaimerText"] = this.disclaimerText;
        data["clearRegion"] = this.clearRegion ? this.clearRegion.toJSON() : <any>undefined;
        data["stableRegion"] = this.stableRegion ? this.stableRegion.toJSON() : <any>undefined;
        data["borderlineRegion"] = this.borderlineRegion ? this.borderlineRegion.toJSON() : <any>undefined;
        data["clinicalRegion"] = this.clinicalRegion ? this.clinicalRegion.toJSON() : <any>undefined;
        return data;
    }
}

/** The patient dashboard options for a given questionnaire. */
export interface IPatientDashboardOptionsViewModel {
    /** Gets or sets the disclaimer text for the patient dashboard questionnaire options. */
    disclaimerText?: string | undefined;
    /** Gets or sets the clear settings for the patient dashboard questionnaire options. */
    clearRegion?: PatientDashboardRegionOptionsViewModel | undefined;
    /** Gets or sets the stable settings for the patient dashboard questionnaire options. */
    stableRegion?: PatientDashboardRegionOptionsViewModel | undefined;
    /** Gets or sets the borderline settings for the patient dashboard questionnaire options. */
    borderlineRegion?: PatientDashboardRegionOptionsViewModel | undefined;
    /** Gets or sets the clinical settings for the patient dashboard questionnaire options. */
    clinicalRegion?: PatientDashboardRegionOptionsViewModel | undefined;
}

/** The patient dashboard region options for the tenancy. */
export class PatientDashboardRegionOptionsViewModel implements IPatientDashboardRegionOptionsViewModel {
    /** Gets or sets the required score for this region. */
    score!: number;
    /** Gets or sets the required score text for this region. */
    scoreText?: string | undefined;
    /** Gets or sets the required info text for this region. */
    infoText?: string | undefined;

    constructor(data?: IPatientDashboardRegionOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.scoreText = _data["scoreText"];
            this.infoText = _data["infoText"];
        }
    }

    static fromJS(data: any): PatientDashboardRegionOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDashboardRegionOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["scoreText"] = this.scoreText;
        data["infoText"] = this.infoText;
        return data;
    }
}

/** The patient dashboard region options for the tenancy. */
export interface IPatientDashboardRegionOptionsViewModel {
    /** Gets or sets the required score for this region. */
    score: number;
    /** Gets or sets the required score text for this region. */
    scoreText?: string | undefined;
    /** Gets or sets the required info text for this region. */
    infoText?: string | undefined;
}

export class ValueTupleOfQuestionnaireViewModelAndNullableDouble implements IValueTupleOfQuestionnaireViewModelAndNullableDouble {
    item1!: QuestionnaireViewModel;
    item2?: number | undefined;

    constructor(data?: IValueTupleOfQuestionnaireViewModelAndNullableDouble) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.item1 = new QuestionnaireViewModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"] ? QuestionnaireViewModel.fromJS(_data["item1"]) : new QuestionnaireViewModel();
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfQuestionnaireViewModelAndNullableDouble {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfQuestionnaireViewModelAndNullableDouble();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1 ? this.item1.toJSON() : <any>undefined;
        data["item2"] = this.item2;
        return data;
    }
}

export interface IValueTupleOfQuestionnaireViewModelAndNullableDouble {
    item1: QuestionnaireViewModel;
    item2?: number | undefined;
}

/** Errors linked to tenancy options. */
export enum TenancyOptionErrors {
    TenancyNotSupported = 0,
    InvalidModel = 1,
}

/** View model for DatasetViewModel entity. */
export class DatasetViewModel extends ViewModelBase implements IDatasetViewModel {
    /** Gets or sets the name of the dataset. */
    name?: string | undefined;

    constructor(data?: IDatasetViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DatasetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

/** View model for DatasetViewModel entity. */
export interface IDatasetViewModel extends IViewModelBase {
    /** Gets or sets the name of the dataset. */
    name?: string | undefined;
}

/** View model detailing measurement. */
export class MeasurementViewModel extends ViewModelBase implements IMeasurementViewModel {
    /** Gets or sets the name of the measurement. */
    name?: string | undefined;
    /** Gets or sets the min measurement. */
    minMeasurement!: number;
    /** Gets or sets the max measurement. */
    maxMeasurement?: number | undefined;
    /** Gets or sets the dataset Id. */
    datasetId!: number;

    constructor(data?: IMeasurementViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.minMeasurement = _data["minMeasurement"];
            this.maxMeasurement = _data["maxMeasurement"];
            this.datasetId = _data["datasetId"];
        }
    }

    static fromJS(data: any): MeasurementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["minMeasurement"] = this.minMeasurement;
        data["maxMeasurement"] = this.maxMeasurement;
        data["datasetId"] = this.datasetId;
        super.toJSON(data);
        return data;
    }
}

/** View model detailing measurement. */
export interface IMeasurementViewModel extends IViewModelBase {
    /** Gets or sets the name of the measurement. */
    name?: string | undefined;
    /** Gets or sets the min measurement. */
    minMeasurement: number;
    /** Gets or sets the max measurement. */
    maxMeasurement?: number | undefined;
    /** Gets or sets the dataset Id. */
    datasetId: number;
}

/** The monitoring status of a schedule. */
export enum MonitoringStatus {
    Active = 0,
    Archived = 1,
    Suspended = 2,
    ArchivedDueToMissedResponses = 3,
    ArchivedDueToEndDateReached = 4,
    Completed = 5,
    ArchivedDueToPatientRemovalFromCaseload = 6,
}

/** Duration till schedule has gone stale. */
export enum StaleDuration {
    Never = 0,
    SixMonths = 1,
    TwelveMonths = 2,
}

/** Defines a goal. */
export class GoalViewModel extends ViewModelBase implements IGoalViewModel {
    /** Gets or sets the id of the patient whom the goal belongs to. */
    patientId!: number;
    /** Gets or sets the id of the caseload that the goal is assigned to. */
    caseloadId!: number;
    /** Gets or sets the caseload. */
    caseload?: CaseloadViewModel | undefined;
    /** Gets or sets the question for the goal. */
    question?: string | undefined;
    /** Gets or sets the last response date for the goal. */
    lastResponse?: Date | undefined;
    /** Gets or sets the last response value for the goal. */
    lastResponseValue?: number | undefined;
    /** Gets or sets the token needed to respond to the goal. */
    accessToken?: string | undefined;
    /** Gets or sets the id of the prompt schedule to use (if applicable). */
    promptScheduleId?: number | undefined;
    /** Gets or sets the prompt schedule to use (if applicable). */
    promptSchedule?: PromptScheduleViewModel | undefined;
    /** Gets or sets the monitoring status of the goal. */
    monitoringStatus!: MonitoringStatus;
    /** Gets or sets the owner of the goal. */
    owner!: GoalOwner;
    /** Gets or sets the DateTime that the goal was last prompted for if applicable. */
    lastPrompted?: Date | undefined;
    /** Gets or sets the StaffId of the staff who created the goal. */
    staffId?: number | undefined;
    /** Gets or sets questionnaire id for goals made from questionnaire. */
    questionnaireId?: number | undefined;

    constructor(data?: IGoalViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.caseloadId = _data["caseloadId"];
            this.caseload = _data["caseload"] ? CaseloadViewModel.fromJS(_data["caseload"]) : <any>undefined;
            this.question = _data["question"];
            this.lastResponse = _data["lastResponse"] ? new Date(_data["lastResponse"].toString()) : <any>undefined;
            this.lastResponseValue = _data["lastResponseValue"];
            this.accessToken = _data["accessToken"];
            this.promptScheduleId = _data["promptScheduleId"];
            this.promptSchedule = _data["promptSchedule"] ? PromptScheduleViewModel.fromJS(_data["promptSchedule"]) : <any>undefined;
            this.monitoringStatus = _data["monitoringStatus"];
            this.owner = _data["owner"];
            this.lastPrompted = _data["lastPrompted"] ? new Date(_data["lastPrompted"].toString()) : <any>undefined;
            this.staffId = _data["staffId"];
            this.questionnaireId = _data["questionnaireId"];
        }
    }

    static fromJS(data: any): GoalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GoalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["caseloadId"] = this.caseloadId;
        data["caseload"] = this.caseload ? this.caseload.toJSON() : <any>undefined;
        data["question"] = this.question;
        data["lastResponse"] = this.lastResponse ? this.lastResponse.toISOString() : <any>undefined;
        data["lastResponseValue"] = this.lastResponseValue;
        data["accessToken"] = this.accessToken;
        data["promptScheduleId"] = this.promptScheduleId;
        data["promptSchedule"] = this.promptSchedule ? this.promptSchedule.toJSON() : <any>undefined;
        data["monitoringStatus"] = this.monitoringStatus;
        data["owner"] = this.owner;
        data["lastPrompted"] = this.lastPrompted ? this.lastPrompted.toISOString() : <any>undefined;
        data["staffId"] = this.staffId;
        data["questionnaireId"] = this.questionnaireId;
        super.toJSON(data);
        return data;
    }
}

/** Defines a goal. */
export interface IGoalViewModel extends IViewModelBase {
    /** Gets or sets the id of the patient whom the goal belongs to. */
    patientId: number;
    /** Gets or sets the id of the caseload that the goal is assigned to. */
    caseloadId: number;
    /** Gets or sets the caseload. */
    caseload?: CaseloadViewModel | undefined;
    /** Gets or sets the question for the goal. */
    question?: string | undefined;
    /** Gets or sets the last response date for the goal. */
    lastResponse?: Date | undefined;
    /** Gets or sets the last response value for the goal. */
    lastResponseValue?: number | undefined;
    /** Gets or sets the token needed to respond to the goal. */
    accessToken?: string | undefined;
    /** Gets or sets the id of the prompt schedule to use (if applicable). */
    promptScheduleId?: number | undefined;
    /** Gets or sets the prompt schedule to use (if applicable). */
    promptSchedule?: PromptScheduleViewModel | undefined;
    /** Gets or sets the monitoring status of the goal. */
    monitoringStatus: MonitoringStatus;
    /** Gets or sets the owner of the goal. */
    owner: GoalOwner;
    /** Gets or sets the DateTime that the goal was last prompted for if applicable. */
    lastPrompted?: Date | undefined;
    /** Gets or sets the StaffId of the staff who created the goal. */
    staffId?: number | undefined;
    /** Gets or sets questionnaire id for goals made from questionnaire. */
    questionnaireId?: number | undefined;
}

/** Defines a schedule. */
export class PromptScheduleViewModel extends ViewModelBase implements IPromptScheduleViewModel {
    /** Gets or sets the frequency in which the user should be prompted. */
    frequency?: PromptFrequency | undefined;
    /** Gets or sets the days of the week that the user should be prompted. */
    daysOfWeek?: Day[] | undefined;
    /** Gets or sets the time of day that the user should be prompted. */
    timeOfDay?: string | undefined;
    /** Gets or sets the day of the month that the user should be prompted. */
    dayOfMonth?: number | undefined;
    /** Gets or sets the place in the month that the user should be prompted. */
    monthPlace?: MonthPlace | undefined;
    /** Gets or sets the number of prompts before being archived. */
    archivesAfter?: number | undefined;
    /** Gets or sets how the archive count should be worked out. */
    archiveCountType?: ArchiveCountType | undefined;
    /** Gets or sets number of times prompt was ignored. */
    timesIgnored?: number | undefined;
    /** Gets or sets QuestionnaireResponseAccessToken. */
    questionnaireResponseAccessToken?: string | undefined;
    /** Gets or sets frequency amount for example every x months. */
    frequencyAmount!: number;

    constructor(data?: IPromptScheduleViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.frequency = _data["frequency"];
            if (Array.isArray(_data["daysOfWeek"])) {
                this.daysOfWeek = [] as any;
                for (let item of _data["daysOfWeek"])
                    this.daysOfWeek!.push(item);
            }
            this.timeOfDay = _data["timeOfDay"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.monthPlace = _data["monthPlace"];
            this.archivesAfter = _data["archivesAfter"];
            this.archiveCountType = _data["archiveCountType"];
            this.timesIgnored = _data["timesIgnored"];
            this.questionnaireResponseAccessToken = _data["questionnaireResponseAccessToken"];
            this.frequencyAmount = _data["frequencyAmount"];
        }
    }

    static fromJS(data: any): PromptScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PromptScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frequency"] = this.frequency;
        if (Array.isArray(this.daysOfWeek)) {
            data["daysOfWeek"] = [];
            for (let item of this.daysOfWeek)
                data["daysOfWeek"].push(item);
        }
        data["timeOfDay"] = this.timeOfDay;
        data["dayOfMonth"] = this.dayOfMonth;
        data["monthPlace"] = this.monthPlace;
        data["archivesAfter"] = this.archivesAfter;
        data["archiveCountType"] = this.archiveCountType;
        data["timesIgnored"] = this.timesIgnored;
        data["questionnaireResponseAccessToken"] = this.questionnaireResponseAccessToken;
        data["frequencyAmount"] = this.frequencyAmount;
        super.toJSON(data);
        return data;
    }
}

/** Defines a schedule. */
export interface IPromptScheduleViewModel extends IViewModelBase {
    /** Gets or sets the frequency in which the user should be prompted. */
    frequency?: PromptFrequency | undefined;
    /** Gets or sets the days of the week that the user should be prompted. */
    daysOfWeek?: Day[] | undefined;
    /** Gets or sets the time of day that the user should be prompted. */
    timeOfDay?: string | undefined;
    /** Gets or sets the day of the month that the user should be prompted. */
    dayOfMonth?: number | undefined;
    /** Gets or sets the place in the month that the user should be prompted. */
    monthPlace?: MonthPlace | undefined;
    /** Gets or sets the number of prompts before being archived. */
    archivesAfter?: number | undefined;
    /** Gets or sets how the archive count should be worked out. */
    archiveCountType?: ArchiveCountType | undefined;
    /** Gets or sets number of times prompt was ignored. */
    timesIgnored?: number | undefined;
    /** Gets or sets QuestionnaireResponseAccessToken. */
    questionnaireResponseAccessToken?: string | undefined;
    /** Gets or sets frequency amount for example every x months. */
    frequencyAmount: number;
}

/** The frequency inwhich a prompt should be triggered. */
export enum PromptFrequency {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
}

/** The monitoring status of a schedule. */
export enum Day {
    Monday = 0,
    Tuesday = 1,
    Wednesday = 2,
    Thursday = 3,
    Friday = 4,
    Saturday = 5,
    Sunday = 6,
}

/** The occurance within the month. */
export enum MonthPlace {
    First = 0,
    Second = 1,
    Third = 2,
    Fourth = 3,
    Last = 4,
}

/** The count type to archive a prompt with. */
export enum ArchiveCountType {
    TotalMissedResponses = 0,
    ConsecutiveMissedResponses = 1,
}

/** The owner of a goal. */
export enum GoalOwner {
    Patient = 0,
    ParentCarer = 1,
}

/** Defines a goal response. */
export class GoalResponseViewModel extends ViewModelBase implements IGoalResponseViewModel {
    /** Gets or sets the id of the patient whom the goal belongs to. */
    patientId!: number;
    /** Gets or sets the id of the caseload that the goal is assigned to. */
    caseloadId!: number;
    /** Gets or sets the caseload. */
    caseload?: CaseloadViewModel | undefined;
    /** Gets or sets the goal id. */
    goalId?: number | undefined;
    /** Gets or sets the goal. */
    goal?: GoalViewModel | undefined;
    /** Gets or sets the response to the goal. */
    response!: number;
    /** Gets or sets submitted date. This will be set in cases where response date is amended. */
    completedDate?: Date | undefined;
    /** Gets or sets interoperability goal information. */
    interoperability?: InteroperabilityGoalViewModal | undefined;
    /** Gets or sets interoperability goal submission date time. */
    interoperabilitySubmitted?: Date | undefined;

    constructor(data?: IGoalResponseViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.caseloadId = _data["caseloadId"];
            this.caseload = _data["caseload"] ? CaseloadViewModel.fromJS(_data["caseload"]) : <any>undefined;
            this.goalId = _data["goalId"];
            this.goal = _data["goal"] ? GoalViewModel.fromJS(_data["goal"]) : <any>undefined;
            this.response = _data["response"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.interoperability = _data["interoperability"] ? InteroperabilityGoalViewModal.fromJS(_data["interoperability"]) : <any>undefined;
            this.interoperabilitySubmitted = _data["interoperabilitySubmitted"] ? new Date(_data["interoperabilitySubmitted"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GoalResponseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GoalResponseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["caseloadId"] = this.caseloadId;
        data["caseload"] = this.caseload ? this.caseload.toJSON() : <any>undefined;
        data["goalId"] = this.goalId;
        data["goal"] = this.goal ? this.goal.toJSON() : <any>undefined;
        data["response"] = this.response;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["interoperability"] = this.interoperability ? this.interoperability.toJSON() : <any>undefined;
        data["interoperabilitySubmitted"] = this.interoperabilitySubmitted ? this.interoperabilitySubmitted.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Defines a goal response. */
export interface IGoalResponseViewModel extends IViewModelBase {
    /** Gets or sets the id of the patient whom the goal belongs to. */
    patientId: number;
    /** Gets or sets the id of the caseload that the goal is assigned to. */
    caseloadId: number;
    /** Gets or sets the caseload. */
    caseload?: CaseloadViewModel | undefined;
    /** Gets or sets the goal id. */
    goalId?: number | undefined;
    /** Gets or sets the goal. */
    goal?: GoalViewModel | undefined;
    /** Gets or sets the response to the goal. */
    response: number;
    /** Gets or sets submitted date. This will be set in cases where response date is amended. */
    completedDate?: Date | undefined;
    /** Gets or sets interoperability goal information. */
    interoperability?: InteroperabilityGoalViewModal | undefined;
    /** Gets or sets interoperability goal submission date time. */
    interoperabilitySubmitted?: Date | undefined;
}

/** The base interoperability view model. */
export class InteroperabilityViewModal implements IInteroperabilityViewModal {
    /** Gets or sets id of the response. */
    id?: number | undefined;
    /** Gets or sets patient id of the response. */
    patientId?: string | undefined;
    /** Gets or sets title of the response. */
    title?: string | undefined;
    /** Gets or sets type of response, either "Questionnaire" or "Goal". */
    type?: string | undefined;
    /** Gets or sets the datetime of submission. */
    submitted?: Date | undefined;
    /** Gets or sets if the response has been deleted. */
    active?: boolean | undefined;
    /** Gets or sets the id of the questionnaire being completed. */
    questionnaireId?: number | undefined;

    constructor(data?: IInteroperabilityViewModal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.patientId = _data["patientId"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.submitted = _data["submitted"] ? new Date(_data["submitted"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.questionnaireId = _data["questionnaireId"];
        }
    }

    static fromJS(data: any): InteroperabilityViewModal {
        data = typeof data === 'object' ? data : {};
        let result = new InteroperabilityViewModal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["patientId"] = this.patientId;
        data["title"] = this.title;
        data["type"] = this.type;
        data["submitted"] = this.submitted ? this.submitted.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["questionnaireId"] = this.questionnaireId;
        return data;
    }
}

/** The base interoperability view model. */
export interface IInteroperabilityViewModal {
    /** Gets or sets id of the response. */
    id?: number | undefined;
    /** Gets or sets patient id of the response. */
    patientId?: string | undefined;
    /** Gets or sets title of the response. */
    title?: string | undefined;
    /** Gets or sets type of response, either "Questionnaire" or "Goal". */
    type?: string | undefined;
    /** Gets or sets the datetime of submission. */
    submitted?: Date | undefined;
    /** Gets or sets if the response has been deleted. */
    active?: boolean | undefined;
    /** Gets or sets the id of the questionnaire being completed. */
    questionnaireId?: number | undefined;
}

/** The goal response interoperability view model. */
export class InteroperabilityGoalViewModal extends InteroperabilityViewModal implements IInteroperabilityGoalViewModal {
    /** Gets or sets goal response. */
    response!: number;

    constructor(data?: IInteroperabilityGoalViewModal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): InteroperabilityGoalViewModal {
        data = typeof data === 'object' ? data : {};
        let result = new InteroperabilityGoalViewModal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["response"] = this.response;
        super.toJSON(data);
        return data;
    }
}

/** The goal response interoperability view model. */
export interface IInteroperabilityGoalViewModal extends IInteroperabilityViewModal {
    /** Gets or sets goal response. */
    response: number;
}

/** Defines the LineGraphDataViewModel. */
export class LineGraphDataViewModel implements ILineGraphDataViewModel {
    /** Gets or sets the line data for the summary graph. */
    lines?: LineViewModel[] | undefined;

    constructor(data?: ILineGraphDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(LineViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LineGraphDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LineGraphDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines the LineGraphDataViewModel. */
export interface ILineGraphDataViewModel {
    /** Gets or sets the line data for the summary graph. */
    lines?: LineViewModel[] | undefined;
}

/** Defines the LineViewModel. */
export class LineViewModel implements ILineViewModel {
    /** Gets or sets the name of the line. */
    lineName?: string | undefined;
    /** Gets or sets a value indicating whether the line is completed or not. */
    completed?: boolean | undefined;
    /** Gets or sets the line id referring to the questionnaire id. */
    lineId?: number | undefined;
    /** Gets or sets the maximum score for the questionnaire. */
    maxScore!: number;
    /** Gets or sets the data for the line. */
    data?: DataPointViewModel[] | undefined;
    /** Gets or sets the data for the versions of the questionnaire if applicable. */
    versions?: DataPointViewModel[] | undefined;
    /** Gets or sets the data for incomplete responses. */
    noResponseData?: DataPointViewModel[] | undefined;

    constructor(data?: ILineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineName = _data["lineName"];
            this.completed = _data["completed"];
            this.lineId = _data["lineId"];
            this.maxScore = _data["maxScore"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DataPointViewModel.fromJS(item));
            }
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(DataPointViewModel.fromJS(item));
            }
            if (Array.isArray(_data["noResponseData"])) {
                this.noResponseData = [] as any;
                for (let item of _data["noResponseData"])
                    this.noResponseData!.push(DataPointViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineName"] = this.lineName;
        data["completed"] = this.completed;
        data["lineId"] = this.lineId;
        data["maxScore"] = this.maxScore;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        if (Array.isArray(this.noResponseData)) {
            data["noResponseData"] = [];
            for (let item of this.noResponseData)
                data["noResponseData"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines the LineViewModel. */
export interface ILineViewModel {
    /** Gets or sets the name of the line. */
    lineName?: string | undefined;
    /** Gets or sets a value indicating whether the line is completed or not. */
    completed?: boolean | undefined;
    /** Gets or sets the line id referring to the questionnaire id. */
    lineId?: number | undefined;
    /** Gets or sets the maximum score for the questionnaire. */
    maxScore: number;
    /** Gets or sets the data for the line. */
    data?: DataPointViewModel[] | undefined;
    /** Gets or sets the data for the versions of the questionnaire if applicable. */
    versions?: DataPointViewModel[] | undefined;
    /** Gets or sets the data for incomplete responses. */
    noResponseData?: DataPointViewModel[] | undefined;
}

/** Defines the DataPointViewModel. */
export class DataPointViewModel implements IDataPointViewModel {
    /** Gets or sets the x value of the data point. */
    x?: Date | undefined;
    /** Gets or sets the y value of the data point. */
    y!: number;

    constructor(data?: IDataPointViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] ? new Date(_data["x"].toString()) : <any>undefined;
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): DataPointViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataPointViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x ? this.x.toISOString() : <any>undefined;
        data["y"] = this.y;
        return data;
    }
}

/** Defines the DataPointViewModel. */
export interface IDataPointViewModel {
    /** Gets or sets the x value of the data point. */
    x?: Date | undefined;
    /** Gets or sets the y value of the data point. */
    y: number;
}

/** Defines the SymptomsGraphDataViewModel. */
export class SymptomsGraphDataViewModel implements ISymptomsGraphDataViewModel {
    /** Gets or sets the symptoms data for the graph. */
    lines?: SymptomsBubbleViewModel[] | undefined;

    constructor(data?: ISymptomsGraphDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SymptomsBubbleViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SymptomsGraphDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SymptomsGraphDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines the SymptomsGraphDataViewModel. */
export interface ISymptomsGraphDataViewModel {
    /** Gets or sets the symptoms data for the graph. */
    lines?: SymptomsBubbleViewModel[] | undefined;
}

/** Defines the SymptomsBubbleViewModel. */
export class SymptomsBubbleViewModel implements ISymptomsBubbleViewModel {
    /** Gets or sets the name of the chart. */
    chartName?: string | undefined;
    /** Gets or sets the data for the bubble chart. */
    data?: SymptomsDataPointViewModel[] | undefined;
    /** Gets or sets the data for the versions of the questionnaire if applicable. */
    versions?: DataPointViewModel[] | undefined;

    constructor(data?: ISymptomsBubbleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartName = _data["chartName"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SymptomsDataPointViewModel.fromJS(item));
            }
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(DataPointViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SymptomsBubbleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SymptomsBubbleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartName"] = this.chartName;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines the SymptomsBubbleViewModel. */
export interface ISymptomsBubbleViewModel {
    /** Gets or sets the name of the chart. */
    chartName?: string | undefined;
    /** Gets or sets the data for the bubble chart. */
    data?: SymptomsDataPointViewModel[] | undefined;
    /** Gets or sets the data for the versions of the questionnaire if applicable. */
    versions?: DataPointViewModel[] | undefined;
}

/** Defines the SymptomsDataPointViewModel. */
export class SymptomsDataPointViewModel implements ISymptomsDataPointViewModel {
    /** Gets or sets the x value of the data point. */
    x?: Date | undefined;
    /** Gets or sets the y value of the data point. */
    y?: string | undefined;
    /** Gets or sets the size of the data point. */
    size!: number;
    /** Gets or sets the score for the data point. */
    score!: number;
    /** Gets or sets the total score for the data point. */
    totalScore!: number;

    constructor(data?: ISymptomsDataPointViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] ? new Date(_data["x"].toString()) : <any>undefined;
            this.y = _data["y"];
            this.size = _data["size"];
            this.score = _data["score"];
            this.totalScore = _data["totalScore"];
        }
    }

    static fromJS(data: any): SymptomsDataPointViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SymptomsDataPointViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x ? this.x.toISOString() : <any>undefined;
        data["y"] = this.y;
        data["size"] = this.size;
        data["score"] = this.score;
        data["totalScore"] = this.totalScore;
        return data;
    }
}

/** Defines the SymptomsDataPointViewModel. */
export interface ISymptomsDataPointViewModel {
    /** Gets or sets the x value of the data point. */
    x?: Date | undefined;
    /** Gets or sets the y value of the data point. */
    y?: string | undefined;
    /** Gets or sets the size of the data point. */
    size: number;
    /** Gets or sets the score for the data point. */
    score: number;
    /** Gets or sets the total score for the data point. */
    totalScore: number;
}

/** Defines the LineGraphDataViewModel. */
export class MedicationLineGraphDataViewModel implements IMedicationLineGraphDataViewModel {
    /** Gets or sets the line data for the summary graph. */
    lines?: MedicationLineViewModel[] | undefined;

    constructor(data?: IMedicationLineGraphDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(MedicationLineViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationLineGraphDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationLineGraphDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines the LineGraphDataViewModel. */
export interface IMedicationLineGraphDataViewModel {
    /** Gets or sets the line data for the summary graph. */
    lines?: MedicationLineViewModel[] | undefined;
}

/** Defines the MedicationLineViewModel. */
export class MedicationLineViewModel implements IMedicationLineViewModel {
    /** Gets or sets the name of the line. */
    lineName?: string | undefined;
    /** Gets or sets the colour of the line. */
    colour?: string | undefined;
    /** Gets or sets the line id referring to the questionnaire id. */
    lineId?: number | undefined;
    /** Gets or sets the data for the line. */
    data?: MedicationDataPointViewModel[] | undefined;

    constructor(data?: IMedicationLineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineName = _data["lineName"];
            this.colour = _data["colour"];
            this.lineId = _data["lineId"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(MedicationDataPointViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MedicationLineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationLineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineName"] = this.lineName;
        data["colour"] = this.colour;
        data["lineId"] = this.lineId;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

/** Defines the MedicationLineViewModel. */
export interface IMedicationLineViewModel {
    /** Gets or sets the name of the line. */
    lineName?: string | undefined;
    /** Gets or sets the colour of the line. */
    colour?: string | undefined;
    /** Gets or sets the line id referring to the questionnaire id. */
    lineId?: number | undefined;
    /** Gets or sets the data for the line. */
    data?: MedicationDataPointViewModel[] | undefined;
}

/** Defines the MedicationDataPointViewModel. */
export class MedicationDataPointViewModel implements IMedicationDataPointViewModel {
    /** Gets or sets the x value of the data point. */
    x?: Date | undefined;
    /** Gets or sets the y value of the data point. */
    y?: string | undefined;
    /** Gets or sets the status of the medication. */
    status?: MedicationStatus | undefined;

    constructor(data?: IMedicationDataPointViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"] ? new Date(_data["x"].toString()) : <any>undefined;
            this.y = _data["y"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MedicationDataPointViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationDataPointViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x ? this.x.toISOString() : <any>undefined;
        data["y"] = this.y;
        data["status"] = this.status;
        return data;
    }
}

/** Defines the MedicationDataPointViewModel. */
export interface IMedicationDataPointViewModel {
    /** Gets or sets the x value of the data point. */
    x?: Date | undefined;
    /** Gets or sets the y value of the data point. */
    y?: string | undefined;
    /** Gets or sets the status of the medication. */
    status?: MedicationStatus | undefined;
}

/** The status of the medication. */
export enum MedicationStatus {
    Start = 0,
    Ongoing = 1,
    End = 2,
}

/** View model detailing medication. */
export class MedicationViewModel extends ViewModelBase implements IMedicationViewModel {
    /** Gets or sets the name of the medication. */
    name?: string | undefined;
    /** Gets or sets the units of the medication. */
    units?: string | undefined;
    /** Gets or sets the min dosage of the medication. */
    minDosage!: number;
    /** Gets or sets the max dosage of the medication. */
    maxDosage!: number;
    /** Gets or sets the medication category Id. */
    medicationCategoryId!: number;

    constructor(data?: IMedicationViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.units = _data["units"];
            this.minDosage = _data["minDosage"];
            this.maxDosage = _data["maxDosage"];
            this.medicationCategoryId = _data["medicationCategoryId"];
        }
    }

    static fromJS(data: any): MedicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["units"] = this.units;
        data["minDosage"] = this.minDosage;
        data["maxDosage"] = this.maxDosage;
        data["medicationCategoryId"] = this.medicationCategoryId;
        super.toJSON(data);
        return data;
    }
}

/** View model detailing medication. */
export interface IMedicationViewModel extends IViewModelBase {
    /** Gets or sets the name of the medication. */
    name?: string | undefined;
    /** Gets or sets the units of the medication. */
    units?: string | undefined;
    /** Gets or sets the min dosage of the medication. */
    minDosage: number;
    /** Gets or sets the max dosage of the medication. */
    maxDosage: number;
    /** Gets or sets the medication category Id. */
    medicationCategoryId: number;
}

/** View model for MedicationCategory entity. */
export class MedicationCategoryViewModel extends ViewModelBase implements IMedicationCategoryViewModel {
    /** Gets or sets the name of the medication category. */
    name?: string | undefined;
    /** Gets or sets the colour of the category. */
    colour?: string | undefined;

    constructor(data?: IMedicationCategoryViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.colour = _data["colour"];
        }
    }

    static fromJS(data: any): MedicationCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicationCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["colour"] = this.colour;
        super.toJSON(data);
        return data;
    }
}

/** View model for MedicationCategory entity. */
export interface IMedicationCategoryViewModel extends IViewModelBase {
    /** Gets or sets the name of the medication category. */
    name?: string | undefined;
    /** Gets or sets the colour of the category. */
    colour?: string | undefined;
}

/** Type of error. */
export enum ErrorType {
    OIDCInvite = 0,
    DatabaseError = 1,
    InvalidModel = 2,
    ExisitingEmail = 3,
    StaffNotLinkedToPatient = 4,
    ExistingNHSNumber = 5,
    ExistingCustomPatientId = 6,
}

/** PatientTimelineDataViewModel used for generating timeline card on front end. */
export class PatientTimelineDataViewModel implements IPatientTimelineDataViewModel {
    /** Gets or sets the name corresponding to name of questionnaire or goal question. */
    name?: string | undefined;
    /** Gets or sets timeline card type i.e. goal or questionnaire. */
    type!: TimelineCardType;
    /** Gets or sets response submitted date. Will be created date in case of uncompleted questionnaire responses. */
    submitted?: Date | undefined;
    /** Gets or sets when the response was edited (if applicable). */
    edited?: Date | undefined;
    /** Gets or sets response token of questionnaire or goal. */
    responseToken?: string | undefined;
    /** Gets or sets the list of responses against a questionnaire. */
    questionnaireResponse?: QuestionnaireResponseViewModel[] | undefined;
    /** Gets or sets the response from a goal response, a value ranging from 1-10. */
    goalResponse?: number | undefined;
    /** Gets or sets questionnaire against the timeline card. Will be null if timeline card is Goal. */
    questionnaire?: QuestionnaireViewModel | undefined;
    /** Gets or sets response id, will be goal response id if Type goal will be questionnaire response id if Type questionnaire. */
    responseId!: number;
    /** Gets or sets a value indicating whether response is completed on creation. */
    completed!: boolean;
    /** Gets or sets patient id associated with response. */
    patientId!: number;
    /** Gets or sets staff name associated with response. */
    staffName?: string | undefined;
    /** Gets or sets caseload name associated with the response. */
    caseloadName?: string | undefined;
    /** Gets or sets staff id that created the response. */
    staffId?: number | undefined;
    /** Gets or sets questionnaire version. */
    questionnaireVersion?: number | undefined;
    /** Gets or sets the goal id. */
    goalId?: number | undefined;
    /** Gets or sets QuestionnaireScores where they do exist. */
    questionnaireScores?: CategoryScoreViewModel[] | undefined;
    /** Gets or sets the role of the user that made the timelineresponse. */
    role?: Role | undefined;
    /** Gets or sets the json of a pax tool response. */
    paxDResponses?: string | undefined;
    /** Gets or sets medication name if the timeline data is medication name. */
    medicationName?: string | undefined;
    /** Gets or sets dosage of the patient medication. */
    dose?: number | undefined;
    /** Gets or sets the patient medication units. */
    units?: string | undefined;
    /** Gets or sets the frequency of the dosage of the medication. */
    frequency?: Frequency | undefined;
    /** Gets or sets the amount of times taken during the specified frequency. */
    frequencyAmount?: number | undefined;
    /** Gets or sets the notes associated with the patient medication. */
    notes?: string | undefined;
    /** Gets or sets the start date of the medication. */
    startDate!: Date;
    /** Gets or sets the end date of the medication. */
    endDate?: Date | undefined;
    /** Gets or sets the measurements against the patient dataset if type is dataset. */
    measurements?: PatientMeasurementViewModel[] | undefined;
    /** Gets or sets dataset name if type is dataset. */
    datasetName?: string | undefined;
    /** Gets or sets the dataset id if timeline data type is patient dataset. */
    datasetId?: number | undefined;
    /** Gets or sets the questionnare response state (new, draft, submitted). */
    questionnaireResponseState?: ResponseState | undefined;
    /** Gets or sets a value indicating whether the section selector is present on timeline responses. */
    sectionsSelector!: boolean;

    constructor(data?: IPatientTimelineDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.submitted = _data["submitted"] ? new Date(_data["submitted"].toString()) : <any>undefined;
            this.edited = _data["edited"] ? new Date(_data["edited"].toString()) : <any>undefined;
            this.responseToken = _data["responseToken"];
            if (Array.isArray(_data["questionnaireResponse"])) {
                this.questionnaireResponse = [] as any;
                for (let item of _data["questionnaireResponse"])
                    this.questionnaireResponse!.push(QuestionnaireResponseViewModel.fromJS(item));
            }
            this.goalResponse = _data["goalResponse"];
            this.questionnaire = _data["questionnaire"] ? QuestionnaireViewModel.fromJS(_data["questionnaire"]) : <any>undefined;
            this.responseId = _data["responseId"];
            this.completed = _data["completed"];
            this.patientId = _data["patientId"];
            this.staffName = _data["staffName"];
            this.caseloadName = _data["caseloadName"];
            this.staffId = _data["staffId"];
            this.questionnaireVersion = _data["questionnaireVersion"];
            this.goalId = _data["goalId"];
            if (Array.isArray(_data["questionnaireScores"])) {
                this.questionnaireScores = [] as any;
                for (let item of _data["questionnaireScores"])
                    this.questionnaireScores!.push(CategoryScoreViewModel.fromJS(item));
            }
            this.role = _data["role"];
            this.paxDResponses = _data["paxDResponses"];
            this.medicationName = _data["medicationName"];
            this.dose = _data["dose"];
            this.units = _data["units"];
            this.frequency = _data["frequency"];
            this.frequencyAmount = _data["frequencyAmount"];
            this.notes = _data["notes"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(PatientMeasurementViewModel.fromJS(item));
            }
            this.datasetName = _data["datasetName"];
            this.datasetId = _data["datasetId"];
            this.questionnaireResponseState = _data["questionnaireResponseState"];
            this.sectionsSelector = _data["sectionsSelector"];
        }
    }

    static fromJS(data: any): PatientTimelineDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientTimelineDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["submitted"] = this.submitted ? this.submitted.toISOString() : <any>undefined;
        data["edited"] = this.edited ? this.edited.toISOString() : <any>undefined;
        data["responseToken"] = this.responseToken;
        if (Array.isArray(this.questionnaireResponse)) {
            data["questionnaireResponse"] = [];
            for (let item of this.questionnaireResponse)
                data["questionnaireResponse"].push(item.toJSON());
        }
        data["goalResponse"] = this.goalResponse;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : <any>undefined;
        data["responseId"] = this.responseId;
        data["completed"] = this.completed;
        data["patientId"] = this.patientId;
        data["staffName"] = this.staffName;
        data["caseloadName"] = this.caseloadName;
        data["staffId"] = this.staffId;
        data["questionnaireVersion"] = this.questionnaireVersion;
        data["goalId"] = this.goalId;
        if (Array.isArray(this.questionnaireScores)) {
            data["questionnaireScores"] = [];
            for (let item of this.questionnaireScores)
                data["questionnaireScores"].push(item.toJSON());
        }
        data["role"] = this.role;
        data["paxDResponses"] = this.paxDResponses;
        data["medicationName"] = this.medicationName;
        data["dose"] = this.dose;
        data["units"] = this.units;
        data["frequency"] = this.frequency;
        data["frequencyAmount"] = this.frequencyAmount;
        data["notes"] = this.notes;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item.toJSON());
        }
        data["datasetName"] = this.datasetName;
        data["datasetId"] = this.datasetId;
        data["questionnaireResponseState"] = this.questionnaireResponseState;
        data["sectionsSelector"] = this.sectionsSelector;
        return data;
    }
}

/** PatientTimelineDataViewModel used for generating timeline card on front end. */
export interface IPatientTimelineDataViewModel {
    /** Gets or sets the name corresponding to name of questionnaire or goal question. */
    name?: string | undefined;
    /** Gets or sets timeline card type i.e. goal or questionnaire. */
    type: TimelineCardType;
    /** Gets or sets response submitted date. Will be created date in case of uncompleted questionnaire responses. */
    submitted?: Date | undefined;
    /** Gets or sets when the response was edited (if applicable). */
    edited?: Date | undefined;
    /** Gets or sets response token of questionnaire or goal. */
    responseToken?: string | undefined;
    /** Gets or sets the list of responses against a questionnaire. */
    questionnaireResponse?: QuestionnaireResponseViewModel[] | undefined;
    /** Gets or sets the response from a goal response, a value ranging from 1-10. */
    goalResponse?: number | undefined;
    /** Gets or sets questionnaire against the timeline card. Will be null if timeline card is Goal. */
    questionnaire?: QuestionnaireViewModel | undefined;
    /** Gets or sets response id, will be goal response id if Type goal will be questionnaire response id if Type questionnaire. */
    responseId: number;
    /** Gets or sets a value indicating whether response is completed on creation. */
    completed: boolean;
    /** Gets or sets patient id associated with response. */
    patientId: number;
    /** Gets or sets staff name associated with response. */
    staffName?: string | undefined;
    /** Gets or sets caseload name associated with the response. */
    caseloadName?: string | undefined;
    /** Gets or sets staff id that created the response. */
    staffId?: number | undefined;
    /** Gets or sets questionnaire version. */
    questionnaireVersion?: number | undefined;
    /** Gets or sets the goal id. */
    goalId?: number | undefined;
    /** Gets or sets QuestionnaireScores where they do exist. */
    questionnaireScores?: CategoryScoreViewModel[] | undefined;
    /** Gets or sets the role of the user that made the timelineresponse. */
    role?: Role | undefined;
    /** Gets or sets the json of a pax tool response. */
    paxDResponses?: string | undefined;
    /** Gets or sets medication name if the timeline data is medication name. */
    medicationName?: string | undefined;
    /** Gets or sets dosage of the patient medication. */
    dose?: number | undefined;
    /** Gets or sets the patient medication units. */
    units?: string | undefined;
    /** Gets or sets the frequency of the dosage of the medication. */
    frequency?: Frequency | undefined;
    /** Gets or sets the amount of times taken during the specified frequency. */
    frequencyAmount?: number | undefined;
    /** Gets or sets the notes associated with the patient medication. */
    notes?: string | undefined;
    /** Gets or sets the start date of the medication. */
    startDate: Date;
    /** Gets or sets the end date of the medication. */
    endDate?: Date | undefined;
    /** Gets or sets the measurements against the patient dataset if type is dataset. */
    measurements?: PatientMeasurementViewModel[] | undefined;
    /** Gets or sets dataset name if type is dataset. */
    datasetName?: string | undefined;
    /** Gets or sets the dataset id if timeline data type is patient dataset. */
    datasetId?: number | undefined;
    /** Gets or sets the questionnare response state (new, draft, submitted). */
    questionnaireResponseState?: ResponseState | undefined;
    /** Gets or sets a value indicating whether the section selector is present on timeline responses. */
    sectionsSelector: boolean;
}

/** Type of timeline card either goal or questionnaire. */
export enum TimelineCardType {
    All = 0,
    Questionnaire = 1,
    Goal = 2,
    Medication = 3,
    Dataset = 4,
}

/** The view model for questionnaire responses. */
export class QuestionnaireResponseViewModel implements IQuestionnaireResponseViewModel {
    /** Gets or sets the question Number. */
    number!: number;
    /** Gets or sets the answer value. */
    answer?: string | undefined;

    constructor(data?: IQuestionnaireResponseViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): QuestionnaireResponseViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireResponseViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["answer"] = this.answer;
        return data;
    }
}

/** The view model for questionnaire responses. */
export interface IQuestionnaireResponseViewModel {
    /** Gets or sets the question Number. */
    number: number;
    /** Gets or sets the answer value. */
    answer?: string | undefined;
}

/** The category score view model. */
export class CategoryScoreViewModel implements ICategoryScoreViewModel {
    /** Gets or sets the category name. */
    name?: string | undefined;
    /** Gets or sets the score. */
    score?: number | undefined;
    /** Gets or sets the max score. */
    maxScore?: number | undefined;
    /** Gets or sets the transformed score. */
    tscore?: string | undefined;
    /** Gets or sets a value indicating whether a graph should be hidden for a tscore. */
    hideGraph!: boolean;
    /** Gets or sets the score status. */
    scoreStatus!: ScoreStatus;
    /** Gets or sets a value indicating whether this is a total category. */
    isTotal!: boolean;
    /** Gets or sets a value indicating the SNOMED code for this category. */
    snomed?: string | undefined;
    /** Gets or sets a value indicating whether a subscale being invalid also invalidates the total. */
    invalidatesTotal!: boolean;
    /** Gets or sets a value indicating the number of skipped questions. */
    numberSkipped?: number | undefined;
    /** Gets or sets a value indicating the threshold for warning skipped questions. */
    skippedWarningThreshold?: number | undefined;

    constructor(data?: ICategoryScoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.score = _data["score"];
            this.maxScore = _data["maxScore"];
            this.tscore = _data["tscore"];
            this.hideGraph = _data["hideGraph"];
            this.scoreStatus = _data["scoreStatus"];
            this.isTotal = _data["isTotal"];
            this.snomed = _data["snomed"];
            this.invalidatesTotal = _data["invalidatesTotal"];
            this.numberSkipped = _data["numberSkipped"];
            this.skippedWarningThreshold = _data["skippedWarningThreshold"];
        }
    }

    static fromJS(data: any): CategoryScoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryScoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["score"] = this.score;
        data["maxScore"] = this.maxScore;
        data["tscore"] = this.tscore;
        data["hideGraph"] = this.hideGraph;
        data["scoreStatus"] = this.scoreStatus;
        data["isTotal"] = this.isTotal;
        data["snomed"] = this.snomed;
        data["invalidatesTotal"] = this.invalidatesTotal;
        data["numberSkipped"] = this.numberSkipped;
        data["skippedWarningThreshold"] = this.skippedWarningThreshold;
        return data;
    }
}

/** The category score view model. */
export interface ICategoryScoreViewModel {
    /** Gets or sets the category name. */
    name?: string | undefined;
    /** Gets or sets the score. */
    score?: number | undefined;
    /** Gets or sets the max score. */
    maxScore?: number | undefined;
    /** Gets or sets the transformed score. */
    tscore?: string | undefined;
    /** Gets or sets a value indicating whether a graph should be hidden for a tscore. */
    hideGraph: boolean;
    /** Gets or sets the score status. */
    scoreStatus: ScoreStatus;
    /** Gets or sets a value indicating whether this is a total category. */
    isTotal: boolean;
    /** Gets or sets a value indicating the SNOMED code for this category. */
    snomed?: string | undefined;
    /** Gets or sets a value indicating whether a subscale being invalid also invalidates the total. */
    invalidatesTotal: boolean;
    /** Gets or sets a value indicating the number of skipped questions. */
    numberSkipped?: number | undefined;
    /** Gets or sets a value indicating the threshold for warning skipped questions. */
    skippedWarningThreshold?: number | undefined;
}

/** The status of the calculated score. */
export enum ScoreStatus {
    Clear = 0,
    Borderline = 1,
    Clinical = 2,
}

/** Frequncy of medication dosage. */
export enum Frequency {
    Hours = 0,
    Days = 1,
    Weeks = 2,
    Months = 3,
}

/** Patient measurement against patient data. */
export class PatientMeasurementViewModel implements IPatientMeasurementViewModel {
    /** Gets or sets the measurement id against the patient measurement. */
    measurementId?: number | undefined;
    /** Gets or sets the value of the patient measurement. */
    value?: string | undefined;
    /** Gets or sets the name of the measurement. */
    measurementName?: string | undefined;

    constructor(data?: IPatientMeasurementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measurementId = _data["measurementId"];
            this.value = _data["value"];
            this.measurementName = _data["measurementName"];
        }
    }

    static fromJS(data: any): PatientMeasurementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMeasurementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measurementId"] = this.measurementId;
        data["value"] = this.value;
        data["measurementName"] = this.measurementName;
        return data;
    }
}

/** Patient measurement against patient data. */
export interface IPatientMeasurementViewModel {
    /** Gets or sets the measurement id against the patient measurement. */
    measurementId?: number | undefined;
    /** Gets or sets the value of the patient measurement. */
    value?: string | undefined;
    /** Gets or sets the name of the measurement. */
    measurementName?: string | undefined;
}

/** The state of the response. */
export enum ResponseState {
    New = 0,
    Draft = 1,
    Submitted = 2,
}

/** View model linked to the PatientDataset. */
export class PatientDatasetViewModel extends ViewModelBase implements IPatientDatasetViewModel {
    /** Gets or sets dataset id associated with the patient dataset. */
    datasetId!: number;
    /** Gets or sets patient id associated with the patient dataset. */
    patientId!: number;
    /** Gets or sets the measurement amount of the patient dataset. */
    measurements?: PatientMeasurementViewModel[] | undefined;
    /** Gets or sets dataset against patient dataset. */
    dataset?: DatasetViewModel | undefined;
    /** Gets or sets the test date of the dataset entry. */
    testDate!: Date;

    constructor(data?: IPatientDatasetViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datasetId = _data["datasetId"];
            this.patientId = _data["patientId"];
            if (Array.isArray(_data["measurements"])) {
                this.measurements = [] as any;
                for (let item of _data["measurements"])
                    this.measurements!.push(PatientMeasurementViewModel.fromJS(item));
            }
            this.dataset = _data["dataset"] ? DatasetViewModel.fromJS(_data["dataset"]) : <any>undefined;
            this.testDate = _data["testDate"] ? new Date(_data["testDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientDatasetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDatasetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        data["patientId"] = this.patientId;
        if (Array.isArray(this.measurements)) {
            data["measurements"] = [];
            for (let item of this.measurements)
                data["measurements"].push(item.toJSON());
        }
        data["dataset"] = this.dataset ? this.dataset.toJSON() : <any>undefined;
        data["testDate"] = this.testDate ? this.testDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** View model linked to the PatientDataset. */
export interface IPatientDatasetViewModel extends IViewModelBase {
    /** Gets or sets dataset id associated with the patient dataset. */
    datasetId: number;
    /** Gets or sets patient id associated with the patient dataset. */
    patientId: number;
    /** Gets or sets the measurement amount of the patient dataset. */
    measurements?: PatientMeasurementViewModel[] | undefined;
    /** Gets or sets dataset against patient dataset. */
    dataset?: DatasetViewModel | undefined;
    /** Gets or sets the test date of the dataset entry. */
    testDate: Date;
}

/** View model linked to the PatientMedication. */
export class PatientMedicationViewModel extends ViewModelBase implements IPatientMedicationViewModel {
    /** Gets or sets medication id associated with patient medication. */
    medicationId!: number;
    /** Gets or sets patient id associated with patient medication. */
    patientId!: number;
    /** Gets or sets dosage of the patient medication. */
    dose?: number | undefined;
    /** Gets or sets the frequency of the dosage of the medication. */
    frequency?: Frequency | undefined;
    /** Gets or sets the amount of times taken during the specified frequency. */
    frequencyAmount?: number | undefined;
    /** Gets or sets the notes associated with the patient medication. */
    notes?: string | undefined;
    /** Gets or sets the start date of the medication. */
    startDate!: Date;
    /** Gets or sets the end date of the medication. */
    endDate?: Date | undefined;
    /** Gets or sets the medication object associated with the patient medication. */
    medication?: MedicationViewModel | undefined;

    constructor(data?: IPatientMedicationViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.medicationId = _data["medicationId"];
            this.patientId = _data["patientId"];
            this.dose = _data["dose"];
            this.frequency = _data["frequency"];
            this.frequencyAmount = _data["frequencyAmount"];
            this.notes = _data["notes"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.medication = _data["medication"] ? MedicationViewModel.fromJS(_data["medication"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientMedicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientMedicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["medicationId"] = this.medicationId;
        data["patientId"] = this.patientId;
        data["dose"] = this.dose;
        data["frequency"] = this.frequency;
        data["frequencyAmount"] = this.frequencyAmount;
        data["notes"] = this.notes;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["medication"] = this.medication ? this.medication.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** View model linked to the PatientMedication. */
export interface IPatientMedicationViewModel extends IViewModelBase {
    /** Gets or sets medication id associated with patient medication. */
    medicationId: number;
    /** Gets or sets patient id associated with patient medication. */
    patientId: number;
    /** Gets or sets dosage of the patient medication. */
    dose?: number | undefined;
    /** Gets or sets the frequency of the dosage of the medication. */
    frequency?: Frequency | undefined;
    /** Gets or sets the amount of times taken during the specified frequency. */
    frequencyAmount?: number | undefined;
    /** Gets or sets the notes associated with the patient medication. */
    notes?: string | undefined;
    /** Gets or sets the start date of the medication. */
    startDate: Date;
    /** Gets or sets the end date of the medication. */
    endDate?: Date | undefined;
    /** Gets or sets the medication object associated with the patient medication. */
    medication?: MedicationViewModel | undefined;
}

/** View model for a patient note. */
export class PatientNoteViewModel extends ViewModelBase implements IPatientNoteViewModel {
    /** Gets or sets id of the patient the note was made against. */
    patientId!: number;
    /** Gets or sets the id of the staff who created the note. */
    staffId?: number | undefined;
    /** Gets or sets the contents of the patient note. */
    text?: string | undefined;
    /** Gets or sets the name of staff member that made the note. */
    staffName?: string | undefined;
    /** Gets or sets the if of the staff member who recently edited the note. */
    editedStaffId?: number | undefined;
    /** Gets or sets the name of the staff member that last edited the note. */
    editedStaffName?: string | undefined;

    constructor(data?: IPatientNoteViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.staffId = _data["staffId"];
            this.text = _data["text"];
            this.staffName = _data["staffName"];
            this.editedStaffId = _data["editedStaffId"];
            this.editedStaffName = _data["editedStaffName"];
        }
    }

    static fromJS(data: any): PatientNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PatientNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["staffId"] = this.staffId;
        data["text"] = this.text;
        data["staffName"] = this.staffName;
        data["editedStaffId"] = this.editedStaffId;
        data["editedStaffName"] = this.editedStaffName;
        super.toJSON(data);
        return data;
    }
}

/** View model for a patient note. */
export interface IPatientNoteViewModel extends IViewModelBase {
    /** Gets or sets id of the patient the note was made against. */
    patientId: number;
    /** Gets or sets the id of the staff who created the note. */
    staffId?: number | undefined;
    /** Gets or sets the contents of the patient note. */
    text?: string | undefined;
    /** Gets or sets the name of staff member that made the note. */
    staffName?: string | undefined;
    /** Gets or sets the if of the staff member who recently edited the note. */
    editedStaffId?: number | undefined;
    /** Gets or sets the name of the staff member that last edited the note. */
    editedStaffName?: string | undefined;
}

/** The questionnaire set view model. */
export class QuestionnaireSetViewModel implements IQuestionnaireSetViewModel {
    /** Gets or sets the set of questionnaires. */
    questionnaires?: number[] | undefined;
    /** Gets or sets the patient id. */
    patientId!: number;
    /** Gets or sets the caseload id. */
    caseloadId?: number | undefined;
    /** Gets or sets schedule id linked to questionnaire response. */
    scheduleId?: number | undefined;

    constructor(data?: IQuestionnaireSetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questionnaires"])) {
                this.questionnaires = [] as any;
                for (let item of _data["questionnaires"])
                    this.questionnaires!.push(item);
            }
            this.patientId = _data["patientId"];
            this.caseloadId = _data["caseloadId"];
            this.scheduleId = _data["scheduleId"];
        }
    }

    static fromJS(data: any): QuestionnaireSetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireSetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionnaires)) {
            data["questionnaires"] = [];
            for (let item of this.questionnaires)
                data["questionnaires"].push(item);
        }
        data["patientId"] = this.patientId;
        data["caseloadId"] = this.caseloadId;
        data["scheduleId"] = this.scheduleId;
        return data;
    }
}

/** The questionnaire set view model. */
export interface IQuestionnaireSetViewModel {
    /** Gets or sets the set of questionnaires. */
    questionnaires?: number[] | undefined;
    /** Gets or sets the patient id. */
    patientId: number;
    /** Gets or sets the caseload id. */
    caseloadId?: number | undefined;
    /** Gets or sets schedule id linked to questionnaire response. */
    scheduleId?: number | undefined;
}

/** The question response score view model. */
export class QuestionnaireResponseScoreViewModel implements IQuestionnaireResponseScoreViewModel {
    /** Gets or sets the scores for each individual question. */
    questionScores?: QuestionScoreViewModel[] | undefined;
    /** Gets or sets the scores for the categories. */
    categoryScores?: CategoryScoreViewModel[] | undefined;

    constructor(data?: IQuestionnaireResponseScoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questionScores"])) {
                this.questionScores = [] as any;
                for (let item of _data["questionScores"])
                    this.questionScores!.push(QuestionScoreViewModel.fromJS(item));
            }
            if (Array.isArray(_data["categoryScores"])) {
                this.categoryScores = [] as any;
                for (let item of _data["categoryScores"])
                    this.categoryScores!.push(CategoryScoreViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionnaireResponseScoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireResponseScoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questionScores)) {
            data["questionScores"] = [];
            for (let item of this.questionScores)
                data["questionScores"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryScores)) {
            data["categoryScores"] = [];
            for (let item of this.categoryScores)
                data["categoryScores"].push(item.toJSON());
        }
        return data;
    }
}

/** The question response score view model. */
export interface IQuestionnaireResponseScoreViewModel {
    /** Gets or sets the scores for each individual question. */
    questionScores?: QuestionScoreViewModel[] | undefined;
    /** Gets or sets the scores for the categories. */
    categoryScores?: CategoryScoreViewModel[] | undefined;
}

/** The question score view model. */
export class QuestionScoreViewModel implements IQuestionScoreViewModel {
    /** Gets or sets the number of the question. */
    questionNumber?: number | undefined;
    /** Gets or sets the short name of the question. */
    questionShortName?: string | undefined;
    /** Gets or sets the score. */
    score?: number | undefined;
    /** Gets or sets the max score. */
    maxScore?: number | undefined;
    /** Gets or sets a value indicating the SNOMED code for this question. */
    snomed?: string | undefined;
    /** Gets or sets a user friendly response to display for interoperability. */
    displayValue?: string | undefined;

    constructor(data?: IQuestionScoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionNumber = _data["questionNumber"];
            this.questionShortName = _data["questionShortName"];
            this.score = _data["score"];
            this.maxScore = _data["maxScore"];
            this.snomed = _data["snomed"];
            this.displayValue = _data["displayValue"];
        }
    }

    static fromJS(data: any): QuestionScoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionScoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionNumber"] = this.questionNumber;
        data["questionShortName"] = this.questionShortName;
        data["score"] = this.score;
        data["maxScore"] = this.maxScore;
        data["snomed"] = this.snomed;
        data["displayValue"] = this.displayValue;
        return data;
    }
}

/** The question score view model. */
export interface IQuestionScoreViewModel {
    /** Gets or sets the number of the question. */
    questionNumber?: number | undefined;
    /** Gets or sets the short name of the question. */
    questionShortName?: string | undefined;
    /** Gets or sets the score. */
    score?: number | undefined;
    /** Gets or sets the max score. */
    maxScore?: number | undefined;
    /** Gets or sets a value indicating the SNOMED code for this question. */
    snomed?: string | undefined;
    /** Gets or sets a user friendly response to display for interoperability. */
    displayValue?: string | undefined;
}

/** Defines the questionnaire version view model. */
export class QuestionnaireVersionViewModel extends ViewModelBase implements IQuestionnaireVersionViewModel {
    /** Gets or sets the ID of the questionnaire the version relates to. */
    questionnaireId!: number;
    /** Gets or sets the questionnaire version number. */
    version!: number;
    /** Gets or sets the questionnaire published datetime. */
    published?: Date | undefined;
    /** Gets or sets the content of the questionnaire version. */
    content!: string;

    constructor(data?: IQuestionnaireVersionViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionnaireId = _data["questionnaireId"];
            this.version = _data["version"];
            this.published = _data["published"] ? new Date(_data["published"].toString()) : <any>undefined;
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): QuestionnaireVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaireId"] = this.questionnaireId;
        data["version"] = this.version;
        data["published"] = this.published ? this.published.toISOString() : <any>undefined;
        data["content"] = this.content;
        super.toJSON(data);
        return data;
    }
}

/** Defines the questionnaire version view model. */
export interface IQuestionnaireVersionViewModel extends IViewModelBase {
    /** Gets or sets the ID of the questionnaire the version relates to. */
    questionnaireId: number;
    /** Gets or sets the questionnaire version number. */
    version: number;
    /** Gets or sets the questionnaire published datetime. */
    published?: Date | undefined;
    /** Gets or sets the content of the questionnaire version. */
    content: string;
}

/** The view model for questionnaire response data. */
export class QuestionnaireResponseDataViewModel extends HasIdViewModel implements IQuestionnaireResponseDataViewModel {
    /** Gets or sets the questionnaire responses. */
    responses?: QuestionnaireResponseViewModel[] | undefined;
    /** Gets or sets the submission date of the responses. */
    submitted?: Date | undefined;
    /** Gets or sets the response state of the response (new, draft, submitted). */
    state?: ResponseState | undefined;

    constructor(data?: IQuestionnaireResponseDataViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(QuestionnaireResponseViewModel.fromJS(item));
            }
            this.submitted = _data["submitted"] ? new Date(_data["submitted"].toString()) : <any>undefined;
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): QuestionnaireResponseDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireResponseDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        data["submitted"] = this.submitted ? this.submitted.toISOString() : <any>undefined;
        data["state"] = this.state;
        super.toJSON(data);
        return data;
    }
}

/** The view model for questionnaire response data. */
export interface IQuestionnaireResponseDataViewModel extends IHasIdViewModel {
    /** Gets or sets the questionnaire responses. */
    responses?: QuestionnaireResponseViewModel[] | undefined;
    /** Gets or sets the submission date of the responses. */
    submitted?: Date | undefined;
    /** Gets or sets the response state of the response (new, draft, submitted). */
    state?: ResponseState | undefined;
}

/** Pax Tool response view model. */
export class PaxDViewModel implements IPaxDViewModel {
    /** Gets or sets responses against a pax decision tool session. */
    responses?: PaxDQuestionViewModel[] | undefined;
    /** Gets or sets QuestionnaireResponseToken associated with the pax decision tool session. */
    questionnaireResponseToken?: string | undefined;

    constructor(data?: IPaxDViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(PaxDQuestionViewModel.fromJS(item));
            }
            this.questionnaireResponseToken = _data["questionnaireResponseToken"];
        }
    }

    static fromJS(data: any): PaxDViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        data["questionnaireResponseToken"] = this.questionnaireResponseToken;
        return data;
    }
}

/** Pax Tool response view model. */
export interface IPaxDViewModel {
    /** Gets or sets responses against a pax decision tool session. */
    responses?: PaxDQuestionViewModel[] | undefined;
    /** Gets or sets QuestionnaireResponseToken associated with the pax decision tool session. */
    questionnaireResponseToken?: string | undefined;
}

/** Pax decision tool question view model. */
export class PaxDQuestionViewModel implements IPaxDQuestionViewModel {
    /** Gets or sets LossPairA. */
    lossPairA?: string | undefined;
    /** Gets or sets LossPairA. */
    lossPairB?: string | undefined;
    /** Gets or sets LossPairA. */
    mostcommon!: number;
    /** Gets or sets LossPairA. */
    mostcommonpos1!: number;
    /** Gets or sets LossPairA. */
    reactionTimeMs!: number;
    /** Gets or sets LossPairA. */
    resumeTime!: Date;
    /** Gets or sets LossPairA. */
    rewardorloss!: number;
    /** Gets or sets LossPairA. */
    run!: number;
    /** Gets or sets LossPairA. */
    score!: number;
    /** Gets or sets LossPairA. */
    session!: number;
    /** Gets or sets LossPairA. */
    side!: number;
    /** Gets or sets LossPairA. */
    startTime!: Date;
    /** Gets or sets LossPairA. */
    stimuli?: string | undefined;
    /** Gets or sets LossPairA. */
    trial!: number;
    /** Gets or sets LossPairA. */
    userOutcome?: string | undefined;
    /** Gets or sets LossPairA. */
    userSelectShape!: number;
    /** Gets or sets LossPairA. */
    userSide?: string | undefined;
    /** Gets or sets LossPairA. */
    userSymbol?: string | undefined;
    /** Gets or sets LossPairA. */
    winPairA?: string | undefined;
    /** Gets or sets LossPairA. */
    winPairB?: string | undefined;

    constructor(data?: IPaxDQuestionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lossPairA = _data["lossPairA"];
            this.lossPairB = _data["lossPairB"];
            this.mostcommon = _data["mostcommon"];
            this.mostcommonpos1 = _data["mostcommonpos1"];
            this.reactionTimeMs = _data["reactionTimeMs"];
            this.resumeTime = _data["resumeTime"] ? new Date(_data["resumeTime"].toString()) : <any>undefined;
            this.rewardorloss = _data["rewardorloss"];
            this.run = _data["run"];
            this.score = _data["score"];
            this.session = _data["session"];
            this.side = _data["side"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.stimuli = _data["stimuli"];
            this.trial = _data["trial"];
            this.userOutcome = _data["userOutcome"];
            this.userSelectShape = _data["userSelectShape"];
            this.userSide = _data["userSide"];
            this.userSymbol = _data["userSymbol"];
            this.winPairA = _data["winPairA"];
            this.winPairB = _data["winPairB"];
        }
    }

    static fromJS(data: any): PaxDQuestionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaxDQuestionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lossPairA"] = this.lossPairA;
        data["lossPairB"] = this.lossPairB;
        data["mostcommon"] = this.mostcommon;
        data["mostcommonpos1"] = this.mostcommonpos1;
        data["reactionTimeMs"] = this.reactionTimeMs;
        data["resumeTime"] = this.resumeTime ? this.resumeTime.toISOString() : <any>undefined;
        data["rewardorloss"] = this.rewardorloss;
        data["run"] = this.run;
        data["score"] = this.score;
        data["session"] = this.session;
        data["side"] = this.side;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["stimuli"] = this.stimuli;
        data["trial"] = this.trial;
        data["userOutcome"] = this.userOutcome;
        data["userSelectShape"] = this.userSelectShape;
        data["userSide"] = this.userSide;
        data["userSymbol"] = this.userSymbol;
        data["winPairA"] = this.winPairA;
        data["winPairB"] = this.winPairB;
        return data;
    }
}

/** Pax decision tool question view model. */
export interface IPaxDQuestionViewModel {
    /** Gets or sets LossPairA. */
    lossPairA?: string | undefined;
    /** Gets or sets LossPairA. */
    lossPairB?: string | undefined;
    /** Gets or sets LossPairA. */
    mostcommon: number;
    /** Gets or sets LossPairA. */
    mostcommonpos1: number;
    /** Gets or sets LossPairA. */
    reactionTimeMs: number;
    /** Gets or sets LossPairA. */
    resumeTime: Date;
    /** Gets or sets LossPairA. */
    rewardorloss: number;
    /** Gets or sets LossPairA. */
    run: number;
    /** Gets or sets LossPairA. */
    score: number;
    /** Gets or sets LossPairA. */
    session: number;
    /** Gets or sets LossPairA. */
    side: number;
    /** Gets or sets LossPairA. */
    startTime: Date;
    /** Gets or sets LossPairA. */
    stimuli?: string | undefined;
    /** Gets or sets LossPairA. */
    trial: number;
    /** Gets or sets LossPairA. */
    userOutcome?: string | undefined;
    /** Gets or sets LossPairA. */
    userSelectShape: number;
    /** Gets or sets LossPairA. */
    userSide?: string | undefined;
    /** Gets or sets LossPairA. */
    userSymbol?: string | undefined;
    /** Gets or sets LossPairA. */
    winPairA?: string | undefined;
    /** Gets or sets LossPairA. */
    winPairB?: string | undefined;
}

/** Errors linked to questionnaires. */
export enum QuestionnaireErrors {
    QuestionnaireNotFound = 0,
    UnableToDeletePublishedQuestionnaire = 1,
}

/** Defines a schedule. */
export class ScheduleViewModel extends ViewModelBase implements IScheduleViewModel {
    /** Gets or sets the id of the patient whom the schedule belongs to. */
    patientId!: number;
    /** Gets or sets the id of the questionnaire that is scheduled. */
    questionnaireId!: number;
    /** Gets or sets the questionnaire that has been scheduled. */
    questionnaire?: QuestionnaireViewModel | undefined;
    /** Gets or sets the id of the caseload that the schedule is assigned to. */
    caseloadId!: number;
    /** Gets or sets the caseload. */
    caseload?: CaseloadViewModel | undefined;
    /** Gets or sets the monitoring status of the schedule. */
    monitoringStatus!: MonitoringStatus;
    /** Gets or sets the date that the schedule should start from. */
    startDate!: Date;
    /** Gets or sets the date that the schedule should end on. */
    endDate?: Date | undefined;
    /** Gets or sets a value indicating whether the schedule should continue indefinitely. */
    continueIndefinitely?: boolean | undefined;
    /** Gets or sets the id of the prompt schedule. */
    promptScheduleId?: number | undefined;
    /** Gets or sets the prompt scheduling. */
    promptSchedule?: PromptScheduleViewModel | undefined;
    /** Gets or sets the last response date for the questionnaire. */
    lastResponseDate?: Date | undefined;
    /** Gets or sets the tenant id. */
    tenantId?: number | undefined;
    /** Gets or sets a value indicating whether questionnaire responses sends a notification to the staff member on submission. */
    sendNotificationOnSubmission!: boolean;
    /** Gets or sets the duration till the schedule is stale. */
    staleDuration!: StaleDuration;
    /** Gets or sets the staff id of the staff that set the schedule. */
    staffId?: number | undefined;
    /** Gets or sets a value indicating whether questionnaire response has been submitted with current token against schedule. */
    isSubmitted!: boolean;

    constructor(data?: IScheduleViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.patientId = _data["patientId"];
            this.questionnaireId = _data["questionnaireId"];
            this.questionnaire = _data["questionnaire"] ? QuestionnaireViewModel.fromJS(_data["questionnaire"]) : <any>undefined;
            this.caseloadId = _data["caseloadId"];
            this.caseload = _data["caseload"] ? CaseloadViewModel.fromJS(_data["caseload"]) : <any>undefined;
            this.monitoringStatus = _data["monitoringStatus"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.continueIndefinitely = _data["continueIndefinitely"];
            this.promptScheduleId = _data["promptScheduleId"];
            this.promptSchedule = _data["promptSchedule"] ? PromptScheduleViewModel.fromJS(_data["promptSchedule"]) : <any>undefined;
            this.lastResponseDate = _data["lastResponseDate"] ? new Date(_data["lastResponseDate"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.sendNotificationOnSubmission = _data["sendNotificationOnSubmission"];
            this.staleDuration = _data["staleDuration"];
            this.staffId = _data["staffId"];
            this.isSubmitted = _data["isSubmitted"];
        }
    }

    static fromJS(data: any): ScheduleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["patientId"] = this.patientId;
        data["questionnaireId"] = this.questionnaireId;
        data["questionnaire"] = this.questionnaire ? this.questionnaire.toJSON() : <any>undefined;
        data["caseloadId"] = this.caseloadId;
        data["caseload"] = this.caseload ? this.caseload.toJSON() : <any>undefined;
        data["monitoringStatus"] = this.monitoringStatus;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["continueIndefinitely"] = this.continueIndefinitely;
        data["promptScheduleId"] = this.promptScheduleId;
        data["promptSchedule"] = this.promptSchedule ? this.promptSchedule.toJSON() : <any>undefined;
        data["lastResponseDate"] = this.lastResponseDate ? this.lastResponseDate.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["sendNotificationOnSubmission"] = this.sendNotificationOnSubmission;
        data["staleDuration"] = this.staleDuration;
        data["staffId"] = this.staffId;
        data["isSubmitted"] = this.isSubmitted;
        super.toJSON(data);
        return data;
    }
}

/** Defines a schedule. */
export interface IScheduleViewModel extends IViewModelBase {
    /** Gets or sets the id of the patient whom the schedule belongs to. */
    patientId: number;
    /** Gets or sets the id of the questionnaire that is scheduled. */
    questionnaireId: number;
    /** Gets or sets the questionnaire that has been scheduled. */
    questionnaire?: QuestionnaireViewModel | undefined;
    /** Gets or sets the id of the caseload that the schedule is assigned to. */
    caseloadId: number;
    /** Gets or sets the caseload. */
    caseload?: CaseloadViewModel | undefined;
    /** Gets or sets the monitoring status of the schedule. */
    monitoringStatus: MonitoringStatus;
    /** Gets or sets the date that the schedule should start from. */
    startDate: Date;
    /** Gets or sets the date that the schedule should end on. */
    endDate?: Date | undefined;
    /** Gets or sets a value indicating whether the schedule should continue indefinitely. */
    continueIndefinitely?: boolean | undefined;
    /** Gets or sets the id of the prompt schedule. */
    promptScheduleId?: number | undefined;
    /** Gets or sets the prompt scheduling. */
    promptSchedule?: PromptScheduleViewModel | undefined;
    /** Gets or sets the last response date for the questionnaire. */
    lastResponseDate?: Date | undefined;
    /** Gets or sets the tenant id. */
    tenantId?: number | undefined;
    /** Gets or sets a value indicating whether questionnaire responses sends a notification to the staff member on submission. */
    sendNotificationOnSubmission: boolean;
    /** Gets or sets the duration till the schedule is stale. */
    staleDuration: StaleDuration;
    /** Gets or sets the staff id of the staff that set the schedule. */
    staffId?: number | undefined;
    /** Gets or sets a value indicating whether questionnaire response has been submitted with current token against schedule. */
    isSubmitted: boolean;
}

/** An entity that defines the HasID. */
export class HasId implements IHasId {
    /** Gets or sets the id. */
    id!: number;

    constructor(data?: IHasId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): HasId {
        data = typeof data === 'object' ? data : {};
        let result = new HasId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

/** An entity that defines the HasID. */
export interface IHasId {
    /** Gets or sets the id. */
    id: number;
}

/** Defines the EntityBase. */
export class EntityBase extends HasId implements IEntityBase {
    /** Gets or sets a value indicating whether the entity is active. */
    active!: boolean;
    /** Gets or sets when the entity was created. */
    created!: Date;
    /** Gets or sets when the entity was last updated. */
    updated!: Date;

    constructor(data?: IEntityBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        let result = new EntityBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** Defines the EntityBase. */
export interface IEntityBase extends IHasId {
    /** Gets or sets a value indicating whether the entity is active. */
    active: boolean;
    /** Gets or sets when the entity was created. */
    created: Date;
    /** Gets or sets when the entity was last updated. */
    updated: Date;
}

/** The class detailing a staff member. */
export class Staff extends EntityBase implements IStaff {
    /** Gets or sets the UserId. */
    userId!: number;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last Name. */
    lastName?: string | undefined;
    /** Gets or sets the IntegrationId of the staff. */
    integrationId?: string | undefined;
    /** Gets or sets the tenant id. */
    tenantId?: number | undefined;
    /** Gets or sets contact email. */
    contactEmail?: string | undefined;
    /** Gets or sets contact mobile. */
    mobileNumber?: string | undefined;
    /** Gets or sets the staff preferred contact type. */
    preferredContact!: PreferredContact;

    constructor(data?: IStaff) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.integrationId = _data["integrationId"];
            this.tenantId = _data["tenantId"];
            this.contactEmail = _data["contactEmail"];
            this.mobileNumber = _data["mobileNumber"];
            this.preferredContact = _data["preferredContact"];
        }
    }

    static fromJS(data: any): Staff {
        data = typeof data === 'object' ? data : {};
        let result = new Staff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["integrationId"] = this.integrationId;
        data["tenantId"] = this.tenantId;
        data["contactEmail"] = this.contactEmail;
        data["mobileNumber"] = this.mobileNumber;
        data["preferredContact"] = this.preferredContact;
        super.toJSON(data);
        return data;
    }
}

/** The class detailing a staff member. */
export interface IStaff extends IEntityBase {
    /** Gets or sets the UserId. */
    userId: number;
    /** Gets or sets the first name. */
    firstName?: string | undefined;
    /** Gets or sets the last Name. */
    lastName?: string | undefined;
    /** Gets or sets the IntegrationId of the staff. */
    integrationId?: string | undefined;
    /** Gets or sets the tenant id. */
    tenantId?: number | undefined;
    /** Gets or sets contact email. */
    contactEmail?: string | undefined;
    /** Gets or sets contact mobile. */
    mobileNumber?: string | undefined;
    /** Gets or sets the staff preferred contact type. */
    preferredContact: PreferredContact;
}

/** Defines the TemporaryAccessLogViewModel. */
export class TemporaryAccessLogViewModel extends ViewModelBase implements ITemporaryAccessLogViewModel {
    /** Gets or sets the staff id of the clinician who made the log. */
    staffId!: number;
    /** Gets or sets the patient id of the patient who is being viewed. */
    patientId!: number;
    /** Gets or sets reason for viewing specified patient. */
    reason!: string;

    constructor(data?: ITemporaryAccessLogViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.staffId = _data["staffId"];
            this.patientId = _data["patientId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): TemporaryAccessLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemporaryAccessLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffId"] = this.staffId;
        data["patientId"] = this.patientId;
        data["reason"] = this.reason;
        super.toJSON(data);
        return data;
    }
}

/** Defines the TemporaryAccessLogViewModel. */
export interface ITemporaryAccessLogViewModel extends IViewModelBase {
    /** Gets or sets the staff id of the clinician who made the log. */
    staffId: number;
    /** Gets or sets the patient id of the patient who is being viewed. */
    patientId: number;
    /** Gets or sets reason for viewing specified patient. */
    reason: string;
}

/** View model of a tenancy. */
export class TenantViewModel extends ViewModelBase implements ITenantViewModel {
    /** Gets or sets the name of the tenant. */
    name?: string | undefined;
    /** Gets or sets the tenant options object. */
    tenantOptions?: TenantOptionsViewModel | undefined;
    /** Gets or sets the Integration API Credentials associated with tenancy. */
    integrationApiCredentials?: string | undefined;

    constructor(data?: ITenantViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.tenantOptions = _data["tenantOptions"] ? TenantOptionsViewModel.fromJS(_data["tenantOptions"]) : <any>undefined;
            this.integrationApiCredentials = _data["integrationApiCredentials"];
        }
    }

    static fromJS(data: any): TenantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tenantOptions"] = this.tenantOptions ? this.tenantOptions.toJSON() : <any>undefined;
        data["integrationApiCredentials"] = this.integrationApiCredentials;
        super.toJSON(data);
        return data;
    }
}

/** View model of a tenancy. */
export interface ITenantViewModel extends IViewModelBase {
    /** Gets or sets the name of the tenant. */
    name?: string | undefined;
    /** Gets or sets the tenant options object. */
    tenantOptions?: TenantOptionsViewModel | undefined;
    /** Gets or sets the Integration API Credentials associated with tenancy. */
    integrationApiCredentials?: string | undefined;
}

/** Tenant options view model converting the tenant options from json to an object. */
export class TenantOptionsViewModel implements ITenantOptionsViewModel {
    /** Gets or sets the integration status. */
    integration?: boolean | undefined;
    /** Gets or sets whether a patient can log in against the tenancy. */
    patientCanLogIn?: boolean | undefined;
    /** Gets or sets the file path of the tenant logo. */
    logoPath?: string | undefined;
    /** Gets or sets the name of the tenant logo. */
    logoName?: string | undefined;
    /** Gets or sets the footer html component for the tenancy. */
    footer?: string | undefined;
    /** Gets or sets the sft host for the tenancy. */
    sftHost?: string | undefined;
    /** Gets or sets the sft port for the tenancy. */
    sftPort?: number | undefined;
    /** Gets or sets the sft username for the tenancy. */
    sftUsername?: string | undefined;
    /** Gets or sets the sft key name for the tenancy. */
    sftKeyName?: string | undefined;
    /** Gets or sets a value indicating whether medication is allowed on tenancy. */
    allowMedication?: boolean | undefined;
    /** Gets or sets a value indicating whether patient dashboard is allowed on tenancy. */
    allowDashboard?: boolean | undefined;
    /** Gets or sets the patient tab options for the tenancy. */
    patientTabOptions?: PatientTab[] | undefined;
    /** Gets or sets the graph options for the tenancy. */
    graphTenancyOptions?: GraphTenantOptionsModel[] | undefined;
    /** Gets or sets a value indicating whether external data is allowed on tenancy. */
    allowExternalData?: boolean | undefined;
    /** Gets or sets a value indicating whether graph seperation should be enabled by default. */
    defaultGraphSeperation?: boolean | undefined;
    /** Gets or sets graph ordering according to given questionnaire ids. */
    graphOrdering?: number[] | undefined;
    /** Gets or sets a value indicating whether notifications are not sent. */
    silenceNotifications?: boolean | undefined;
    /** Gets or sets the tenancy OIDC organisation URI. */
    oidcOrgURI?: string | undefined;
    /** Gets or sets the tenancy interoperability endpoint URI. */
    interoperabilityURI?: string | undefined;
    /** Gets or sets the tenancy interoperability JWT Authentication URI. */
    interoperabilityJWTURI?: string | undefined;
    /** Gets or sets the tenancy interoperability JWT Authentication Secret. */
    interoperabilityPasswordSecret?: string | undefined;
    /** Gets or sets the tenancy interoperability certificate hash. */
    interoperabilityCertHash?: string | undefined;
    /** Gets or sets the tenancy interoperability JWT Authentication Username. */
    interoperabilityJWTUsername?: string | undefined;
    /** Gets or sets a value indicating whether a clinician can edit a response. */
    clinicianCanEditResponses?: boolean | undefined;
    /** Gets or sets a value indicating whether an NHS number is required. */
    nhsNumberRequired?: boolean | undefined;
    /** Gets or sets a value indicating whether admins are allowed to edit questionnaires. */
    allowEditQuestionnaires?: boolean | undefined;
    /** Gets or sets a custom patient id view model to allow custom patient id's to be input and displayed on patient profiles, with various options. */
    customPatientId?: CustomPatientIdViewModel | undefined;

    constructor(data?: ITenantOptionsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integration = _data["integration"];
            this.patientCanLogIn = _data["patientCanLogIn"];
            this.logoPath = _data["logoPath"];
            this.logoName = _data["logoName"];
            this.footer = _data["footer"];
            this.sftHost = _data["sftHost"];
            this.sftPort = _data["sftPort"];
            this.sftUsername = _data["sftUsername"];
            this.sftKeyName = _data["sftKeyName"];
            this.allowMedication = _data["allowMedication"];
            this.allowDashboard = _data["allowDashboard"];
            if (Array.isArray(_data["patientTabOptions"])) {
                this.patientTabOptions = [] as any;
                for (let item of _data["patientTabOptions"])
                    this.patientTabOptions!.push(item);
            }
            if (Array.isArray(_data["graphTenancyOptions"])) {
                this.graphTenancyOptions = [] as any;
                for (let item of _data["graphTenancyOptions"])
                    this.graphTenancyOptions!.push(GraphTenantOptionsModel.fromJS(item));
            }
            this.allowExternalData = _data["allowExternalData"];
            this.defaultGraphSeperation = _data["defaultGraphSeperation"];
            if (Array.isArray(_data["graphOrdering"])) {
                this.graphOrdering = [] as any;
                for (let item of _data["graphOrdering"])
                    this.graphOrdering!.push(item);
            }
            this.silenceNotifications = _data["silenceNotifications"];
            this.oidcOrgURI = _data["oidcOrgURI"];
            this.interoperabilityURI = _data["interoperabilityURI"];
            this.interoperabilityJWTURI = _data["interoperabilityJWTURI"];
            this.interoperabilityPasswordSecret = _data["interoperabilityPasswordSecret"];
            this.interoperabilityCertHash = _data["interoperabilityCertHash"];
            this.interoperabilityJWTUsername = _data["interoperabilityJWTUsername"];
            this.clinicianCanEditResponses = _data["clinicianCanEditResponses"];
            this.nhsNumberRequired = _data["nhsNumberRequired"];
            this.allowEditQuestionnaires = _data["allowEditQuestionnaires"];
            this.customPatientId = _data["customPatientId"] ? CustomPatientIdViewModel.fromJS(_data["customPatientId"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantOptionsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOptionsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integration"] = this.integration;
        data["patientCanLogIn"] = this.patientCanLogIn;
        data["logoPath"] = this.logoPath;
        data["logoName"] = this.logoName;
        data["footer"] = this.footer;
        data["sftHost"] = this.sftHost;
        data["sftPort"] = this.sftPort;
        data["sftUsername"] = this.sftUsername;
        data["sftKeyName"] = this.sftKeyName;
        data["allowMedication"] = this.allowMedication;
        data["allowDashboard"] = this.allowDashboard;
        if (Array.isArray(this.patientTabOptions)) {
            data["patientTabOptions"] = [];
            for (let item of this.patientTabOptions)
                data["patientTabOptions"].push(item);
        }
        if (Array.isArray(this.graphTenancyOptions)) {
            data["graphTenancyOptions"] = [];
            for (let item of this.graphTenancyOptions)
                data["graphTenancyOptions"].push(item.toJSON());
        }
        data["allowExternalData"] = this.allowExternalData;
        data["defaultGraphSeperation"] = this.defaultGraphSeperation;
        if (Array.isArray(this.graphOrdering)) {
            data["graphOrdering"] = [];
            for (let item of this.graphOrdering)
                data["graphOrdering"].push(item);
        }
        data["silenceNotifications"] = this.silenceNotifications;
        data["oidcOrgURI"] = this.oidcOrgURI;
        data["interoperabilityURI"] = this.interoperabilityURI;
        data["interoperabilityJWTURI"] = this.interoperabilityJWTURI;
        data["interoperabilityPasswordSecret"] = this.interoperabilityPasswordSecret;
        data["interoperabilityCertHash"] = this.interoperabilityCertHash;
        data["interoperabilityJWTUsername"] = this.interoperabilityJWTUsername;
        data["clinicianCanEditResponses"] = this.clinicianCanEditResponses;
        data["nhsNumberRequired"] = this.nhsNumberRequired;
        data["allowEditQuestionnaires"] = this.allowEditQuestionnaires;
        data["customPatientId"] = this.customPatientId ? this.customPatientId.toJSON() : <any>undefined;
        return data;
    }
}

/** Tenant options view model converting the tenant options from json to an object. */
export interface ITenantOptionsViewModel {
    /** Gets or sets the integration status. */
    integration?: boolean | undefined;
    /** Gets or sets whether a patient can log in against the tenancy. */
    patientCanLogIn?: boolean | undefined;
    /** Gets or sets the file path of the tenant logo. */
    logoPath?: string | undefined;
    /** Gets or sets the name of the tenant logo. */
    logoName?: string | undefined;
    /** Gets or sets the footer html component for the tenancy. */
    footer?: string | undefined;
    /** Gets or sets the sft host for the tenancy. */
    sftHost?: string | undefined;
    /** Gets or sets the sft port for the tenancy. */
    sftPort?: number | undefined;
    /** Gets or sets the sft username for the tenancy. */
    sftUsername?: string | undefined;
    /** Gets or sets the sft key name for the tenancy. */
    sftKeyName?: string | undefined;
    /** Gets or sets a value indicating whether medication is allowed on tenancy. */
    allowMedication?: boolean | undefined;
    /** Gets or sets a value indicating whether patient dashboard is allowed on tenancy. */
    allowDashboard?: boolean | undefined;
    /** Gets or sets the patient tab options for the tenancy. */
    patientTabOptions?: PatientTab[] | undefined;
    /** Gets or sets the graph options for the tenancy. */
    graphTenancyOptions?: GraphTenantOptionsModel[] | undefined;
    /** Gets or sets a value indicating whether external data is allowed on tenancy. */
    allowExternalData?: boolean | undefined;
    /** Gets or sets a value indicating whether graph seperation should be enabled by default. */
    defaultGraphSeperation?: boolean | undefined;
    /** Gets or sets graph ordering according to given questionnaire ids. */
    graphOrdering?: number[] | undefined;
    /** Gets or sets a value indicating whether notifications are not sent. */
    silenceNotifications?: boolean | undefined;
    /** Gets or sets the tenancy OIDC organisation URI. */
    oidcOrgURI?: string | undefined;
    /** Gets or sets the tenancy interoperability endpoint URI. */
    interoperabilityURI?: string | undefined;
    /** Gets or sets the tenancy interoperability JWT Authentication URI. */
    interoperabilityJWTURI?: string | undefined;
    /** Gets or sets the tenancy interoperability JWT Authentication Secret. */
    interoperabilityPasswordSecret?: string | undefined;
    /** Gets or sets the tenancy interoperability certificate hash. */
    interoperabilityCertHash?: string | undefined;
    /** Gets or sets the tenancy interoperability JWT Authentication Username. */
    interoperabilityJWTUsername?: string | undefined;
    /** Gets or sets a value indicating whether a clinician can edit a response. */
    clinicianCanEditResponses?: boolean | undefined;
    /** Gets or sets a value indicating whether an NHS number is required. */
    nhsNumberRequired?: boolean | undefined;
    /** Gets or sets a value indicating whether admins are allowed to edit questionnaires. */
    allowEditQuestionnaires?: boolean | undefined;
    /** Gets or sets a custom patient id view model to allow custom patient id's to be input and displayed on patient profiles, with various options. */
    customPatientId?: CustomPatientIdViewModel | undefined;
}

/** The tabs available when viewing a patient. */
export enum PatientTab {
    Details = 0,
    Dashboard = 1,
    Timeline = 2,
    Graphs = 3,
    Questionnaires = 4,
    Goals = 5,
    Schedule = 6,
    Notes = 7,
    Medication = 8,
    Datasets = 9,
}

/** The graphing options for the tenancy. */
export class GraphTenantOptionsModel implements IGraphTenantOptionsModel {
    /** Gets or sets the questionnaire id for the graphing tenant options. */
    questionnaireId!: number;
    /** Gets or sets the clinical score for the summary graph. */
    clinicalScore!: number;
    /** Gets or sets the borderline score for the summary graph. */
    borderlineScore!: number;
    /** Gets or sets the stable score for the summary graph. */
    stableScore!: number;

    constructor(data?: IGraphTenantOptionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionnaireId = _data["questionnaireId"];
            this.clinicalScore = _data["clinicalScore"];
            this.borderlineScore = _data["borderlineScore"];
            this.stableScore = _data["stableScore"];
        }
    }

    static fromJS(data: any): GraphTenantOptionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new GraphTenantOptionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaireId"] = this.questionnaireId;
        data["clinicalScore"] = this.clinicalScore;
        data["borderlineScore"] = this.borderlineScore;
        data["stableScore"] = this.stableScore;
        return data;
    }
}

/** The graphing options for the tenancy. */
export interface IGraphTenantOptionsModel {
    /** Gets or sets the questionnaire id for the graphing tenant options. */
    questionnaireId: number;
    /** Gets or sets the clinical score for the summary graph. */
    clinicalScore: number;
    /** Gets or sets the borderline score for the summary graph. */
    borderlineScore: number;
    /** Gets or sets the stable score for the summary graph. */
    stableScore: number;
}

/** Custom patient id view model to convert a JSON object to a c# object. */
export class CustomPatientIdViewModel implements ICustomPatientIdViewModel {
    /** Gets or sets the display name to use for the custom patient id. */
    displayName?: string | undefined;
    /** Gets or sets the regex to use to validate the custom patient id. */
    regex?: string | undefined;
    /** Gets or sets a bool to determine if the custom patient id is mandatory or not. */
    mandatory?: boolean | undefined;

    constructor(data?: ICustomPatientIdViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.regex = _data["regex"];
            this.mandatory = _data["mandatory"];
        }
    }

    static fromJS(data: any): CustomPatientIdViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomPatientIdViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["regex"] = this.regex;
        data["mandatory"] = this.mandatory;
        return data;
    }
}

/** Custom patient id view model to convert a JSON object to a c# object. */
export interface ICustomPatientIdViewModel {
    /** Gets or sets the display name to use for the custom patient id. */
    displayName?: string | undefined;
    /** Gets or sets the regex to use to validate the custom patient id. */
    regex?: string | undefined;
    /** Gets or sets a bool to determine if the custom patient id is mandatory or not. */
    mandatory?: boolean | undefined;
}

export class TupleOfListOfStaffViewModelAndInteger implements ITupleOfListOfStaffViewModelAndInteger {
    item1!: StaffViewModel[];
    item2!: number;

    constructor(data?: ITupleOfListOfStaffViewModelAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.item1 = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["item1"])) {
                this.item1 = [] as any;
                for (let item of _data["item1"])
                    this.item1!.push(StaffViewModel.fromJS(item));
            }
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): TupleOfListOfStaffViewModelAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfListOfStaffViewModelAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item1)) {
            data["item1"] = [];
            for (let item of this.item1)
                data["item1"].push(item.toJSON());
        }
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITupleOfListOfStaffViewModelAndInteger {
    item1: StaffViewModel[];
    item2: number;
}

export class TupleOfListOfPatientViewModelAndInteger implements ITupleOfListOfPatientViewModelAndInteger {
    item1!: PatientViewModel[];
    item2!: number;

    constructor(data?: ITupleOfListOfPatientViewModelAndInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.item1 = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["item1"])) {
                this.item1 = [] as any;
                for (let item of _data["item1"])
                    this.item1!.push(PatientViewModel.fromJS(item));
            }
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): TupleOfListOfPatientViewModelAndInteger {
        data = typeof data === 'object' ? data : {};
        let result = new TupleOfListOfPatientViewModelAndInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.item1)) {
            data["item1"] = [];
            for (let item of this.item1)
                data["item1"].push(item.toJSON());
        }
        data["item2"] = this.item2;
        return data;
    }
}

export interface ITupleOfListOfPatientViewModelAndInteger {
    item1: PatientViewModel[];
    item2: number;
}

/** An enum defining possible ways to sort results. */
export enum SortType {
    FirstName = 0,
    LastName = 1,
    TcNumber = 2,
    NhsNumber = 3,
    DateOfBirth = 4,
    LastResponse = 5,
}

/** An enum defining possible ways to direct sorted search results. */
export enum SortDirectionType {
    Ascending = 0,
    Decending = 1,
}

/** Defines the ContactDetailsViewModel. */
export class ContactDetailsViewModel implements IContactDetailsViewModel {
    /** Gets or sets the preferred contact type. */
    preferredContact!: PreferredContact;
    /** Gets or sets the contact email. */
    contactEmail?: string | undefined;
    /** Gets or sets the mobile number. */
    mobileNumber?: string | undefined;

    constructor(data?: IContactDetailsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preferredContact = _data["preferredContact"];
            this.contactEmail = _data["contactEmail"];
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): ContactDetailsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDetailsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preferredContact"] = this.preferredContact;
        data["contactEmail"] = this.contactEmail;
        data["mobileNumber"] = this.mobileNumber;
        return data;
    }
}

/** Defines the ContactDetailsViewModel. */
export interface IContactDetailsViewModel {
    /** Gets or sets the preferred contact type. */
    preferredContact: PreferredContact;
    /** Gets or sets the contact email. */
    contactEmail?: string | undefined;
    /** Gets or sets the mobile number. */
    mobileNumber?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}